import {
  JE_AADReadNodeData,
  JE_AADWriteNodeData,
  JE_AAD_ClaimMapping,
  JE_SignInNodeData,
  JsonFlowchartNode,
  JE_SignIn_LinkCollection,
  JE_IdPNodeData,
  JE_UserInputNodeData,
  JE_UserInput_InputField,
  JE_ConditionalNodeData,
  JE_Conditional_ConditionGroup,
  JE_Conditional_Condition,
  JE_UsernamePasswordValidationNodeData,
  JE_TokenIssuerNodeData,
  JE_FlowchartIndex,
  JE_NodeSessionBehavior,
  JE_PasswordComplexityRequirements,
  JE_RESTNodeData,
  parsePasswordComplexity,
  JE_MFANodeData,
  JE_WebAuthnRegistrationNodeData,
  JE_WebAuthnAuthenticationNodeData,
  JE_WebAuthnCredentialExistsNodeData,
  JE_WebAuthnAvailabilityNodeData,
  JE_ConditionalAccessEvaluationNodeData,
  JE_ErrorPageNodeData,
  JE_AuthorizeTokenNodeData,
  JE_UserInfoIssuerNodeData,
  JE_AppInsights_InputField,
  JE_AppInsightsNodeData,
  JE_SendEmailOTPNodeData,
  JE_NodeData,
  JE_OIDCIdPNodeData,
  JE_OIDCScope,
  JE_SAMLIdPNodeData,
  JE_GenericIdPClaimMapping,
  JE_SetClaimsNodeData,
} from './flowchartToGraph';
import { BranchVarMap, ConditionalMap, ConditionalRef } from './jsonFlowchartStat';
import {
  addClaimToDefaultSessionManagementTP,
  addFQClaimsExchangeToJourneyStep,
  addFQOrchestrationStepToJourney,
  createFQClaim,
  createFQClaimXform,
  createFQDisplayControl,
  createFQPredicate,
  createFQPredicateValidation,
  createFQTechnicalProfile,
  generateRelyingPartyXML,
  getOrCreateBooleanComparisonFramework,
  getOrCreateDefaultSessionManagementTP,
  getOrCreateNonemptyStringPredicateValidation,
  getOrCreateNoopSessionManagementTP,
  getOrCreateSocialSessionManagementTP,
  getOrCreateSpecialClaim,
  getOrCreateStringHandlingBufferClaim,
  getOrCreateTokenIssuerTechnicalProfile,
  getOrCreateTrueBooleanConstant,
  getOrCreateUserForeignIdentityCreationXforms,
  getOrCreateUserForeignIdentityReadXform,
  getOrCreateWebAuthnRegistrationContentDefinition,
  getOrCreateWebAuthnAuthenticationContentDefinition,
  JE_FQClaimsExchangeSpec,
  JE_FQClaimSpec,
  JE_FQClaimXformSpec,
  JE_FQJourneyInsightsSpec,
  JE_FQMetadataItemSpec,
  JE_FQPreconditionSpec,
  JE_FQPredicateGroup,
  JE_FQRelyingPartySpec,
  JE_FQTechnicalProfileSpec,
  JE_FQUserJourneyBehaviorsSpec,
  JE_FQUserJourneySpec,
  JE_ParsingContext,
  JE_technicalProfileClaimRef,
  JE_technicalProfileProtocolSpec,
  JE_TechnicalProfileStore,
  JE_UserJourneyStore,
  JE_ValidationTechnicalProfileRef,
  getOrCreateSSCTransform,
  getOrCreateFQContentDefinition,
  fetchDefaultFQContentDefinitionRef,
  JE_FQContentDefinitionSpec,
  JE_PredicateValidationStore,
  setUserJourneyAuthorizationProfile,
  cloneFQClaim,
  JE_claimXformParamSpec,
  JE_claimXformIOClaimSpec,
  JE_FQOrchestrationStepSpec,
  createClaimsProviderSelectionReference,
  JE_CryptographicKeyRef,
  getOrCreateSamlIdPSessionManagementTP,
  addSamlMetadataUrlToJourney,
  getSpecialClaimEffectiveId,
  getOrCreateAADAccessTokenClaim,
  createValidationErrorTP,
} from './jsonFQContext';
import {
  linkInfo,
  getLinkID,
  sanitizeDisplayName,
  isRealResolver,
  isSpecialResolver,
  getNodeSessionProfileId,
  getTenantSettings,
  extractSettingFieldValue,
} from './utils';
import constants from '../constants/jsonXMLConstants';
import settings from '../constants/jsonXMLsettings';
import { faPlugCircleMinus, faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import { getDisplayName } from '@mui/utils';
import { convertOrchestrationStepsToGraph } from '../xmlParsing/convertJsonPolicyToGraph';
import { RelyingPartyReference } from './policyXMLGeneration';
import { SubtitlesOffTwoTone } from '@mui/icons-material';
import { isConstructorDeclaration, nodeModuleNameResolver } from 'typescript';
import { ConnectionLineType } from 'react-flow-renderer';
import { components } from 'react-select';
import { trimEnd } from 'lodash';
import { PersistedClaimComponent, PreConditionsComponent } from '../components/gritComponents';
import { getNodes } from '../store';
import jsonConstants from '../constants/jsonConstants';
import { dataSanitizeException } from '@microsoft/applicationinsights-common';
import jsonXMLConstants from '../constants/jsonXMLConstants';

interface JE_SubflowInfo {
  validationFlow: JE_ValidationTechnicalProfileRef[];
  outputClaimIds: Set<string>;
  flowType: string;
  parentNodeId: string;
}

const validateClaims = (parsingCtx: JE_ParsingContext) => {
  let hasPasswordClaim = false;
  let hasForeignIdClaim = false;
  Object.keys(parsingCtx.claimStore.claims).forEach((claimId: string) => {
    let claim = parsingCtx.claimStore.claims[claimId];
    if (claimId === 'password') {
      if (claim.dataType !== 'string') {
        throw 'Invalid password claim: dataType must be string';
      }
      if (claim.userInputType !== 'Password') {
        throw 'Invalid password claim: userInputType must be Password';
      }
      hasPasswordClaim = true;
    } else if (claimId === 'foreignId') {
      if (claim.dataType != 'userIdentity') {
        throw 'Invalid foreignId claim: dataType must be userIdentity';
      }
    } else if (
      constants.reservedClaimNames.some((rcn) => {
        return rcn.toLowerCase() === claim.id.toLowerCase();
      })
    ) {
      throw `Invalid claim - has reserved ID ${claim.id}`;
    } else if (!constants.customPolicySchema.claims.allowedDataTypes.includes(claim.dataType)) {
      throw `Invalid claim '${claimId}': Unsupported data type '${claim.dataType}'`;
    }
    if (
      claim.userInputType &&
      !constants.customPolicySchema.claims.allowedUserInputs[
        claim.dataType as keyof typeof constants.customPolicySchema.claims.allowedUserInputs
      ].includes(claim.userInputType)
    ) {
      throw `Invalid claim '${claimId}': User input type '${claim.userInputType}' not allowed for data type '${claim.dataType}'`;
    }
  });
  if (!hasPasswordClaim) {
    throw 'Required password claim is not defined';
  }
  if (!hasForeignIdClaim) {
    createFQClaim(parsingCtx.claimStore, {
      id: 'foreignId',
      dataType: 'userIdentity',
      displayName: 'Foreign ID',
    });
    //throw 'Required foreignId claim is not defined';
  }
  getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.newPassword.id);
  getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.reenterPassword.id);
};

export const generateAttributeClaims = (parsingCtx: JE_ParsingContext, attributes: { [id: string]: any }) => {
  Object.keys(attributes).forEach((attrId: string) => {
    if (parsingCtx.claimStore.claimIds.has(attributes[attrId].id.toLowerCase())) {
      // Duplicate explicitly-declared attributes are not allowed due to ambiguous references
      throw 'Duplicate attribute ID in provided attributes';
    }
    let baseClaim: JE_FQClaimSpec = {
      id: attributes[attrId].id,
      displayName: attributes[attrId].displayName,
      dataType: attributes[attrId].dataType,
    };
    if (attributes[attrId].userInputType) {
      baseClaim.userInputType = attributes[attrId].userInputType;
    }
    if (attributes[attrId].restriction === 'Enumeration') {
      baseClaim.restriction = true;
      baseClaim.enumeration = [];
      attributes[attrId].enumeration.forEach((en: { [index: string]: string }) => {
        baseClaim.enumeration!.push({
          text: en['text'],
          value: en['value'],
          selectByDefault: en['selectByDefault'].toString(),
        });
      });
    } else if (attributes[attrId].restriction === 'Pattern') {
      baseClaim.restriction = true;
      baseClaim.pattern = {
        regex: attributes[attrId].pattern.regularExpression,
        helpText: attributes[attrId].pattern.helpText
      };
    }
    if (baseClaim.dataType === 'string' && attributes[attrId].mask && attributes[attrId].mask.type !== 'None') {
      baseClaim.mask = {
        type: attributes[attrId].mask.type === 'Simple' ? 'Simple' : 'Regex',
        value: attributes[attrId].mask.value,
      };
      if (attributes[attrId].mask.type === 'Regex') {
        baseClaim.mask.regex = attributes[attrId].mask.regex;
      }
    }
    let createdClaim = createFQClaim(parsingCtx.claimStore, baseClaim);
    parsingCtx.claimStore.declaredClaimIds.add(createdClaim.id);
  });
  validateClaims(parsingCtx);
  if (Object.keys(attributes).includes('password')) {
    if (attributes['password'].options.length > 0) {
      generatePasswordComplexityValidations(parsingCtx, parsePasswordComplexity(attributes['password']));
    }
  }
};

const generatePasswordComplexityValidations = (
  parsingCtx: JE_ParsingContext,
  complexity: JE_PasswordComplexityRequirements,
) => {
  let lengthRangeId: string | null = null;
  let lowercaseId: string | null = null;
  let uppercaseId: string | null = null;
  let lettersId: string | null = null;
  let numbersId: string | null = null;
  let specialsId: string | null = null;
  if (complexity.letters && (complexity.lowercaseLetters || complexity.uppercaseLetters)) {
    throw 'Invalid password complexity configuration: letters category specified along with lowercase/uppercase letters (overlapping classes)';
  }
  if (complexity.minimumLength !== undefined && complexity.maximumLength !== undefined) {
    lengthRangeId = createFQPredicate(parsingCtx.predicateStore, {
      id: `passwordComplexityLength`,
      method: 'IsLengthRange',
      parameters: [
        { id: 'Minimum', value: complexity.minimumLength.toString() },
        { id: 'Maximum', value: complexity.maximumLength.toString() },
      ],
      errorMessage: `The password must be between ${complexity.minimumLength.toString()} and ${complexity.maximumLength.toString()} characters in length`,
    }).id;
  }
  if (complexity.letters) {
    lettersId = createFQPredicate(parsingCtx.predicateStore, {
      id: `passwordComplexityIncludesLetters`,
      method: 'IncludesCharacters',
      parameters: [{ id: 'CharacterSet', value: 'a-zA-Z' }],
      errorMessage: 'a letter',
    }).id;
  }
  if (complexity.lowercaseLetters) {
    lowercaseId = createFQPredicate(parsingCtx.predicateStore, {
      id: 'passwordComplexityIncludesLowercase',
      method: 'IncludesCharacters',
      parameters: [{ id: 'CharacterSet', value: 'a-z' }],
      errorMessage: 'a lowercase letter',
    }).id;
  }
  if (complexity.uppercaseLetters) {
    uppercaseId = createFQPredicate(parsingCtx.predicateStore, {
      id: 'passwordComplexityIncludesUppercase',
      method: 'IncludesCharacters',
      parameters: [{ id: 'CharacterSet', value: 'A-Z' }],
      errorMessage: 'an uppercase letter',
    }).id;
  }
  if (complexity.numbers) {
    numbersId = createFQPredicate(parsingCtx.predicateStore, {
      id: 'passwordComplexityIncludesNumbers',
      method: 'IncludesCharacters',
      parameters: [{ id: 'CharacterSet', value: '0-9' }],
      errorMessage: 'a number',
    }).id;
  }
  if (complexity.specialCharacters) {
    specialsId = createFQPredicate(parsingCtx.predicateStore, {
      id: 'passwordComplexityIncludesSpecialChars',
      method: 'IncludesCharacters',
      parameters: [{ id: 'CharacterSet', value: '@#$%^&*\\-_+=[]{}|\\\\:\',.?/~"();!' }],
      errorMessage: 'a special character',
    }).id;
  }
  let groups: JE_FQPredicateGroup[] = [];
  if (lengthRangeId) {
    groups.push({
      id: 'passwordComplexityLengthValidation',
      predicateReferences: [lengthRangeId],
    });
  }
  let characterConstraints: string[] = [];
  if (lettersId) {
    characterConstraints.push(lettersId);
  }
  if (lowercaseId) {
    characterConstraints.push(lowercaseId);
  }
  if (uppercaseId) {
    characterConstraints.push(uppercaseId);
  }
  if (numbersId) {
    characterConstraints.push(numbersId);
  }
  if (specialsId) {
    characterConstraints.push(specialsId);
  }
  if (characterConstraints.length > 0) {
    let ccHelpText = '';
    if (complexity.numberIncluded && characterConstraints.length > complexity.numberIncluded) {
      ccHelpText = `The password must have at least ${complexity.numberIncluded} of the following:`;
    } else {
      ccHelpText = 'The password must contain all of the following:';
    }
    let ccGroup: JE_FQPredicateGroup = {
      id: 'passwordComplexityCharsetValidation',
      userHelpText: ccHelpText,
      predicateReferences: characterConstraints,
    };
    if (complexity.numberIncluded) {
      if (complexity.numberIncluded > characterConstraints.length) {
        throw 'Invalid password complexity configuration: more character classes to be matched than classes selected';
      }
      ccGroup.matchAtLeast = complexity.numberIncluded;
    }
    groups.push(ccGroup);
  }
  let hasComplexityConstraints = groups.length > 0;
  let validationId: string = '';
  if (hasComplexityConstraints) {
    validationId = createFQPredicateValidation(parsingCtx.predicateValidationStore, {
      id: 'passwordComplexityValidation',
      groups: groups,
    }).id;
  }
  let npwClaimId = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.newPassword.id);

  let rpwClaimId = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.reenterPassword.id);
  if (hasComplexityConstraints) {
    parsingCtx.claimStore.claims[npwClaimId].predicateValidationReference = validationId;
    parsingCtx.claimStore.claims[rpwClaimId].predicateValidationReference = validationId;
  }
};

const generateSSOSessionProfile = (parsingCtx: JE_ParsingContext, ssoSession: { [index: string]: any }) => {
  let sessionFlag = createFQClaim(parsingCtx.claimStore, {
    id: `SessionFlag__SSO`,
    displayName: `Global SSO Session Flag`,
    dataType: 'boolean',
  });
  let sessionInitDummy = createFQClaim(parsingCtx.claimStore, {
    id: `SessionInitDummy__SSO`,
    displayName: `Global SSO Session Init Dummy`,
    dataType: 'string',
  });
  let sessionTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `SessionManagement__SSO`,
      displayName: `Global SSO Session`,
      protocol: constants.customPolicySchema.protocols.defaultSSO,
      persistedClaims: ssoSession.persistedClaims.map(
        (pClm: { claimId: string; defaultValue: string }) => {
          return { claimId: pClm.claimId, defaultValue: pClm.defaultValue };
        },
      ),
      outputClaims: ssoSession.outputClaims.map((oClm: { claimId: string; defaultValue: string }) => {
        return { claimId: oClm.claimId, defaultValue: oClm.defaultValue };
      }),
    },
    'Session Management',
  );
  sessionTP.persistedClaims!.push({
    claimId: sessionInitDummy.id,
    defaultValue: '',
  });
  sessionTP.outputClaims!.push({
    claimId: sessionFlag.id,
    defaultValue: 'true',
  });
  parsingCtx.sessions['_SSO'] = {
    sessionId: '_SSO',
    sessionProfileId: sessionTP.id,
    sessionFlagClaimId: sessionFlag.id,
    sessionInitClaimId: sessionInitDummy.id,
  };
}

const generateFlagSessionProfile = (
  parsingCtx: JE_ParsingContext,
  sessionId: string
) => {
  let sessionFlag = createFQClaim(parsingCtx.claimStore, {
    id: `SessionFlag_${sessionId}`,
    displayName: `Session Flag ${sessionId}`,
    dataType: 'boolean',
  });
  let sessionInitDummy = createFQClaim(parsingCtx.claimStore, {
    id: `SessionInitDummy_${sessionId}`,
    displayName: `Session Init Dummy ${sessionId}`,
    dataType: 'string',
  });
  let sessionTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `SessionManagement_${sessionId}`,
      displayName: `${sessionId} Session Management`,
      protocol: constants.customPolicySchema.protocols.defaultSSO,
      persistedClaims: [{
        claimId: sessionInitDummy.id,
        defaultValue: ''
      }],
      outputClaims: [{
        claimId: sessionFlag.id,
        defaultValue: 'true'
      }]
    },
    'Session Management',
  );
  parsingCtx.sessions[sessionId] = {
    sessionId: sessionId,
    sessionProfileId: sessionTP.id,
    sessionFlagClaimId: sessionFlag.id,
    sessionInitClaimId: sessionInitDummy.id,
  };
}

export const generateGeneralSessionManagementProfiles = (
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  ssoSession: { [index: string]: any },
) => {
  let usingSSOSession = Object.keys(nodes).some((nodeId: string) => {
    return nodes[nodeId].kind === jsonXMLConstants.editorComponentTypes.sessionExists;
  });
  if (usingSSOSession) {
    generateSSOSessionProfile(parsingCtx, ssoSession);
  }
  Object.keys(ssoSession.sessionFlags).forEach((sessionId) => {
    generateFlagSessionProfile(parsingCtx, sessionId);
  });
};

const generateBooleanComparisonBaseTransformIds = (
  inputClaimIdA: string,
  inputClaimIdB: string,
  parsingCtx: JE_ParsingContext,
) => {
  let booleanComparisonFramework = getOrCreateBooleanComparisonFramework(parsingCtx);
  return [
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `booleanComparisonOrStage${parsingCtx.claimTransformStore.claimXformIds.size}`,
      method: 'OrClaims',
      inputClaims: [
        { claimId: inputClaimIdA, xformClaimType: 'inputClaim1' },
        { claimId: inputClaimIdB, xformClaimType: 'inputClaim2' },
      ],
      outputClaims: [{ claimId: booleanComparisonFramework.bufferClaims.orBuf, xformClaimType: 'outputClaim' }],
    }).id,
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `booleanComparisonAndStage${parsingCtx.claimTransformStore.claimXformIds.size}`,
      method: 'AndClaims',
      inputClaims: [
        { claimId: inputClaimIdA, xformClaimType: 'inputClaim1' },
        { claimId: inputClaimIdB, xformClaimType: 'inputClaim2' },
      ],
      outputClaims: [{ claimId: booleanComparisonFramework.bufferClaims.andBuf, xformClaimType: 'outputClaim' }],
    }).id,
    booleanComparisonFramework.xforms.nandXform,
  ];
};

const generateBooleanNotEqualsComparisonTransforms = (
  inputClaimIdA: string,
  inputClaimIdB: string,
  outputClaimId: string,
  parsingCtx: JE_ParsingContext,
) => {
  let booleanComparisonFramework = getOrCreateBooleanComparisonFramework(parsingCtx);
  let xformIds = generateBooleanComparisonBaseTransformIds(inputClaimIdA, inputClaimIdB, parsingCtx);
  xformIds.push(
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `booleanComparisonXorStage${parsingCtx.claimTransformStore.claimXformIds.size}`,
      method: 'AndClaims',
      inputClaims: [
        { claimId: booleanComparisonFramework.bufferClaims.orBuf, xformClaimType: 'inputClaim1' },
        { claimId: booleanComparisonFramework.bufferClaims.nandBuf, xformClaimType: 'inputClaim2' },
      ],
      outputClaims: [{ claimId: outputClaimId, xformClaimType: 'outputClaim' }],
    }).id,
  );
  return xformIds;
};

const generateBooleanEqualsComparisonTransforms = (
  inputClaimIdA: string,
  inputClaimIdB: string,
  outputClaimId: string,
  parsingCtx: JE_ParsingContext,
) => {
  let booleanComparisonFramework = getOrCreateBooleanComparisonFramework(parsingCtx);
  let xformIds = generateBooleanComparisonBaseTransformIds(inputClaimIdA, inputClaimIdB, parsingCtx);
  xformIds.push(booleanComparisonFramework.xforms.xorXform);
  xformIds.push(
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `booleanComparisonXnorStage${parsingCtx.claimTransformStore.claimXformIds.size}`,
      method: 'NotClaims',
      inputClaims: [{ claimId: booleanComparisonFramework.bufferClaims.xorBuf, xformClaimType: 'inputClaim' }],
      outputClaims: [{ claimId: outputClaimId, xformClaimType: 'outputClaim' }],
    }).id,
  );
  return xformIds;
};

const generateBranchJoinOrchestration = (
  node: JsonFlowchartNode,
  parsingCtx: JE_ParsingContext,
  journeyId: string,
  branchVarMap: BranchVarMap,
  submitActionFlow?: JE_SubflowInfo,
) => {
  if (branchVarMap.hasOwnProperty(node.nodeId) && branchVarMap[node.nodeId].incidentBranchVars.length > 1) {
    let xformIds: string[] = [];
    let accumulatorClaimsIds: string[] = [];
    for (let i = 0; i < branchVarMap[node.nodeId].incidentBranchVars.length - 2; i += 1) {
      accumulatorClaimsIds.push(
        createFQClaim(parsingCtx.claimStore, {
          id: `branchJoinBooleanAccumulator${parsingCtx.claimStore.claimIds.size}`,
          dataType: 'boolean',
          displayName: `branchJoinBooleanAccumulator${parsingCtx.claimStore.claimIds.size}`,
        }).id,
      );
    }
    accumulatorClaimsIds.push(branchVarMap[node.nodeId].branchVarId!);
    let lastOrVar: string | null = null;
    let bIndex = 0;
    branchVarMap[node.nodeId].incidentBranchVars.forEach((branchVarId: string) => {
      if (lastOrVar) {
        let newXformId = createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `branchJoinFinalBooleanOr${parsingCtx.claimTransformStore.claimXformIds.size}`,
          method: 'OrClaims',
          inputClaims: [
            { claimId: lastOrVar, xformClaimType: 'inputClaim1' },
            { claimId: branchVarId, xformClaimType: 'inputClaim2' },
          ],
          outputClaims: [{ claimId: accumulatorClaimsIds[bIndex], xformClaimType: 'outputClaim' }],
        }).id;
        xformIds.push(newXformId);
        lastOrVar = accumulatorClaimsIds[bIndex];
        bIndex += 1;
      } else {
        lastOrVar = branchVarId;
      }
    });
    let outputClaims: JE_technicalProfileClaimRef[] = branchVarMap[node.nodeId].incidentBranchVars.map(
      (branchVarId: string) => {
        return { claimId: branchVarId };
      },
    );
    accumulatorClaimsIds.forEach((acId: string) => {
      outputClaims.push({ claimId: acId, defaultValue: 'false' });
    });

    let btp = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `branchJoinProfile${parsingCtx.technicalProfileStore.tpIds.size}`,
        displayName: `Branch Join ${parsingCtx.technicalProfileStore.tpIds.size}`,
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        inputClaims: branchVarMap[node.nodeId].incidentBranchVars.map((branchVarId: string) => {
          return { claimId: branchVarId };
        }),
        outputClaims: outputClaims,
        outputClaimXformIds: xformIds,
        useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id,
      },
      'Conditional Handling',
    );
    if (settings.outputExtraBranchVarInfo) {
      parsingCtx.branchVarMetadata[branchVarMap[node.nodeId].branchVarId!].setInProfiles.add(btp.id);
    }
    branchVarMap[node.nodeId].incidentBranchVars.forEach((bvid: string) => {
      let precondition: JE_FQPreconditionSpec[] = [
        {
          type: 'ClaimEquals',
          executeActionsIf: false,
          values: [bvid, 'True'],
          action: 'SkipThisOrchestrationStep',
        },
      ];
      // Need to add the new branch var to live claims for following nodes (sort of - by adding it to all the parents).
      node.parents.forEach((parentId) => {
        if (parsingCtx.liveClaims.hasOwnProperty(parentId)) {
          parsingCtx.liveClaims[parentId].add(branchVarMap[node.nodeId].branchVarId!);
        }
      });
      addFQOrchestrationStepOrValidationProfileRef(
        parsingCtx,
        null,
        null,
        btp.id,
        `branchJoinClaimsExchange${parsingCtx.userJourneyStore.claimsExchangeIds.size}`,
        journeyId,
        branchVarMap,
        precondition,
        submitActionFlow,
        outputClaims.map((outClaim: JE_technicalProfileClaimRef) => {
          return outClaim.claimId!;
        }),
      );
    });
  }
};

const generatePreconditions = (node: JsonFlowchartNode, branchVarMap: BranchVarMap, appliedToVTP: boolean) => {
  let preconditions: JE_FQPreconditionSpec[] = [];
  if (branchVarMap.hasOwnProperty(node.nodeId) && branchVarMap[node.nodeId].branchVarId) {
    preconditions.push({
      type: 'ClaimEquals',
      executeActionsIf: false,
      values: [branchVarMap[node.nodeId].branchVarId!, 'True'],
      action: appliedToVTP ? 'SkipThisValidationTechnicalProfile' : 'SkipThisOrchestrationStep',
    });
  }
  return preconditions;
};

const addClaimIdToLiveClaimSet = (parsingCtx: JE_ParsingContext, liveClaimSet: Set<string>, claimId: string) => {
  if (parsingCtx.claimStore.claims[claimId].userInputType !== 'Password') {
    liveClaimSet.add(claimId);
  }
};

const updateLiveClaims = (
  parsingCtx: JE_ParsingContext,
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  technicalProfileId: string | null,
  subflow?: JE_SubflowInfo,
) => {
  let nodeLiveClaims: Set<string> = parsingCtx.liveClaims[node.nodeId];
  if (!nodeLiveClaims) {
    nodeLiveClaims = new Set<string>();
    if (node.parents.length === 0 && subflow) {
      // Initializing the live claims inside a subflow depends on the type of subflow
      if (subflow.flowType === 'formSubmitAction') {
        nodes[subflow.parentNodeId].parents.forEach((gpId) => {
          if (parsingCtx.liveClaims.hasOwnProperty(gpId)) {
            parsingCtx.liveClaims[gpId].forEach((claimId) => {
              addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, claimId);
            });
          }
        });
        if (nodes[subflow.parentNodeId].kind === constants.componentTypes.signIn) {
          let parentData = nodes[subflow.parentNodeId].data as JE_SignInNodeData;
          addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, parentData.userNameClaim);
        } else if (nodes[subflow.parentNodeId].kind === constants.componentTypes.userInput) {
          let parentData = nodes[subflow.parentNodeId].data as JE_UserInputNodeData;
          parentData.inputFields.forEach((ifield) => {
            addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, ifield.claimId);
            if (ifield.prefilled === 'claim') {
              addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, ifield.prefill_source);
            }
          });
        }
      } else if (subflow.flowType === 'emailVerificationSendAction') {
        let parentData = nodes[subflow.parentNodeId].data as JE_UserInputNodeData;
        if (!parentData.emailValidation) {
          throw 'Parent node of email verification send action specifies no email claim (should not happen)';
        }
        addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, parentData.emailValidation.emailClaimId);
        addClaimIdToLiveClaimSet(
          parsingCtx,
          nodeLiveClaims,
          getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.verificationCode.id),
        );
      }
    } else {
      node.parents.forEach((parentId) => {
        parsingCtx.liveClaims[parentId]?.forEach((claimId) => {
          addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, claimId);
        });
      });
    }
    parsingCtx.liveClaims[node.nodeId] = nodeLiveClaims;
  }
  if (technicalProfileId) {
    let newTP: JE_FQTechnicalProfileSpec =
      parsingCtx.technicalProfileStore.claimsProviders[
        parsingCtx.technicalProfileStore.providerNameIndex[technicalProfileId]
      ].technicalProfiles[technicalProfileId];
    newTP.inputClaimXformIds?.forEach((inpClaimXform) => {
      parsingCtx.claimTransformStore.claimXforms[inpClaimXform].inputClaims?.forEach((ixcf) => {
        addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, ixcf.claimId);
      });
      parsingCtx.claimTransformStore.claimXforms[inpClaimXform].outputClaims?.forEach((oxcf) => {
        addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, oxcf.claimId);
      });
    });
    newTP.inputClaims?.forEach((inpClaim) => {
      if (inpClaim.claimId) {
        addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, inpClaim.claimId);
      }
    });
    /*newTP.persistedClaims?.forEach((pClaim) => {
      if (pClaim.claimId) {
        addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, pClaim.claimId);
      }
    });*/
    newTP.outputClaims?.forEach((outClaim) => {
      if (outClaim.claimId) {
        addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, outClaim.claimId);
      }
    });
    newTP.outputClaimXformIds?.forEach((outClaimXform) => {
      parsingCtx.claimTransformStore.claimXforms[outClaimXform].inputClaims?.forEach((ixcf) => {
        addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, ixcf.claimId);
      });
      parsingCtx.claimTransformStore.claimXforms[outClaimXform].outputClaims?.forEach((oxcf) => {
        addClaimIdToLiveClaimSet(parsingCtx, nodeLiveClaims, oxcf.claimId);
      });
    });
  }
};

const generateAdvanceNeededClaimsInitializationStep = (
  parsingCtx: JE_ParsingContext,
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  advanceNeededClaims: Set<string>,
  journeyId: string,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  subflow?: JE_SubflowInfo,
) => {
  if (advanceNeededClaims.size > 0) {
    let advanceClaimInputRefs: JE_technicalProfileClaimRef[] = [];
    let advanceClaimOutputRefs: JE_technicalProfileClaimRef[] = [];
    advanceNeededClaims.forEach((claimId) => {
      advanceClaimInputRefs.push({
        claimId: claimId,
      });
      advanceClaimOutputRefs.push({
        claimId: claimId,
        defaultValue: getClaimTypeDefault(claimId, parsingCtx),
      });
    });
    let advancePrepTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `${node.sanitizedDisplayName}_InitAdvanceClaims`,
        displayName: node.displayName,
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        inputClaims: advanceClaimInputRefs,
        outputClaims: advanceClaimOutputRefs,
        useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
      },
      'Claims Preparation',
    );
    addFQOrchestrationStepOrValidationProfileRef(
      parsingCtx,
      node,
      nodes,
      advancePrepTP.id,
      `${node.sanitizedDisplayName}_AdvancePrepClaimsExchange`,
      journeyId,
      branchVarMap,
      preconditions?.slice(),
      subflow,
    );
  }
};

const addNewFQClaimsExchangeOrchestrationStep = (
  parsingCtx: JE_ParsingContext,
  node: JsonFlowchartNode | null,
  nodes: { [nodeId: string]: JsonFlowchartNode } | null,
  journeyId: string,
  technicalProfileId: string,
  newClaimsExchangeId: string,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  if (node && nodes) {
    updateLiveClaims(parsingCtx, node, nodes, technicalProfileId);
  }
  if (
    node?.isLink &&
    nodes &&
    node.parents?.length === 1 && // Enforced rule - nodes that are children of a claims provider selection can have only one parent
    parsingCtx.claimsProviderSelectionMap.hasOwnProperty(node.parents[0]) &&
    !parsingCtx.claimsProviderSelectionMap[node.parents[0]].addedNodes.has(node.nodeId)
  ) {
    let addedTP =
      parsingCtx.technicalProfileStore.claimsProviders[
        parsingCtx.technicalProfileStore.providerNameIndex[technicalProfileId]
      ].technicalProfiles[technicalProfileId];
    let headTPId = technicalProfileId;
    if (branchVarMap.hasOwnProperty(node.nodeId) && branchVarMap[node.nodeId].branchVarId) {
      // If we need to set a branch var, children of a claims provider selection actually have to do it themselves.
      if (
        constants.canTakeArbitraryOutputClaims.some((protocolId) => {
          return (
            constants.customPolicySchema.protocols[
            protocolId as keyof typeof constants.customPolicySchema.protocols
            ] === addedTP.protocol
          );
        })
      ) {
        if (!addedTP.outputClaims) {
          addedTP.outputClaims = [];
        }
        addedTP.outputClaims.push({
          claimId: branchVarMap[node.nodeId].branchVarId,
          defaultValue: 'true',
          alwaysUseDefaultValue: true,
        });
        if (settings.outputExtraBranchVarInfo) {
          parsingCtx.branchVarMetadata[branchVarMap[node.nodeId].branchVarId!].setInProfiles.add(addedTP.id);
        }
      } else {
        let precursorTP = createFQTechnicalProfile(
          parsingCtx.technicalProfileStore,
          {
            id: `${node.sanitizedDisplayName}_ClaimsProviderSelector`,
            displayName: node.displayName,
            protocol: constants.customPolicySchema.protocols.claimsTransformation,
            outputClaims: [
              {
                claimId: branchVarMap[node.nodeId].branchVarId,
                defaultValue: 'true',
                alwaysUseDefaultValue: true,
              },
            ],
            useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id,
          },
          'Claims Provider Selection Branch Handling',
        );
        headTPId = precursorTP.id;
        if (settings.outputExtraBranchVarInfo) {
          parsingCtx.branchVarMetadata[branchVarMap[node.nodeId].branchVarId!].setInProfiles.add(precursorTP.id);
        }
      }
    }
    let claimsProviderSelectionEntry = parsingCtx.claimsProviderSelectionMap[node.parents[0]];
    claimsProviderSelectionEntry.addedNodes.add(node.nodeId);
    let claimsExchangeRef = addFQClaimsExchangeToJourneyStep(
      parsingCtx.userJourneyStore,
      {
        id: `${newClaimsExchangeId}_Precursor`,
        technicalProfileReferenceId: headTPId,
      },
      claimsProviderSelectionEntry.claimsExchangeLandingStep,
    );
    claimsProviderSelectionEntry.claimsProviderSelectionStep.claimsProviderSelections!.push({
      targetClaimsExchangeId: claimsExchangeRef.id,
    });
    if (headTPId !== technicalProfileId) {
      // A new TP was created to be the landing point, so the original can be an orch step.
      addFQOrchestrationStepToJourney(
        parsingCtx.userJourneyStore,
        {
          order: 1,
          type: 'ClaimsExchange',
          claimsExchanges: [{ id: newClaimsExchangeId, technicalProfileReferenceId: technicalProfileId }],
          preconditions: preconditions?.slice(),
        },
        journeyId,
      );
    }
  } else {
    addFQOrchestrationStepToJourney(
      parsingCtx.userJourneyStore,
      {
        order: 1,
        type: 'ClaimsExchange',
        claimsExchanges: [{ id: newClaimsExchangeId, technicalProfileReferenceId: technicalProfileId }],
        preconditions: preconditions?.slice(),
      },
      journeyId,
    );
  }
};

// Generates either an OrchestrationStep added to the user journey ID if a validationFlow list is not provided,
// or a ValidationTechnicalProfile reference added to the validationFlow list if one is provided.
export const addFQOrchestrationStepOrValidationProfileRef = (
  parsingCtx: JE_ParsingContext,
  node: JsonFlowchartNode | null,
  nodes: { [nodeId: string]: JsonFlowchartNode } | null,
  technicalProfileId: string,
  newClaimsExchangeId: string,
  journeyId: string,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  submitActionFlow?: JE_SubflowInfo,
  transferOutputClaims?: string[],
) => {
  if (submitActionFlow) {
    if (node && nodes) {
      updateLiveClaims(parsingCtx, node, nodes, technicalProfileId, submitActionFlow);
    }
    submitActionFlow.validationFlow.push({
      profileId: technicalProfileId,
      preconditions: preconditions?.slice(),
    });
    if (transferOutputClaims) {
      transferOutputClaims.forEach((claimId: string) => {
        if (parsingCtx.claimStore.claims[claimId].userInputType !== 'Password') {
          // Password claim values can't be propagated out of a node anyways, but as that is "magic" behavior from ADB2C let's
          // avoid adding them to output claims when we don't need to.
          submitActionFlow.outputClaimIds.add(claimId);
        }
      });
    }
  } else {
    addNewFQClaimsExchangeOrchestrationStep(
      parsingCtx,
      node,
      nodes,
      journeyId,
      technicalProfileId,
      newClaimsExchangeId,
      branchVarMap,
      preconditions?.slice(),
    );
  }
};

const createStrCopyFormatClaimXform = (parsingCtx: JE_ParsingContext, inputClaimId: string, outputClaimId: string) => {
  return createFQClaimXform(parsingCtx.claimTransformStore, {
    id: `stringCleanCopy${parsingCtx.claimTransformStore.claimXformIds.size}`,
    method: 'FormatStringClaim',
    inputClaims: [{ claimId: inputClaimId, xformClaimType: 'inputClaim' }],
    inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}' }],
    outputClaims: [{ claimId: outputClaimId, xformClaimType: 'outputClaim' }],
  }).id;
};

const createIdPSessionHandlerStep = (
  parsingCtx: JE_ParsingContext,
  idpNode: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  journeyId: string,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  if (idpNode.sessionBehavior && idpNode.sessionBehavior.sessionAction === constants.sessionActions.globalSSO) {
    let nodeData = idpNode.data as JE_IdPNodeData;
    let sessionTPId = getNodeSessionProfileId(idpNode, parsingCtx);
    let sessionTP =
      parsingCtx.technicalProfileStore.claimsProviders[parsingCtx.technicalProfileStore.providerNameIndex[sessionTPId]]
        .technicalProfiles[sessionTPId];
    let iClaims: JE_technicalProfileClaimRef[] = nodeData.partnerClaimMappings
      .filter((pClm) => {
        return sessionTP.persistedClaims?.some((perClm) => {
          return perClm.claimId === pClm.claimId;
        });
      })
      .map((pClm) => {
        return { claimId: pClm.claimId };
      });
    if (
      sessionTP.persistedClaims?.some((perClm) => {
        return perClm.claimId === 'foreignId';
      })
    ) {
      iClaims.push({ claimId: 'foreignId' });
    }
    if (iClaims.length > 0) {
      let sessionHandlerTP = createFQTechnicalProfile(
        parsingCtx.technicalProfileStore,
        {
          id: `${idpNode.sanitizedDisplayName}_SessionWriter`,
          displayName: idpNode.displayName,
          protocol: constants.customPolicySchema.protocols.claimsTransformation,
          inputClaims: iClaims,
          outputClaims: iClaims,
          useTechnicalProfileForSessionManagement: sessionTPId,
        },
        'IdP Session Handling',
      );
      addFQOrchestrationStepOrValidationProfileRef(
        parsingCtx,
        idpNode,
        nodes,
        sessionHandlerTP.id,
        `${idpNode.sanitizedDisplayName}_SessionWriteClaimsExchange`,
        journeyId,
        branchVarMap,
        preconditions?.slice(),
      );
    }
  }
};

const createFacebookAuthProfile = (
  parsingCtx: JE_ParsingContext,
  idpNode: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  apid: string,
) => {
  let nodeData = idpNode.data as JE_IdPNodeData;
  let identityXforms = getOrCreateUserForeignIdentityCreationXforms(parsingCtx);
  let outputClaims: JE_technicalProfileClaimRef[] = [
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.issuerUserId.id),
      partnerClaimType: 'id',
    },
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.identityProvider.id),
      defaultValue: 'facebook.com',
      alwaysUseDefaultValue: true,
    },
  ];
  nodeData.partnerClaimMappings.forEach((pcm) => {
    if (pcm.partnerClaimType && (!pcm.defaultValue)) {
      outputClaims.push({
        claimId: pcm.claimId,
        partnerClaimType: pcm.partnerClaimType,
      });
    } else {
      outputClaims.push({
        claimId: pcm.claimId,
        defaultValue: pcm.defaultValue,
        alwaysUseDefaultValue: pcm.alwaysUseDefaultValue
      });
    }
  });
  outputClaims.push({
    claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.isFederatedLogin.id),
    defaultValue: 'true',
    alwaysUseDefaultValue: true,
  });
  let fbTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `Facebook-auth`,
      displayName: 'Facebook',
      protocol: constants.customPolicySchema.protocols.OAuth2,
      metadata: [
        { key: 'ProviderName', value: 'facebook' },
        { key: 'authorization_endpoint', value: 'https://www.facebook.com/dialog/oauth' },
        { key: 'AccessTokenEndpoint', value: 'https://graph.facebook.com/oauth/access_token' },
        { key: 'HttpBinding', value: 'GET' },
        { key: 'UsePolicyIndirectUri', value: '0' },
        { key: 'AccessTokenResponseFormat', value: 'json' },
      ],
      cryptographicKeys: [{ id: 'client_secret', storageReferenceId: nodeData.clientSecretRef }],
      outputClaims: outputClaims,
      outputClaimXformIds: identityXforms,
    },
    linkInfo[apid].providerDisplayName,
  );
  if (idpNode.sessionBehavior && idpNode.sessionBehavior.sessionAction !== 'always') {
    fbTP.useTechnicalProfileForSessionManagement = getOrCreateSocialSessionManagementTP(parsingCtx).id;
  } else {
    fbTP.useTechnicalProfileForSessionManagement = getOrCreateNoopSessionManagementTP(parsingCtx).id;
  }
  return fbTP;
};

const generateFacebookNodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let fbTP = createFacebookAuthProfile(parsingCtx, node, nodes, 'facebook');
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    fbTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
  createIdPSessionHandlerStep(parsingCtx, node, nodes, journeyId, branchVarMap, preconditions);
};

const createGoogleAuthProfile = (
  parsingCtx: JE_ParsingContext,
  idpNode: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  apid: string,
) => {
  let nodeData = idpNode.data as JE_IdPNodeData;
  let identityXforms = getOrCreateUserForeignIdentityCreationXforms(parsingCtx);
  let outputClaims: JE_technicalProfileClaimRef[] = [
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.issuerUserId.id),
      partnerClaimType: 'id',
    },
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.identityProvider.id),
      defaultValue: 'google.com',
      alwaysUseDefaultValue: true,
    },
  ];
  nodeData.partnerClaimMappings.forEach((pcm) => {
    if (pcm.partnerClaimType && (!pcm.defaultValue)) {
      outputClaims.push({
        claimId: pcm.claimId,
        partnerClaimType: pcm.partnerClaimType,
      });
    } else {
      outputClaims.push({
        claimId: pcm.claimId,
        defaultValue: pcm.defaultValue,
        alwaysUseDefaultValue: pcm.alwaysUseDefaultValue
      });
    }
  });
  outputClaims.push({
    claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.isFederatedLogin.id),
    defaultValue: 'true',
    alwaysUseDefaultValue: true,
  });
  let gTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${apid}-auth`,
      displayName: 'Google',
      protocol: constants.customPolicySchema.protocols.OAuth2,
      metadata: [
        { key: 'ProviderName', value: 'google' },
        { key: 'authorization_endpoint', value: 'https://accounts.google.com/o/oauth2/auth' },
        { key: 'AccessTokenEndpoint', value: 'https://accounts.google.com/o/oauth2/token' },
        { key: 'ClaimsEndpoint', value: 'https://www.googleapis.com/oauth2/v1/userinfo' },
        { key: 'scope', value: 'email profile' },
        { key: 'HttpBinding', value: 'POST' },
        { key: 'UsePolicyInRedirectUri', value: 'false' },
        { key: 'client_id', value: nodeData.clientId },
      ],
      cryptographicKeys: [{ id: 'client_secret', storageReferenceId: nodeData.clientSecretRef }],
      outputClaims: outputClaims,
      outputClaimXformIds: identityXforms,
    },
    linkInfo[apid].providerDisplayName,
  );
  if (idpNode.sessionBehavior && idpNode.sessionBehavior.sessionAction !== constants.sessionActions.always) {
    gTP.useTechnicalProfileForSessionManagement = getOrCreateSocialSessionManagementTP(parsingCtx).id;
  } else {
    gTP.useTechnicalProfileForSessionManagement = getOrCreateNoopSessionManagementTP(parsingCtx).id;
  }
  return gTP;
};

const generateGoogleNodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let gTP = createGoogleAuthProfile(parsingCtx, node, nodes, 'google');
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    gTP.id,
    `googleAuthClaimsExchange${parsingCtx.userJourneyStore.claimsExchangeIds.size}`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
  createIdPSessionHandlerStep(parsingCtx, node, nodes, journeyId, branchVarMap, preconditions);
};

const generateSignInNodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  subflowTopologicalOrders: { [index: string]: string[] },
  subflowBranchVarMaps: { [index: string]: BranchVarMap },
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_SignInNodeData;
  // Do not use the default metadata settings for forgot password or signup links - these use link nodes instead
  let settingsMetadata: JE_FQMetadataItemSpec[] = [
    {
      key: 'setting.forgotPasswordLinkLocation',
      value: 'None',
    },
    {
      key: 'setting.showSignupLink',
      value: 'false',
    },
    {
      key: 'IncludeClaimResolvingInClaimsHandling',
      value: 'true',
    },
  ];
  if (nodeData.contentDefinitionUrl) {
    let draftCD: JE_FQContentDefinitionSpec = {
      id: `signUpSignInContentDef${parsingCtx.contentDefinitionStore.cdIds.size}`,
      loadUri: nodeData.contentDefinitionUrl,
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Sign-in Sign-up Page' }],
    };
    if (settings.includeDefaultLocalization) {
      draftCD.localizedResourcesReferences = {
        mergeBehavior: 'Prepend',
        references: [{ language: 'en', referenceId: 'api.localaccountsignin.en' }],
      };
    }
    settingsMetadata.push({
      key: 'ContentDefinitionReferenceId',
      value: getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.localaccountsignin').id,
    });
  } else {
    settingsMetadata.push({
      key: 'ContentDefinitionReferenceId',
      value: fetchDefaultFQContentDefinitionRef(parsingCtx, 'api.localaccountsignin'),
    });
  }
  if (nodeData.formSubmitAction && nodeData.validationErrorMessage && subflowTopologicalOrders[nodeData.formSubmitAction].some((nId: string) => { return nodes[nId].kind === constants.componentTypes.validationError })) {
    settingsMetadata.push({ key: 'UserMessageIfClaimsTransformationBooleanValueIsNotEqual', value: nodeData.validationErrorMessage });
  }
  if (nodeData.keepMeSignedIn) {
    settingsMetadata.push({
      key: 'setting.enableRememberMe',
      value: 'True',
    });
  }
  if (nodeData.userNameType === 'email') {
    settingsMetadata.push({
      key: 'setting.operatingMode',
      value: 'Email',
    });
  } else if (nodeData.userNameType === 'shortNames' || nodeData.userNameType === 'mixed') {
    settingsMetadata.push({
      key: 'setting.operatingMode',
      value: 'Username',
    });
  }

  let localAccountNode = node.children.find((childId: string) => {
    return getLinkID(nodes[childId]) === 'localAccount';
  });
  let localAccountSignInTP: JE_FQTechnicalProfileSpec | null = null;
  if (localAccountNode) {
    // Submit actions for the signup node itself can only apply if local account signin is enabled.
    let submitAction: JE_SubflowInfo = {
      validationFlow: [],
      outputClaimIds: new Set(),
      flowType: 'formSubmitAction',
      parentNodeId: node.nodeId,
    };
    if (
      nodeData.formSubmitAction &&
      subflowTopologicalOrders[nodeData.formSubmitAction] &&
      subflowTopologicalOrders[nodeData.formSubmitAction].length > 0
    ) {
      parseConditionalDAG(
        parsingCtx,
        journeyId,
        nodes,
        subflowTopologicalOrders[nodeData.formSubmitAction],
        subflowBranchVarMaps[nodeData.formSubmitAction],
        {},
        {},
        submitAction,
      );
    }
    let outputClaims: JE_technicalProfileClaimRef[] = [];
    submitAction.outputClaimIds.forEach((sClaimId: string) => {
      outputClaims.push({ claimId: sClaimId });
    });
    if (!submitAction.outputClaimIds.has(nodeData.userNameClaim)) {
      outputClaims.push({ claimId: nodeData.userNameClaim });
    }
    let draftLocalSignInTp: JE_FQTechnicalProfileSpec = {
      id: 'localAccountSignInProfile',
      displayName: 'Local Account Signin',
      protocol: constants.customPolicySchema.protocols.selfAsserted,
      metadata: settingsMetadata,
      includeInSso: false,
      inputClaims: [{ claimId: nodeData.userNameClaim, defaultValue: '{OIDC:LoginHint}', alwaysUseDefaultValue: true }],
      displayClaims: [{ claimId: nodeData.userNameClaim, required: true }],
      validationTechnicalProfiles: submitAction.validationFlow,
      outputClaims: outputClaims,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    };
    if (nodeData.collectPassword) {
      draftLocalSignInTp.displayClaims?.push({ claimId: 'password', required: true });
    }
    if (branchVarMap.hasOwnProperty(localAccountNode) && branchVarMap[localAccountNode].branchVarId) {
      draftLocalSignInTp.outputClaims?.push({
        claimId: branchVarMap[localAccountNode].branchVarId!,
        defaultValue: 'true',
        alwaysUseDefaultValue: true,
      });
    }
    localAccountSignInTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      draftLocalSignInTp,
      linkInfo['localAccount'].providerDisplayName,
    );
    if (branchVarMap.hasOwnProperty(localAccountNode) && branchVarMap[localAccountNode].branchVarId && settings.outputExtraBranchVarInfo) {
      parsingCtx.branchVarMetadata[branchVarMap[localAccountNode].branchVarId!].setInProfiles.add(localAccountSignInTP.id);
    }
  }

  let signInContentDefinitionRefId = 'api.signuporsignin';

  if (nodeData.contentDefinitionUrl) {
    let draftCD: JE_FQContentDefinitionSpec = {
      id: `signUpSignInContentDef${parsingCtx.contentDefinitionStore.cdIds.size}`,
      loadUri: nodeData.contentDefinitionUrl,
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:unifiedssp:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Sign-in Sign-up Page' }],
    };
    if (settings.includeDefaultLocalization) {
      draftCD.localizedResourcesReferences = {
        mergeBehavior: 'Prepend',
        references: [{ language: 'en', referenceId: 'api.signuporsignin.en' }],
      };
    }
    signInContentDefinitionRefId = getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.signuporsignin').id;
  } else {
    signInContentDefinitionRefId = fetchDefaultFQContentDefinitionRef(parsingCtx, 'api.signuporsignin');
  }

  let signInOrchStep = addFQOrchestrationStepToJourney(
    parsingCtx.userJourneyStore,
    {
      order: 1,
      type: 'CombinedSignInAndSignUp',
      contentDefinitionReferenceId: signInContentDefinitionRefId,
      claimsProviderSelections: [],
      preconditions: preconditions,
      claimsExchanges: [],
    },
    journeyId,
  );

  // Add an entry for the signin node in live claims. It supplies no TP ID so only inherits claims from its parents.
  updateLiveClaims(parsingCtx, node, nodes, null);

  if (localAccountSignInTP) {
    let cexSpec = addFQClaimsExchangeToJourneyStep(
      parsingCtx.userJourneyStore,
      {
        id: 'localAccountSignInClaimsExchange',
        technicalProfileReferenceId: localAccountSignInTP.id,
      },
      signInOrchStep,
    );
    updateLiveClaims(parsingCtx, nodes[localAccountNode!], nodes, localAccountSignInTP.id);
    signInOrchStep.claimsProviderSelections?.push({ validationClaimsExchangeId: cexSpec.id });
  }

  // If any links are defined, add a ClaimsExchange orchestration step to land on from claims provider selection.
  // Generated link technical profiles will also set boolean conditional flags for auth method in their output claims.

  if (nodeData.generateLandingCEX) {
    // Create a landing-point claims exchange.
    let idpSignInOrchStep = addFQOrchestrationStepToJourney(
      parsingCtx.userJourneyStore,
      {
        order: 2,
        type: 'ClaimsExchange',
        preconditions: preconditions?.slice(),
        claimsExchanges: [],
      },
      journeyId,
    );
    if (localAccountNode) {
      // If we have a local account node, we skip the CEX landing page if we take the local account signin branch.
      if (branchVarMap.hasOwnProperty(localAccountNode) && branchVarMap[localAccountNode].branchVarId) {
        idpSignInOrchStep.preconditions!.push({
          type: 'ClaimEquals',
          executeActionsIf: true,
          values: [branchVarMap[localAccountNode].branchVarId!, 'True'],
          action: 'SkipThisOrchestrationStep',
        });
      }
    }
    createClaimsProviderSelectionReference(parsingCtx, node.nodeId, signInOrchStep, idpSignInOrchStep);
  } else if (localAccountNode) { // If we have no links and only a local account node, and the next step after this is the token issuer, we need a ClaimsExchange in between.
    let descendant = nodes[nodes[localAccountNode].children[0]];
    // If the TokenIssuer contains default values, it will generate an extra profile and we don't need one here.
    if ((descendant.kind === constants.componentTypes.tokenIssuer) && (!(descendant.data as JE_TokenIssuerNodeData).claims.some((clm) => { return !!(clm.defaultValue); }))) {
      let infillTP = createFQTechnicalProfile(
        parsingCtx.technicalProfileStore,
        {
          id: `${node.sanitizedDisplayName}_SignInPlaceholder`,
          displayName: `${node.displayName} Placeholder`,
          protocol: constants.customPolicySchema.protocols.claimsTransformation,
          outputClaims: [
            { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.signInPlaceholderDummy.id), defaultValue: "", alwaysUseDefaultValue: true }
          ],
          useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id
        },
        'Placeholders'
      );
      addFQOrchestrationStepToJourney(
        parsingCtx.userJourneyStore,
        {
          order: 2,
          type: 'ClaimsExchange',
          preconditions: preconditions?.slice(),
          claimsExchanges: [
            { id: `${node.displayName}_SignInPlaceholderExchange`, technicalProfileReferenceId: infillTP.id }
          ]
        },
        journeyId
      );
    }
  }
};

const getAADIOClaimRef = (parsingCtx: JE_ParsingContext, claimAttrMapping: JE_AAD_ClaimMapping) => {
  if (claimAttrMapping.claimResolver) {
    let claimRef: JE_technicalProfileClaimRef = {
      claimId: createFQClaim(parsingCtx.claimStore, {
        id: `aadClaimResolverBuffer${parsingCtx.claimStore.claimIds.size}`,
        displayName: 'AAD Claims Resolver Buffer',
        dataType: 'string',
      }).id,
      partnerClaimType: claimAttrMapping.attributeId,
      defaultValue: claimAttrMapping.defaultValue,
      alwaysUseDefaultValue: true,
    };
    return claimRef;
  } else if (claimAttrMapping.specialSessionContext) {
    let claimRef: JE_technicalProfileClaimRef = {
      claimId: getOrCreateSpecialClaim(
        parsingCtx,
        constants.sessionContexts.specials[
          claimAttrMapping.defaultValue as keyof typeof constants.sessionContexts.specials
        ].claimId,
      ),
      partnerClaimType: claimAttrMapping.attributeId,
    };
    return claimRef;
  } else {
    let claimRef: JE_technicalProfileClaimRef = { claimId: claimAttrMapping.claimId };
    if (claimAttrMapping.claimId !== claimAttrMapping.attributeId) {
      claimRef.partnerClaimType = claimAttrMapping.attributeId;
    }
    if (claimAttrMapping.defaultValue !== undefined) {
      claimRef.defaultValue = claimAttrMapping.defaultValue;
      if (claimAttrMapping.alwaysUseDefaultValue !== undefined) {
        claimRef.alwaysUseDefaultValue = claimAttrMapping.alwaysUseDefaultValue;
      }
    }
    return claimRef;
  }
};

const getAADObjectIdentifierClaimRef = (
  parsingCtx: JE_ParsingContext,
  objectIndex: string,
  claimAttrMap: JE_AAD_ClaimMapping[],
) => {
  let matchingMap = claimAttrMap.filter((cam: JE_AAD_ClaimMapping) => {
    return cam.attributeId === objectIndex;
  });
  let claimRef: JE_technicalProfileClaimRef = getAADIOClaimRef(parsingCtx, matchingMap[0]);
  claimRef.required = true;
  return claimRef;
};

const claimUsesUserIdentitiesAPI = (parsingCtx: JE_ParsingContext, claimId: string) => {
  const claimType = parsingCtx.claimStore.claims[claimId].dataType;
  return claimType === 'userIdentity' || claimType === 'userIdentityCollection';
};

const generateAADReadFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  submitActionFlow?: JE_SubflowInfo,
) => {
  let nodeData = node.data as JE_AADReadNodeData;
  let abbrName = node.nodeId.substring(0, 12);
  let outputClaims = nodeData.claimAttributeMap.map((ca: JE_AAD_ClaimMapping) => {
    return getAADIOClaimRef(parsingCtx, ca);
  });
  let oidRef: JE_technicalProfileClaimRef = {
    claimId: nodeData.objectIndexAttribute.claimId,
    partnerClaimType: nodeData.objectIndexAttribute.attributeId
  };
  if (nodeData.objectIndex === 'userIdentities') {
    oidRef.claimId = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentitiesForRead.id);
    outputClaims.forEach((ca) => {
      if (ca.claimId === 'foreignId') {
        ca.claimId = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentitiesForRead.id);
      }
    });
    let uidTransformId = getOrCreateUserForeignIdentityReadXform(parsingCtx);

    let preReadTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `aadReadByUserIdentitiesPrepProfile${parsingCtx.technicalProfileStore.tpIds.size}`,
        displayName: `AAD Read Preparation ${parsingCtx.technicalProfileStore.tpIds.size}`,
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        inputClaims: [
          { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emptyUserIdentities.id) },
          { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentitiesForRead.id) },
        ],
        outputClaims: [
          { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emptyUserIdentities.id) },
          { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentitiesForRead.id) },
        ],
        outputClaimXformIds: [uidTransformId],
        useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
      },
      'AAD Read Preparations',
    );
    addFQOrchestrationStepOrValidationProfileRef(
      parsingCtx,
      node,
      nodes,
      preReadTP.id,
      `aadReadByUserIdentitiesPrepExchange${parsingCtx.userJourneyStore.claimsExchangeIds.size}`,
      journeyId,
      branchVarMap,
      preconditions?.slice(),
      submitActionFlow,
      preReadTP.outputClaims?.map((outputClaimRef: JE_technicalProfileClaimRef) => outputClaimRef.claimId!),
    );
  }
  let metadataFields: JE_FQMetadataItemSpec[] = [
    { key: 'Operation', value: 'Read' },
    { key: 'RaiseErrorIfClaimsPrincipalDoesNotExist', value: nodeData.throwErrorIfNotFound.toString() },
  ];
  if (nodeData.throwErrorIfNotFound && nodeData.errorMessage) {
    metadataFields.push({ key: 'UserMessageIfClaimsPrincipalDoesNotExist', value: nodeData.errorMessage });
  }
  if (extractSettingFieldValue(jsonConstants.defaultAppSettingFields.extensionsContainerClientId.id, parsingCtx.buildSettings) &&
    extractSettingFieldValue(jsonConstants.defaultAppSettingFields.extensionsContainerObjectId.id, parsingCtx.buildSettings)) {
    metadataFields.push({ key: 'ClientId', value: extractSettingFieldValue(jsonConstants.defaultAppSettingFields.extensionsContainerClientId.id, parsingCtx.buildSettings) });
    metadataFields.push({ key: 'ApplicationObjectId', value: extractSettingFieldValue(jsonConstants.defaultAppSettingFields.extensionsContainerObjectId.id, parsingCtx.buildSettings) });
  }
  if (
    claimUsesUserIdentitiesAPI(parsingCtx, oidRef.claimId!) ||
    outputClaims.some((oClaim) => {
      return claimUsesUserIdentitiesAPI(parsingCtx, oClaim.claimId!);
    })
  ) {
    // Reading or writing userIdentity types to AAD requires the v1.6 API be specified.
    metadataFields.unshift({ key: 'api-version', value: '1.6' });
  }
  let aadReadTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: `AAD Read ${abbrName}`,
      protocol: constants.customPolicySchema.protocols.AAD,
      metadata: metadataFields,
      cryptographicKeys: [
        {
          id: 'issuer_secret',
          storageReferenceId: extractSettingFieldValue(jsonConstants.defaultAppSettingFields.tokenSigningKeyContainer.id, parsingCtx.buildSettings)
        },
      ],
      includeInSso: false,
      inputClaims: [oidRef],
      outputClaims: outputClaims,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Azure Active Directory',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    aadReadTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    submitActionFlow,
    aadReadTP.outputClaims?.map((outputClaimRef: JE_technicalProfileClaimRef) => outputClaimRef.claimId!),
  );
};

const generateSpecialSessionContextPrefiller = (
  parsingCtx: JE_ParsingContext,
  node: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  specialSessionContexts: Set<string>,
) => {
  let outputClaims: JE_technicalProfileClaimRef[] = [];
  let outputClaimsXforms: string[] = [];
  specialSessionContexts.forEach((ssc) => {
    let spKey = ssc as keyof typeof constants.sessionContexts.specials;
    outputClaims.push({
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.sessionContexts.specials[spKey].claimId),
    });
    switch (spKey) {
      case constants.sessionContexts.specials.CurrentDateTime.specialId:
        outputClaimsXforms.push(getOrCreateSSCTransform(parsingCtx, spKey));
        break;
      default:
        throw 'Unknown SSC in prefiller generation';
    }
  });
  let sscPrefillTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `specialSessionContextPrefillProfile${parsingCtx.technicalProfileStore.tpIds.size}`,
      displayName: 'Special Session Context Prefill',
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      outputClaims: outputClaims,
      outputClaimXformIds: outputClaimsXforms,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Special Session Context Handling',
  );
  return sscPrefillTP;
};

const generateAADWriteFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  submitActionFlow?: JE_SubflowInfo,
) => {
  let nodeData = node.data as JE_AADWriteNodeData;
  let advanceNeededClaims = collectAdvanceNeededClaimsAADWriteNode(node);
  generateAdvanceNeededClaimsInitializationStep(
    parsingCtx,
    node,
    nodes,
    advanceNeededClaims,
    journeyId,
    branchVarMap,
    preconditions,
    submitActionFlow,
  );
  let persistedClaims: JE_technicalProfileClaimRef[] = [];
  let appendUserIdentities: string[] = [];
  let replaceUserIdentities: string[] = [];
  let removeUserIdentities: string[] = [];
  let inputConcatXforms: string[] = [];
  let claimResolutions: JE_technicalProfileClaimRef[] = [];
  let specialSessionContexts: Set<string> = new Set();
  let inputConcatClaims = nodeData.inputConcatenations.map((inputConcat) => {
    let abbrNameA = inputConcat[0].substring(0, 6);
    let abbrNameB = inputConcat[1].substring(0, 6);
    let concatClaimId = createFQClaim(parsingCtx.claimStore, {
      id: `${node.sanitizedDisplayName}_Concatenated${abbrNameA}_${abbrNameB}`,
      displayName: `Input Concatenation of ${abbrNameA} and ${abbrNameB}`,
      dataType: 'string',
    }).id;
    inputConcatXforms.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${node.sanitizedDisplayName}_ConcatClaims${abbrNameA}_${abbrNameB}`,
        method: 'FormatStringMultipleClaims',
        inputClaims: [
          { claimId: inputConcat[0], xformClaimType: 'inputClaim1' },
          { claimId: inputConcat[1], xformClaimType: 'inputClaim2' },
        ],
        inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}{1}' }],
        outputClaims: [{ claimId: concatClaimId, xformClaimType: 'outputClaim' }],
      }).id,
    );
    return concatClaimId;
  });
  let oidRef = getAADObjectIdentifierClaimRef(parsingCtx, nodeData.objectIndex, nodeData.claimAttributeMap);
  if (nodeData.isCreateNew) {
    let passwordClaimMapping = nodeData.claimAttributeMap.filter((ca: JE_AAD_ClaimMapping) => {
      return ca.attributeId === 'password';
    });
    if (passwordClaimMapping.length === 0 || !passwordClaimMapping[0].claimId) {
      let pwStringBufId = getOrCreateStringHandlingBufferClaim(parsingCtx, 'password');
      inputConcatXforms.push(
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_MakeRandomPassword`,
          method: 'CreateRandomString',
          inputParameters: [{ id: 'randomGeneratorType', dataType: 'string', value: 'GUID' }],
          outputClaims: [{ claimId: pwStringBufId, xformClaimType: 'outputClaim' }],
        }).id,
      );
      if (passwordClaimMapping.length === 0) {
        nodeData.claimAttributeMap.push({
          claimId: pwStringBufId,
          attributeId: 'password',
        });
      } else {
        passwordClaimMapping[0].claimId = pwStringBufId;
      }
    }
  }
  let keyedOnForeignID = oidRef.partnerClaimType == constants.specialAttributes.userIdentities;
  // let keyedOnString = parsingCtx.claimStore.claims[oidRef.claimId!].dataType === 'string';

  nodeData.claimAttributeMap.forEach((ca: JE_AAD_ClaimMapping) => {
    if (ca.concatIndex !== undefined) {
      ca.claimId = inputConcatClaims[ca.concatIndex];
    }
    if (ca.attributeId === constants.specialAttributes.userIdentities) {
      if (keyedOnForeignID) {
        if (ca.claimId !== oidRef.claimId) {
          throw `Invalid AAD claim mapping in node: ${node.nodeId} - arbitrary writes to userIdentities can't coexist wth keying on the collection`;
        }
      } else {
        // Note: If any replace identities are present, the existing userIdentities collection will be replaced.
        // When this is the case, replace and append will behave identically in the rest of that AAD write component.
        if (ca.collectionOp === 'append') {
          appendUserIdentities.push(ca.claimId);
        } else if (ca.collectionOp === 'replace') {
          replaceUserIdentities.push(ca.claimId);
        } else if (ca.collectionOp === 'remove') {
          if (nodeData.isCreateNew) {
            throw `Invalid AAD claim mapping in node: ${node.nodeId} - can't remove from userIdentities in Create operation`;
          }
          removeUserIdentities.push(ca.claimId);
        } else {
          throw `Invalid AAD claim mapping in node: ${node.nodeId} - mapping to userIdentities has no or invalid identityOp`;
        }
      }
    } else {
      //if (!((ca.attributeId === oidRef.partnerClaimType) && (parsingCtx.claimStore.claims[oidRef]) )
      let claimRef = getAADIOClaimRef(parsingCtx, ca);
      if (ca.specialSessionContext) {
        specialSessionContexts.add(ca.defaultValue);
      } else if (ca.claimResolver) {
        claimResolutions.push(claimRef);
        let claimRefCopy: JE_technicalProfileClaimRef = {
          claimId: claimRef.claimId,
          partnerClaimType: claimRef.partnerClaimType,
        };
        claimRef = claimRefCopy;
      }
      persistedClaims.push(claimRef);
    }
  });
  if (claimResolutions.length > 0 || specialSessionContexts.size > 0) {
    let pfTP: JE_FQTechnicalProfileSpec | null = null;
    if (specialSessionContexts.size > 0) {
      pfTP = generateSpecialSessionContextPrefiller(parsingCtx, node, nodes, specialSessionContexts);
    } else {
      pfTP = createFQTechnicalProfile(
        parsingCtx.technicalProfileStore,
        {
          id: `sessionContextPrefillProfile${parsingCtx.technicalProfileStore.tpIds.size}`,
          displayName: 'Session Context Prefill',
          protocol: constants.customPolicySchema.protocols.claimsTransformation,
          inputClaims: [],
          outputClaims: [],
          useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
        },
        'Special Session Context Handling',
      );
    }
    let handleClaimResolutions = false;
    claimResolutions.forEach((cr) => {
      handleClaimResolutions = true;
      if (!pfTP!.inputClaims) {
        pfTP!.inputClaims = [];
      }
      if (
        pfTP!.inputClaims!.filter((icr) => {
          return icr.claimId === cr.claimId;
        }).length == 0
      ) {
        pfTP?.outputClaims?.push({
          claimId: cr.claimId,
        });
        pfTP?.inputClaims?.push({
          claimId: cr.claimId,
          defaultValue: cr.defaultValue,
          alwaysUseDefaultValue: cr.alwaysUseDefaultValue,
        });
      } else {
        pfTP!.inputClaims!.find((icr) => {
          return icr.claimId === cr.claimId;
        })!.defaultValue = cr.defaultValue;
        pfTP!.inputClaims!.find((icr) => {
          return icr.claimId === cr.claimId;
        })!.alwaysUseDefaultValue = cr.alwaysUseDefaultValue;
      }
    });
    if (!pfTP.metadata) {
      pfTP.metadata = [];
    }
    if (handleClaimResolutions) {
      pfTP.metadata.push({
        key: 'IncludeClaimResolvingInClaimsHandling',
        value: 'true',
      });
    }
    if (pfTP) {
      addFQOrchestrationStepOrValidationProfileRef(
        parsingCtx,
        node,
        nodes,
        pfTP.id,
        `${node.sanitizedDisplayName}_SessionContextPrepExchange`,
        journeyId,
        branchVarMap,
        preconditions?.slice(),
        submitActionFlow,
      );
    }
  }

  let containsUIWrites =
    appendUserIdentities.length > 0 || replaceUserIdentities.length > 0 || removeUserIdentities.length > 0;

  let extClientId = extractSettingFieldValue(jsonConstants.defaultAppSettingFields.extensionsContainerClientId.id, parsingCtx.buildSettings);
  let extObjectId = extractSettingFieldValue(jsonConstants.defaultAppSettingFields.extensionsContainerObjectId.id, parsingCtx.buildSettings);
  if (!nodeData.isCreateNew && (keyedOnForeignID || containsUIWrites)) {
    // Need to read the existing userIdentities collection in advance.
    let advanceInputXformIds: string[] = [];
    let readRef = oidRef;
    if (keyedOnForeignID) {
      // Need to read the full collection from a partial collection, so first make the partial collection.
      advanceInputXformIds.push(getOrCreateUserForeignIdentityReadXform(parsingCtx));
      readRef = {
        claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentitiesForRead.id),
        partnerClaimType: constants.specialAttributes.userIdentities,
      };
    }
    let uirMetadata: JE_FQMetadataItemSpec[] = [
      { key: 'api-version', value: '1.6' },
      { key: 'Operation', value: 'Read' },
      { key: 'RaiseErrorIfClaimsPrincipalDoesNotExist', value: nodeData.throwErrorIfNotFound.toString() },
      { key: 'RaiseErrorIfClaimsPrincipalAlreadyExists', value: nodeData.throwErrorIfExists.toString() },
    ];
    if (nodeData.throwErrorIfNotFound && nodeData.errorMessage) {
      uirMetadata.push({ key: 'UserMessageIfClaimsPrincipalDoesNotExist', value: nodeData.errorMessage });
    }

    if (extClientId && extObjectId) {
      uirMetadata.push({ key: 'ClientId', value: extClientId });
      uirMetadata.push({ key: 'ApplicationObjectId', value: extObjectId });
    }
    // Note createFQTPForNode is used to generate the read TP here. This will create an extra session TP for this TP alone in the case where
    // the node was configured tobe skipped only if executed; the session behavior will be the same as for the AAD write but if it was to be
    // an individual session profile it will be a separate one.
    let userIdentityReadTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `${node.sanitizedDisplayName}_PrepReadUserIdentityProfile`,
        displayName: `AAD Read UserIdentities Collection ${parsingCtx.technicalProfileStore.tpIds.size}`,
        protocol: constants.customPolicySchema.protocols.AAD,
        metadata: uirMetadata,
        cryptographicKeys: [
          {
            id: 'issuer_secret',
            storageReferenceId: extractSettingFieldValue(jsonConstants.defaultAppSettingFields.tokenSigningKeyContainer.id, parsingCtx.buildSettings)
          },
        ],
        includeInSso: false,
        inputClaimXformIds: advanceInputXformIds,
        inputClaims: [readRef],
        outputClaims: [
          {
            claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id),
            partnerClaimType: 'userIdentities',
          },
        ],
        useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
      },
      'Azure Active Directory',
    );
    addFQOrchestrationStepOrValidationProfileRef(
      parsingCtx,
      node,
      nodes,
      userIdentityReadTP.id,
      `${node.sanitizedDisplayName}_PrepReadUserIdentityExchange`,
      journeyId,
      branchVarMap,
      preconditions?.slice(),
      submitActionFlow,
    );
  }
  let inputClaimXformIds: string[] = [];

  if (containsUIWrites || keyedOnForeignID) {
    persistedClaims.push({
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id),
      partnerClaimType: constants.specialAttributes.userIdentities,
    });
  }

  if (nodeData.isCreateNew && keyedOnForeignID) {
    inputClaimXformIds.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${node.sanitizedDisplayName}_MakeIndexingUserIdentityCollection`,
        method: 'AddItemToUserIdentityCollection',
        inputClaims: [
          { claimId: oidRef.claimId!, xformClaimType: 'item' },
          {
            claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emptyUserIdentities.id),
            xformClaimType: 'collection',
          },
        ],
        outputClaims: [
          {
            claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id),
            xformClaimType: 'collection',
          },
        ],
      }).id,
    );
    persistedClaims.push({
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userPrincipalName.id),
      partnerClaimType: constants.specialAttributes.userPrincipalName,
    });
  }

  if (keyedOnForeignID) {
    oidRef.claimId = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id);
  }

  let metadataFields: JE_FQMetadataItemSpec[] = [
    { key: 'Operation', value: 'Write' },
    { key: 'RaiseErrorIfClaimsPrincipalAlreadyExists', value: nodeData.throwErrorIfExists.toString() },
    { key: 'RaiseErrorIfClaimsPrincipalDoesNotExist', value: nodeData.throwErrorIfNotFound.toString() },
  ];
  if (nodeData.throwErrorIfExists && nodeData.errorMessage) {
    metadataFields.push({ key: 'UserMessageIfClaimsPrincipalAlreadyExists', value: nodeData.errorMessage });
  } else if (nodeData.throwErrorIfNotFound && nodeData.errorMessage) {
    metadataFields.push({ key: 'UserMessageIfClaimsPrincipalDoesNotExist', value: nodeData.errorMessage });
  }

  if (extClientId && extObjectId) {
    metadataFields.push({ key: 'ClientId', value: extClientId });
    metadataFields.push({ key: 'ApplicationObjectId', value: extObjectId });
  }
  if (
    claimUsesUserIdentitiesAPI(parsingCtx, oidRef.claimId!) ||
    persistedClaims.some((pClaim) => {
      return claimUsesUserIdentitiesAPI(parsingCtx, pClaim.claimId!);
    })
  ) {
    // Reading or writing userIdentity types to AAD requires the v1.6 API be specified.
    metadataFields.unshift({ key: 'api-version', value: '1.6' });
  }
  inputConcatXforms.forEach((icxId: string) => {
    inputClaimXformIds.push(icxId);
  });
  nodeData.claimAttributeMap.forEach((cam, idx) => {
    if (
      !cam.specialSessionContext &&
      !cam.claimResolver &&
      parsingCtx.claimStore.claims[cam.claimId].dataType === 'string' &&
      cam.defaultValue
    ) {
      if (!cam.alwaysUseDefaultValue) {
        // Clean input strings if using optional defaults
        inputClaimXformIds.push(
          createStrCopyFormatClaimXform(
            parsingCtx,
            cam.claimId,
            getOrCreateStringHandlingBufferClaim(parsingCtx, cam.claimId),
          ),
        );
        inputClaimXformIds.push(
          createFQClaimXform(parsingCtx.claimTransformStore, {
            id: `${node.sanitizedDisplayName}_InputDefaultValueHandler${idx}`,
            method: 'SetClaimsIfStringsMatch',
            inputClaims: [
              {
                claimId: getOrCreateStringHandlingBufferClaim(parsingCtx, cam.claimId),
                xformClaimType: 'claimToMatch',
              },
            ],
            inputParameters: [
              { id: 'matchTo', dataType: 'string', value: '' },
              { id: 'stringComparison', dataType: 'string', value: 'ordinalIgnoreCase' },
              { id: 'outputClaimIfMatched', dataType: 'string', value: cam.defaultValue },
            ],
            outputClaims: [
              { claimId: cam.claimId, xformClaimType: 'outputClaim' },
              {
                claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.strCmpBoolBuf.id),
                xformClaimType: 'stringCompareResultClaim',
              },
            ],
          }).id,
        );
      }
    }
  });
  if (replaceUserIdentities.length > 0) {
    let initEmptyCollection = true;
    replaceUserIdentities.forEach((claimId: string, idx) => {
      if (parsingCtx.claimStore.claims[claimId].dataType !== 'userIdentity') {
        throw `Invalid AAD Write in node ${node.nodeId}: userIdentities collection modification with a claim of non-userIdentity type`;
      }
      inputClaimXformIds.push(
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_FillUserIdentitiesReplacement${idx}`,
          method: 'AddItemToUserIdentityCollection',
          inputClaims: [
            { claimId: claimId, xformClaimType: 'item' },
            {
              claimId: getOrCreateSpecialClaim(
                parsingCtx,
                initEmptyCollection
                  ? constants.specialClaims.emptyUserIdentities.id
                  : constants.specialClaims.userIdentities.id,
              ),
              xformClaimType: 'collection',
            },
          ],
          outputClaims: [
            {
              claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id),
              xformClaimType: 'collection',
            },
          ],
        }).id,
      );
      initEmptyCollection = false;
    });
  }
  appendUserIdentities.forEach((claimId: string, idx) => {
    if (parsingCtx.claimStore.claims[claimId].dataType !== 'userIdentity') {
      throw `Invalid AAD Write in node ${node.nodeId}: userIdentities collection modification with a claim of non-userIdentity type`;
    }
    inputClaimXformIds.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${node.sanitizedDisplayName}_AppendUserIdentity${idx}`,
        method: 'AddItemToUserIdentityCollection',
        inputClaims: [
          { claimId: claimId, xformClaimType: 'item' },
          {
            claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id),
            xformClaimType: 'collection',
          },
        ],
        outputClaims: [
          {
            claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id),
            xformClaimType: 'collection',
          },
        ],
      }).id,
    );
  });
  removeUserIdentities.forEach((claimId: string, idx) => {
    if (parsingCtx.claimStore.claims[claimId].dataType !== 'userIdentity') {
      throw `Invalid AAD Write in node ${node.nodeId}: userIdentities collection modification with a claim of non-userIdentity type`;
    }
    inputClaimXformIds.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${node.sanitizedDisplayName}_RemoveUserIdentity${idx}`,
        method: 'RemoveUserIdentityFromCollectionByIssuer',
        inputClaims: [
          {
            claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.identityProvider.id),
            xformClaimType: 'issuer',
          },
          {
            claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id),
            xformClaimType: 'collection',
          },
        ],
        outputClaims: [
          {
            claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdentities.id),
            xformClaimType: 'collection',
          },
        ],
      }).id,
    );
  });
  if (nodeData.isCreateNew) {
    if (
      !persistedClaims.some(
        (pClaim) =>
          pClaim.partnerClaimType === 'displayName' || (!pClaim.partnerClaimType && pClaim.claimId === 'displayName'),
      )
    ) {
      persistedClaims.push({
        claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.displayName.id),
        defaultValue: 'unknown',
        partnerClaimType: 'displayName',
      });
    } else if (
      !persistedClaims.filter(
        (pClaim) =>
          pClaim.partnerClaimType === 'displayName' || (!pClaim.partnerClaimType && pClaim.claimId === 'displayName'),
      )[0].defaultValue
    ) {
      persistedClaims.filter(
        (pClaim) =>
          pClaim.partnerClaimType === 'displayName' || (!pClaim.partnerClaimType && pClaim.claimId === 'displayName'),
      )[0].defaultValue = 'unknown';
    }
  }
  // PasswordPolicies needs to be included to write any password or ADB2C will complain
  if (
    persistedClaims.some(
      (pClaim) => pClaim.partnerClaimType === 'password' || (!pClaim.partnerClaimType && pClaim.claimId === 'password'),
    )
  ) {
    if (
      !persistedClaims.some(
        (pClaim) =>
          pClaim.partnerClaimType === 'passwordPolicies' ||
          (!pClaim.partnerClaimType && pClaim.claimId === 'passwordPolicies'),
      )
    ) {
      persistedClaims.push({
        claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.passwordPolicies.id),
        defaultValue: 'DisablePasswordExpiration, DisableStrongPassword',
        partnerClaimType: 'passwordPolicies',
      });
    }
  }
  let outputClaims: JE_technicalProfileClaimRef[] = [];
  if (nodeData.objectIdOutputClaim) {
    outputClaims.push({
      claimId: nodeData.objectIdOutputClaim,
      partnerClaimType: constants.specialAttributes.objectId,
    });
  }
  if (nodeData.upnOutputClaim) {
    outputClaims.push({
      claimId: nodeData.upnOutputClaim,
      partnerClaimType: constants.specialAttributes.userPrincipalName,
    });
  }
  let aadWriteTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.AAD,
      metadata: metadataFields,
      cryptographicKeys: [
        {
          id: 'issuer_secret',
          storageReferenceId: extractSettingFieldValue(jsonConstants.defaultAppSettingFields.tokenSigningKeyContainer.id, parsingCtx.buildSettings)
        },
      ],
      includeInSso: false,
      inputClaimXformIds: inputClaimXformIds,
      inputClaims: [oidRef],
      persistedClaims: persistedClaims,
      outputClaims: outputClaims,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Azure Active Directory',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    aadWriteTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    submitActionFlow,
    outputClaims.map((oClaimRef) => {
      return oClaimRef.claimId!;
    }),
  );
};

const generateAADSSPRSendCodeTP = (parsingCtx: JE_ParsingContext, emailClaimId: string) => {
  return createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `SendEmailVerificationCodeSSPRProfile${parsingCtx.technicalProfileStore.tpIds.size}`,
      displayName: 'Send Code',
      protocol: constants.customPolicySchema.protocols.aadSspr,
      metadata: [{ key: 'Operation', value: 'SendCode' }],
      inputClaims: [{ claimId: emailClaimId, partnerClaimType: 'emailAddress' }],
    },
    'AAD SSPR',
  ).id;
};

const generateAADSSPRVerifyCodeTP = (parsingCtx: JE_ParsingContext, emailClaimId: string) => {
  return createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `VerifyEmailVerificationCodeSSPRProfile${parsingCtx.technicalProfileStore.tpIds.size}`,
      displayName: 'Verify Code',
      protocol: constants.customPolicySchema.protocols.aadSspr,
      metadata: [{ key: 'Operation', value: 'VerifyCode' }],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.verificationCode.id),
          partnerClaimType: 'verificationCode',
        },
        { claimId: emailClaimId, partnerClaimType: 'emailAddress' },
      ],
    },
    'AAD SSPR',
  ).id;
};

const generateEmailValidationDisplayControl = (parsingCtx: JE_ParsingContext, emailInputClaimId: string) => {
  return createFQDisplayControl(parsingCtx.displayControlStore, {
    id: `EmailValidationDisplayControl${parsingCtx.displayControlStore.displayControlIds.size}`,
    userInterfaceControlType: 'VerificationControl',
    inputClaims: [{ claimId: emailInputClaimId, required: true }],
    displayClaims: [
      { claimId: emailInputClaimId, required: true },
      {
        claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.verificationCode.id),
        controlClaimType: 'VerificationCode',
        required: true,
      },
    ],
    outputClaims: [{ claimId: emailInputClaimId }],
    actions: [
      {
        id: 'SendCode',
        validationClaimsExchange: [{ profileId: generateAADSSPRSendCodeTP(parsingCtx, emailInputClaimId) }],
      },
      {
        id: 'VerifyCode',
        validationClaimsExchange: [{ profileId: generateAADSSPRVerifyCodeTP(parsingCtx, emailInputClaimId) }],
      },
    ],
  }).id;
};

const generateCustomEmailValidationDisplayContol = (
  parsingCtx: JE_ParsingContext,
  journeyId: string,
  parentNodeId: string,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  subflowTopologicalOrders: { [index: string]: string[] },
  subflowBranchVarMaps: { [index: string]: BranchVarMap },
  emailInputClaimId: string,
  sendActionFlowId: string,
  locallyIdentifiedEmailInputClaimId: string, // This claim is important if a generated claim replaced the UI claim specified for the display control, such as if it was readonly.
) => {
  let subflowData: JE_SubflowInfo = {
    validationFlow: [],
    outputClaimIds: new Set(),
    flowType: 'emailVerificationSendAction',
    parentNodeId: parentNodeId,
  };
  parseConditionalDAG(
    parsingCtx,
    journeyId,
    nodes,
    subflowTopologicalOrders[sendActionFlowId],
    subflowBranchVarMaps[sendActionFlowId],
    {},
    {},
    subflowData,
  );
  if (subflowData.validationFlow.length === 0) {
    throw 'Custom email validation flow actions cannot be empty';
  }
  if (locallyIdentifiedEmailInputClaimId !== emailInputClaimId) {
    let copybackVTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `EmailVerificationDisplayControl_CopybackEmail`,
        displayName: 'Email Verification Email Copyback',
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        inputClaims: [{ claimId: emailInputClaimId }],
        outputClaims: [{ claimId: emailInputClaimId }, { claimId: locallyIdentifiedEmailInputClaimId }],
        outputClaimXformIds: [
          createFQClaimXform(parsingCtx.claimTransformStore, {
            id: `EmailVerificationDisplayContol_CopybackXform`,
            method: 'CopyClaim',
            inputClaims: [{ claimId: emailInputClaimId, xformClaimType: 'inputClaim' }],
            outputClaims: [{ claimId: locallyIdentifiedEmailInputClaimId, xformClaimType: 'outputClaim' }],
          }).id,
        ],
      },
      'OTP Handling',
    );
    subflowData.validationFlow.unshift({
      profileId: copybackVTP.id,
    });
  }
  let verifyOTPTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `EmailValidationDisplayControl_VerifyOTP`,
      displayName: 'Email Validation OTP Verification',
      protocol: constants.customPolicySchema.protocols.oneTimePassword,
      metadata: [{ key: 'Operation', value: 'VerifyCode' }],
      inputClaims: [
        { claimId: emailInputClaimId, partnerClaimType: 'identifier' },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.verificationCode.id),
          partnerClaimType: 'otpToVerify',
        },
      ],
    },
    'OTP Handling',
  );
  let customEmailValidationDC = createFQDisplayControl(parsingCtx.displayControlStore, {
    id: `EmailValidationDisplayControl${parsingCtx.displayControlStore.displayControlIds.size}`,
    userInterfaceControlType: 'VerificationControl',
    inputClaims: [{ claimId: emailInputClaimId, required: true }],
    displayClaims: [
      { claimId: emailInputClaimId, required: true },
      {
        claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.verificationCode.id),
        controlClaimType: 'VerificationCode',
        required: true,
      },
    ],
    outputClaims: [{ claimId: emailInputClaimId }],
    actions: [
      {
        id: 'SendCode',
        validationClaimsExchange: subflowData.validationFlow,
      },
      {
        id: 'VerifyCode',
        validationClaimsExchange: [{ profileId: verifyOTPTP.id }],
      },
    ],
  });
  return customEmailValidationDC.id;
};

const generateUserInputNodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  subflowTopologicalOrders: { [index: string]: string[] },
  subflowBranchVarMaps: { [index: string]: BranchVarMap },
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_UserInputNodeData;
  // Step 0: Collect advance needed claims and ensure they are initialized.
  let advanceNeededClaims = collectAdvanceNeededClaimsUserInputNode(node, parsingCtx);
  generateAdvanceNeededClaimsInitializationStep(
    parsingCtx,
    node,
    nodes,
    advanceNeededClaims,
    journeyId,
    branchVarMap,
    preconditions,
  );
  // Step 1: Input xform generation, and IO claim collection.
  // Prefilling from other claims can potentially introduce cycles in claim dependencies, so these need to be sorted out.
  // Claims can be part of at most one such cycle (since claims can only be destination of one prefill copy).
  // So make a graph of prefill copies and traverse until all nodes visited. If a node gets revisited, we create a temp claim to copy its value to
  // and we'll order the claim transformations to move values into the temp copies first before other copying is done.
  // Then the remaining set of prefills (including from the new copies to the original destinations) will be sorted so all
  // prefilling will place instances where a claim is a source before the instance where that claim is a destination.
  // (Literal prefills happen after InputClaimsTransformations so aren't relevant to this step)
  // 1a. Collect prefill copy operations.
  let prefillMap: { [src: string]: string[] } = {};
  let visited: Set<string> = new Set();
  let requiresBooleanCopy = false;
  let readonlyCopyMap: { [fieldClaimId: string]: string } = {};
  let inputClaims: JE_technicalProfileClaimRef[] = [];
  let displayClaims: JE_technicalProfileClaimRef[] = [];
  let outputClaims: JE_technicalProfileClaimRef[] = [];
  let validationDisplayControl: JE_technicalProfileClaimRef | null = null;
  let usingClaimsResolvers = false;
  let allInputFields: JE_UserInput_InputField[] = nodeData.inputFields.slice();
  if (nodeData.emailValidation) {
    let emailClaim = parsingCtx.claimStore.claims[nodeData.emailValidation.emailClaimId];
    allInputFields.unshift({
      kind: 'data',
      claimId: emailClaim.id,
      readonly: nodeData.emailValidation.readonly,
      prefilled: nodeData.emailValidation.prefillSourceType,
      prefill_source: nodeData.emailValidation.prefillSource ? nodeData.emailValidation.prefillSource : '',
      required: true
    });
  }
  allInputFields.forEach((inputField: JE_UserInput_InputField) => {
    if (inputField.kind === 'data') {
      let existingClaim = parsingCtx.claimStore.claims[inputField.claimId];
      if (inputField.readonly && existingClaim.userInputType !== 'Readonly') {
        if (existingClaim.dataType === 'dateTime') {
          throw 'Illegal user input page display mapping: non-readonly dateTime claims cannot be displayed as readonly (uncopyable type)';
        }
        // Make a copy claim for later.
        let abbrName = inputField.claimId.substring(0, 10);
        readonlyCopyMap[inputField.claimId] = cloneFQClaim(
          parsingCtx.claimStore,
          existingClaim,
          `${node.sanitizedDisplayName}_${abbrName}_DisplayCopy`,
          'Readonly',
        ).id;
      }
      if (inputField.prefilled === 'claim') {
        if (inputField.prefill_source !== inputField.claimId) {
          if (existingClaim.dataType === 'dateTime') {
            throw 'Illegal user input page display mapping: dateTime fields cannot be prefilled from another claim (uncopyable type)';
          }
          if (existingClaim.dataType === 'boolean') {
            requiresBooleanCopy = true;
          }
          if (!prefillMap.hasOwnProperty(inputField.prefill_source)) {
            prefillMap[inputField.prefill_source] = [];
          }
          prefillMap[inputField.prefill_source].push(inputField.claimId);
        } else if (readonlyCopyMap.hasOwnProperty(inputField.claimId)) {
          if (!prefillMap.hasOwnProperty(inputField.claimId)) {
            prefillMap[inputField.claimId] = [];
          }
          prefillMap[inputField.claimId].push(readonlyCopyMap[inputField.claimId]);
          if (existingClaim.dataType === 'boolean') {
            // Check the other case in which we prefill from the same value but need to make a display copy, just in case we still need boolean copy because of that
            requiresBooleanCopy = true;
          }
        }
      }
      if (inputField.prefilled !== 'none') {
        let inputClaimRef: JE_technicalProfileClaimRef = {
          claimId: readonlyCopyMap.hasOwnProperty(inputField.claimId)
            ? readonlyCopyMap[inputField.claimId]
            : inputField.claimId,
        };
        if (inputField.prefilled === 'literal' || inputField.prefilled === 'resolver') {
          inputClaimRef.defaultValue = inputField.prefill_source;
          inputClaimRef.alwaysUseDefaultValue = true;
          if (inputField.prefilled === 'resolver') {
            usingClaimsResolvers = true;
          }
        }
        inputClaims.push(inputClaimRef);
      }
      if (!nodeData.emailValidation || nodeData.emailValidation.emailClaimId !== existingClaim.id) {
        let displayClaimRef: JE_technicalProfileClaimRef = {
          claimId: readonlyCopyMap.hasOwnProperty(inputField.claimId)
            ? readonlyCopyMap[inputField.claimId]
            : inputField.claimId,
        };
        if (!readonlyCopyMap.hasOwnProperty(inputField.claimId)) {
          displayClaimRef.required = inputField.required;
        }
        displayClaims.push(displayClaimRef);
      }

      let outputClaimRef: JE_technicalProfileClaimRef = {
        claimId: inputField.claimId,
      };
      if (
        readonlyCopyMap.hasOwnProperty(inputField.claimId) &&
        (inputField.prefilled === 'literal' || inputField.prefilled == 'resolver')
      ) {
        outputClaimRef.defaultValue = inputField.prefill_source;
        outputClaimRef.alwaysUseDefaultValue = true;
      }
      outputClaims.push(outputClaimRef);
    }
  });
  if (nodeData.emailValidation) {
    let emailClaim = parsingCtx.claimStore.claims[nodeData.emailValidation.emailClaimId];
    if (
      nodeData.emailValidation.sendAction &&
      subflowTopologicalOrders[nodeData.emailValidation.sendAction] &&
      subflowTopologicalOrders[nodeData.emailValidation.sendAction].length > 0
    ) {
      // Custom email validation
      validationDisplayControl = {
        displayControlId: generateCustomEmailValidationDisplayContol(
          parsingCtx,
          journeyId,
          node.nodeId,
          nodes,
          subflowTopologicalOrders,
          subflowBranchVarMaps,
          Object.keys(readonlyCopyMap).includes(emailClaim.id) ? readonlyCopyMap[emailClaim.id] : emailClaim.id,
          nodeData.emailValidation.sendAction,
          emailClaim.id,
        ),
      };
    } else {
      validationDisplayControl = {
        displayControlId: generateEmailValidationDisplayControl(
          parsingCtx,
          Object.keys(readonlyCopyMap).includes(emailClaim.id) ? readonlyCopyMap[emailClaim.id] : emailClaim.id,
        ),
      };
    }
  }
  // Find and make temp copies to break cycle dependencies.
  let copyMap: { [src: string]: string } = {};
  let copyReverseMap: { [copy: string]: string } = {};
  Object.keys(prefillMap).forEach((prefillSrc: string) => {
    if (visited.has(prefillSrc)) {
      let abbrName = prefillSrc.substring(0, 10);
      let copyClaim = createFQClaim(parsingCtx.claimStore, {
        id: `${node.sanitizedDisplayName}_${abbrName}_TempCopy`,
        displayName: `Temp Copy ${abbrName}`,
        dataType: parsingCtx.claimStore.claims[prefillSrc].dataType,
      });
      prefillMap[copyClaim.id] = prefillMap[prefillSrc];
      // Safe to delete during map iteration in this case, because items only appear once as keys and once as values
      // and will only get deleted if they've been seen as both
      delete prefillMap[prefillSrc];
      copyMap[prefillSrc] = copyClaim.id;
      copyReverseMap[copyClaim.id] = prefillSrc;
    } else {
      visited.add(prefillSrc);
      prefillMap[prefillSrc].forEach((prefillDest: string) => {
        if (visited.has(prefillDest)) {
          let abbrName = prefillDest.substring(0, 10);
          let copyClaim = createFQClaim(parsingCtx.claimStore, {
            id: `${node.sanitizedDisplayName}_${abbrName}_TempCopy`,
            displayName: `Temp Copy ${abbrName}`,
            dataType: parsingCtx.claimStore.claims[prefillDest].dataType,
          });
          prefillMap[copyClaim.id] = prefillMap[prefillDest];
          delete prefillMap[prefillDest];
          copyMap[prefillDest] = copyClaim.id;
          copyReverseMap[copyClaim.id] = prefillDest;
        } else {
          visited.add(prefillDest);
        }
      });
    }
  });
  // Copy order is as follows:
  // Do copies from the copyMap first.
  // Then do all remaining copies whose destination is not a source of any copy.
  // Then place the remaining copies, in sorted order such that for all claims A, copies where A is source come before the copy where A is dest.
  let prefillCopies: [string, string][] = [];
  Object.keys(copyMap).forEach((src: string) => {
    prefillCopies.push([src, copyMap[src]]);
  });
  let remainingCopies: [string, string][] = [];
  Object.keys(prefillMap).forEach((src: string) => {
    prefillMap[src].forEach((dest: string) => {
      if (!prefillMap.hasOwnProperty(dest)) {
        prefillCopies.push([src, dest]);
      } else {
        remainingCopies.push([src, dest]);
      }
    });
  });
  let depCopyMap: { [src: string]: string[] } = {};
  let reverseDepMap: { [dest: string]: string } = {};
  // The remaining copies form a tree (or collection of trees) at this point, so find all the leaves and reverse from them to construct an ordering.
  // Hopefully by this point there aren't many copies left and this step can be mostly skipped.
  let leaves: Set<string> = new Set();
  let sources: Set<string> = new Set();
  visited = new Set();
  remainingCopies.forEach((fromTo: [string, string]) => {
    let [src, dest] = fromTo;
    sources.add(src);
    if (!depCopyMap.hasOwnProperty(src)) {
      depCopyMap[src] = [];
    }
    depCopyMap[src].push(dest);
    reverseDepMap[dest] = src;
  });
  remainingCopies.forEach((fromTo: [string, string]) => {
    let [src, dest] = fromTo;
    if (!sources.has(dest)) {
      leaves.add(dest);
    }
  });
  let searchQ = Array.from(leaves);
  while (searchQ.length > 0) {
    let nextDest = searchQ.shift()!;
    visited.add(nextDest);
    if (reverseDepMap.hasOwnProperty(nextDest)) {
      if (depCopyMap[reverseDepMap[nextDest]].every((dd: string) => visited.has(dd))) {
        searchQ.push(reverseDepMap[nextDest]);
      }
    }
    if (depCopyMap.hasOwnProperty(nextDest)) {
      depCopyMap[nextDest].forEach((deeperDest: string) => {
        prefillCopies.push([nextDest, deeperDest]);
      });
    }
  }
  let booleanCopyDummyId = '';
  // Finished sorting copies; prefillCopies has a sorted ordering of input transform copy operations.
  // Some of these may potentially require different copies based on the input display settings but the ordering should hold.

  // AD B2C has no boolean claim copy functionality, so we need to approximate this by ANDing a boolean claim with true.
  // This is guaranteed to exist if we have any boolean claims, as the first orchestration step of every journey will set the boolean
  // true constant claim to true.
  if (requiresBooleanCopy) {
    booleanCopyDummyId = getOrCreateTrueBooleanConstant(parsingCtx);
  }

  let inputXformIds: string[] = [];
  prefillCopies.forEach((fromTo: [string, string]) => {
    let [src, dest] = fromTo;
    // For copies to a temp copy generated in the last step, we don't care what the readonly state is since this is just a temp container.
    // For copies that don't need to generate a readonly copy we can use this same path.
    let abbrSrc = src.substring(0, 10);
    let abbrDest = dest.substring(0, 10);
    if (parsingCtx.claimStore.claims[src].dataType === 'boolean') {
      // Boolean copy xform is AndClaims with the boolean copy dummy generated previously
      inputXformIds.push(
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_${abbrSrc}_${abbrDest}_PerformCopy`,
          method: 'AndClaims',
          inputClaims: [
            { claimId: src, xformClaimType: 'inputClaim1' },
            { claimId: booleanCopyDummyId, xformClaimType: 'inputClaim2' },
          ],
          outputClaims: [{ claimId: dest, xformClaimType: 'outputClaim' }],
        }).id,
      );
      if (readonlyCopyMap.hasOwnProperty(dest)) {
        // We need to make a read-only copy and prefill that copy in-order too.
        let abbrCopy = readonlyCopyMap[dest].substring(8, 18);
        inputXformIds.push(
          createFQClaimXform(parsingCtx.claimTransformStore, {
            id: `${node.sanitizedDisplayName}_${abbrSrc}_${abbrCopy}_PerformCopy`,
            method: 'AndClaims',
            inputClaims: [
              { claimId: src, xformClaimType: 'inputClaim1' },
              { claimId: booleanCopyDummyId, xformClaimType: 'inputClaim2' },
            ],
            outputClaims: [{ claimId: readonlyCopyMap[dest], xformClaimType: 'outputClaim' }],
          }).id,
        );
      }
    } else {
      // Use CopyClaim for strings
      inputXformIds.push(
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_${abbrSrc}_${abbrDest}_PerformCopy`,
          method: 'CopyClaim',
          inputClaims: [{ claimId: src, xformClaimType: 'inputClaim' }],
          outputClaims: [{ claimId: dest, xformClaimType: 'outputClaim' }],
        }).id,
      );
      if (readonlyCopyMap.hasOwnProperty(dest)) {
        let abbrCopy = readonlyCopyMap[dest].substring(8, 18);
        inputXformIds.push(
          createFQClaimXform(parsingCtx.claimTransformStore, {
            id: `${node.sanitizedDisplayName}_${abbrSrc}_${abbrCopy}_PerformCopy`,
            method: 'CopyClaim',
            inputClaims: [{ claimId: src, xformClaimType: 'inputClaim' }],
            outputClaims: [{ claimId: readonlyCopyMap[dest], xformClaimType: 'outputClaim' }],
          }).id,
        );
      }
    }
  });
  if (nodeData.emailValidation) {
    let emailClaim = parsingCtx.claimStore.claims[nodeData.emailValidation.emailClaimId];
    if (readonlyCopyMap.hasOwnProperty(emailClaim.id)) {
      if (nodeData.emailValidation.prefillSourceType === 'claim') {
        // Need to make sure prefill happens in input claims, not output claims
        inputXformIds.push(
          createFQClaimXform(parsingCtx.claimTransformStore, {
            id: `${node.sanitizedDisplayName}_Email_Verification_Display_Refill`,
            method: 'CopyClaim',
            inputClaims: [{ claimId: readonlyCopyMap[emailClaim.id], xformClaimType: 'inputClaim' }],
            outputClaims: [{ claimId: emailClaim.id, xformClaimType: 'outputClaim' }],
          }).id,
        );
        inputClaims.push({
          claimId: emailClaim.id,
        });
      } else if (nodeData.emailValidation.prefillSourceType === 'resolver') {
        inputClaims.push({
          claimId: emailClaim.id,
          defaultValue: nodeData.emailValidation.prefillSource,
          alwaysUseDefaultValue: true,
        });
      }
    }
  }

  // Step 2: Generate the technical profile.
  let expIdNumber = parsingCtx.technicalProfileStore.tpIds.size;
  // Add the output claim needed by self-asserted profiles to catch the submit.
  outputClaims.unshift({
    claimId: getOrCreateSpecialClaim(parsingCtx, 'executed-SelfAsserted-Input'),
    defaultValue: 'true',
  });
  // Generate the validation technical profiles, if any.
  let submitAction: JE_SubflowInfo = {
    validationFlow: [],
    outputClaimIds: new Set(),
    flowType: 'formSubmitAction',
    parentNodeId: node.nodeId,
  };
  if (
    nodeData.formSubmitAction &&
    subflowTopologicalOrders[nodeData.formSubmitAction] &&
    subflowTopologicalOrders[nodeData.formSubmitAction].length > 0
  ) {
    parseConditionalDAG(
      parsingCtx,
      journeyId,
      nodes,
      subflowTopologicalOrders[nodeData.formSubmitAction],
      subflowBranchVarMaps[nodeData.formSubmitAction],
      {},
      {},
      submitAction,
    );
    // Add any output claims from the submit action, so they are available in the claims bag.
    submitAction.outputClaimIds.forEach((sClaimId: string) => {
      if (
        outputClaims.filter((outClaim: JE_technicalProfileClaimRef) => {
          return outClaim.claimId === sClaimId;
        }).length == 0
      ) {
        outputClaims.push({ claimId: sClaimId });
      }
    });
    // TODO: Find a better way to handle this case.
    // If the user defined a repeated password field, we rename the input claims under the hood to match those expected by the default HTML templates.
    // However, they may have used the 'password' claim value in VTPs, so we need to copy back to it.
    if (nodeData.specialPasswordValidation) {
      let specialPasswordId = 'newPassword';
      submitAction.validationFlow.unshift({
        profileId: createFQTechnicalProfile(
          parsingCtx.technicalProfileStore,
          {
            id: `${node.sanitizedDisplayName}_InternalPasswordCopyProfile`,
            displayName: `Internal Password Copy ${parsingCtx.technicalProfileStore.tpIds.size}`,
            protocol: constants.customPolicySchema.protocols.claimsTransformation,
            inputClaims: [{ claimId: specialPasswordId, required: true }],
            outputClaims: [{ claimId: 'password' }],
            outputClaimXformIds: [
              createFQClaimXform(parsingCtx.claimTransformStore, {
                id: `${node.sanitizedDisplayName}_InternalPasswordCopy`,
                method: 'CopyClaim',
                inputClaims: [{ claimId: specialPasswordId, xformClaimType: 'inputClaim' }],
                outputClaims: [{ claimId: 'password', xformClaimType: 'outputClaim' }],
              }).id,
            ],
          },
          'Password Handling',
        ).id,
      });
    }
  }
  if (validationDisplayControl) {
    displayClaims.unshift(validationDisplayControl);
  }
  let metadataFields: JE_FQMetadataItemSpec[] = [];
  if (nodeData.contentDefinitionUrl) {
    let draftCD: JE_FQContentDefinitionSpec = {
      id: `${node.sanitizedDisplayName}_ContentDefinition`,
      loadUri: nodeData.contentDefinitionUrl,
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'User Input Page' }],
    };
    metadataFields.push({
      key: 'ContentDefinitionReferenceId',
      value: getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.selfasserted').id,
    });
  } else {
    metadataFields.push({
      key: 'ContentDefinitionReferenceId',
      value: fetchDefaultFQContentDefinitionRef(parsingCtx, 'api.selfasserted'),
    });
  }
  if (usingClaimsResolvers) {
    metadataFields.push({ key: 'IncludeClaimResolvingInClaimsHandling', value: 'true' });
  }
  if (nodeData.formSubmitAction && nodeData.validationErrorMessage && subflowTopologicalOrders[nodeData.formSubmitAction].some((nId: string) => { return nodes[nId].kind === constants.componentTypes.validationError })) {
    metadataFields.push({ key: 'UserMessageIfClaimsTransformationBooleanValueIsNotEqual', value: nodeData.validationErrorMessage });
  }
  let userInputTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName ? node.displayName : `User Input ${expIdNumber}`,
      protocol: constants.customPolicySchema.protocols.selfAsserted,
      metadata: metadataFields,
      includeInSso: false,
      inputClaimXformIds: inputXformIds,
      inputClaims: inputClaims,
      displayClaims: displayClaims,
      outputClaims: outputClaims,
      validationTechnicalProfiles: submitAction.validationFlow,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Self Asserted',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    userInputTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
};

const generateAppInsightsCommonTechnicalProfileFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  displayName?: string,
) => {
  let nodeData = node.data as JE_AppInsightsNodeData;

  let inputClaims: JE_technicalProfileClaimRef[] = [
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.EventTimestamp.id),
      partnerClaimType: '{property:EventTimestamp}',
      defaultValue: '{Context:DateTimeInUtc}',
    },
    {
      claimId: 'tenantId',
      partnerClaimType: '{property:TenantId}',
      defaultValue: '{Policy:TrustFrameworkTenantId}',
    },
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.PolicyId.id),
      partnerClaimType: '{property:Policy}',
      defaultValue: '{Policy:PolicyId}',
    },
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.CorrelationId.id),
      partnerClaimType: '{property:CorrelationId}',
      defaultValue: '{Context:CorrelationId}',
    },
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.Culture.id),
      partnerClaimType: '{property:Culture}',
      defaultValue: '{Culture:RFC5646}',
    },
  ];
  // Step 2: Generate the technical profile.
  let metadataFields: JE_FQMetadataItemSpec[] = [];
  if (nodeData.instrumentationKey !== '') {
    metadataFields.push({ key: 'InstrumentationKey', value: nodeData.instrumentationKey });
  }
  metadataFields.push({ key: 'DeveloperMode', value: 'false' });
  metadataFields.push({ key: 'DisableTelemetry ', value: 'false' });
  let userInputTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: 'AppInsights-Common',
      displayName: 'Application Insights',
      protocol: constants.customPolicySchema.protocols.appInsights,
      metadata: metadataFields,
      inputClaims: inputClaims,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Application Insights',
  );
  return userInputTP;
};

const generateAppInsightsTechnicalProfileFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  displayName?: string,
) => {
  let nodeData = node.data as JE_AppInsightsNodeData;

  let inputClaims: JE_technicalProfileClaimRef[] = [
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.EventType.id),
      partnerClaimType: 'eventName',
      defaultValue: nodeData.eventType,
    },
  ];
  nodeData.inputFields.forEach((inputField: JE_AppInsights_InputField) => {
    let inputClaimRef: JE_technicalProfileClaimRef = {
      claimId: inputField.claimId,
    };
    inputClaimRef.partnerClaimType = `{property:${inputField.partnerClaimType}}`;
    inputClaimRef.defaultValue = inputField.defaultValue;
    inputClaims.push(inputClaimRef);
  });

  // Step 2: Generate the technical profile.
  let userInputTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName + '-' + nodeData.eventType,
      inputClaims: inputClaims,
      includeTechnicalProfile: 'AppInsights-Common',
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Application Insights',
  );
  return userInputTP;
};

const generateAppInsightsNodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  if (!parsingCtx.globalReusables.hasOwnProperty('appInsightsCommonCreated')) {
    let appInsightsCommonTechnicalProfile = generateAppInsightsCommonTechnicalProfileFQSchema(
      node,
      journeyId,
      parsingCtx,
      nodes,
    );
    parsingCtx.globalReusables.appInsightsCommonCreated = true;
  }

  let uiTechnicalProfile = generateAppInsightsTechnicalProfileFQSchema(node, journeyId, parsingCtx, nodes);
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    uiTechnicalProfile.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
};

const generateBooleanCopyClaimTransforms = (parsingCtx: JE_ParsingContext, baseXformName: string, srcClaim: string, destClaim: string) => {
  return [
    createFQClaimXform(
      parsingCtx.claimTransformStore,
      {
        id: `${baseXformName}_BoolCopyA`,
        method: 'NotClaims',
        inputClaims: [
          { claimId: srcClaim, xformClaimType: 'inputClaim' }
        ],
        outputClaims: [
          { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanNotBuffer.id), xformClaimType: 'outputClaim' }
        ]
      }
    ).id,
    createFQClaimXform(
      parsingCtx.claimTransformStore,
      {
        id: `${baseXformName}_BoolCopyB`,
        method: 'NotClaims',
        inputClaims: [
          { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanNotBuffer.id), xformClaimType: 'outputClaim' }
        ],
        outputClaims: [
          { claimId: destClaim, xformClaimType: 'outputClaim' }
        ]
      }
    ).id
  ];
}

const generateSetClaimsNodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  submitActionFlow?: JE_SubflowInfo,
) => {
  let nodeData = node.data as JE_SetClaimsNodeData;
  // Step 1: Find any precursor operations needed (such as special claims resolvers).
  let sourceClaims: Set<string> = new Set<string>();
  let intermediateTempVarMap: { [index: string]: string } = {};
  let usesClaimsResolution = false;
  nodeData.claimsToSet.forEach((claimToSet) => {
    if (claimToSet.sourceType === 'resolver') {
      // Also note if claims resolution needs to be enabled.
      if (!Object.keys(jsonXMLConstants.sessionContexts.specials).includes(claimToSet.sourceValue)) {
        usesClaimsResolution = true;
      }
    } else if (claimToSet.sourceType === 'claim') {
      sourceClaims.add(claimToSet.sourceValue);
    } else if (claimToSet.sourceType === 'transform') {
      claimToSet.transformData?.getClaims().forEach(clm => {
        sourceClaims.add(claimToSet.sourceValue);
      })
    }
  });

  // Find all claims that appear in both destination and source and write them all to placeholders first.
  // This method is slightly less efficient in terms of amount of XML and placeholders generated but way simpler than converting to a graph and breaking cycles.
  nodeData.claimsToSet.forEach((claimToSet) => {
    if (sourceClaims.has(claimToSet.claimToSet)) {
      intermediateTempVarMap[claimToSet.claimToSet] = createFQClaim(
        parsingCtx.claimStore,
        {
          id: `${node.sanitizedDisplayName}_${claimToSet.claimToSet}_copy`,
          dataType: parsingCtx.claimStore.claims[claimToSet.claimToSet].dataType,
          displayName: parsingCtx.claimStore.claims[claimToSet.claimToSet].displayName
        }
      ).id;
    }
  });

  // Step 3: If any precursor requirements emerged from steps 1 and 2, generate the precursor TP.
  if (Object.keys(intermediateTempVarMap).length > 0) {
    let precursorTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `${node.sanitizedDisplayName}_Prep`,
        displayName: node.displayName,
        protocol: jsonXMLConstants.customPolicySchema.protocols.claimsTransformation,
        inputClaims: [],
        outputClaims: [],
        outputClaimXformIds: [],
        useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx)
      },
      'SetClaims'
    );
    Object.keys(intermediateTempVarMap).forEach((srcClaimId: string) => {
      precursorTP.inputClaims!.push({
        claimId: srcClaimId
      });
      precursorTP.outputClaims!.push({
        claimId: srcClaimId
      });
      precursorTP.outputClaims!.push({
        claimId: intermediateTempVarMap[srcClaimId]
      });
      if (parsingCtx.claimStore.claims[srcClaimId].dataType === 'string') {
        precursorTP.outputClaimXformIds!.push(
          createStrCopyFormatClaimXform(
            parsingCtx,
            srcClaimId,
            intermediateTempVarMap[srcClaimId]
          )
        );
      } else if (parsingCtx.claimStore.claims[srcClaimId].dataType === 'boolean') {
        generateBooleanCopyClaimTransforms(parsingCtx, node.sanitizedDisplayName, srcClaimId, intermediateTempVarMap[srcClaimId]).forEach((xformId: string) => {
          precursorTP.outputClaimXformIds!.push(xformId);
        });
      }
    })
    addFQOrchestrationStepOrValidationProfileRef(
      parsingCtx,
      node,
      nodes,
      precursorTP.id,
      `${node.sanitizedDisplayName}_PreparationExchange`,
      journeyId,
      branchVarMap,
      preconditions?.slice(),
      submitActionFlow,
    );
  }

  // Step 4: Generate the actual set-claims TP.
  let metadataFields: JE_FQMetadataItemSpec[] = [];
  if (usesClaimsResolution) {
    metadataFields.push({
      key: 'IncludeClaimResolvingInClaimsHandling',
      value: 'true'
    });
  }

  let inputClaims: JE_technicalProfileClaimRef[] = [];
  let outputClaims: JE_technicalProfileClaimRef[] = [];
  let outputXforms: string[] = [];

  nodeData.claimsToSet.forEach((setClaimEntry) => {
    if (setClaimEntry.sourceType === 'claim') {
      let srcClaim = setClaimEntry.sourceValue;
      if (Object.keys(intermediateTempVarMap).includes(setClaimEntry.sourceValue)) {
        srcClaim = intermediateTempVarMap[setClaimEntry.sourceValue];
      }
      inputClaims.push({ claimId: srcClaim });
      if (parsingCtx.claimStore.claims[srcClaim].dataType === 'string') {
        outputXforms.push(createStrCopyFormatClaimXform(parsingCtx, srcClaim, setClaimEntry.claimToSet));
        if (setClaimEntry.defaultValue) {
          outputXforms.push(createStrCopyFormatClaimXform(parsingCtx, srcClaim, getOrCreateStringHandlingBufferClaim(parsingCtx, srcClaim)));
          outputXforms.push(createFQClaimXform(
            parsingCtx.claimTransformStore,
            {
              id: `${node.sanitizedDisplayName}_StringClaimDefaultValueHandler`,
              method: 'SetClaimsIfStringsMatch',
              inputClaims: [
                {
                  claimId: getOrCreateStringHandlingBufferClaim(parsingCtx, srcClaim),
                  xformClaimType: 'claimToMatch'
                }
              ],
              inputParameters: [
                { id: 'matchTo', dataType: 'string', value: '' },
                { id: 'stringComparison', dataType: 'string', value: 'ordinalIgnoreCase' },
                { id: 'outputClaimIfMatched', dataType: 'string', value: setClaimEntry.defaultValue },
              ],
              outputClaims: [
                { claimId: setClaimEntry.claimToSet, xformClaimType: 'outputClaim' },
                { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.strCmpBoolBuf.id), xformClaimType: 'stringCompareResultClaim' }
              ]
            }
          ).id);
        }
        outputClaims.push({ claimId: setClaimEntry.claimToSet });
      } else if (parsingCtx.claimStore.claims[srcClaim].dataType === 'boolean') {
        generateBooleanCopyClaimTransforms(parsingCtx, node.sanitizedDisplayName, srcClaim, setClaimEntry.claimToSet).forEach((xformId: string) => {
          outputXforms.push(xformId);
        });
      }
    } else if (setClaimEntry.sourceType === 'literal') {
      outputClaims.push({ claimId: setClaimEntry.claimToSet, defaultValue: setClaimEntry.sourceValue, alwaysUseDefaultValue: true });
    } else if (setClaimEntry.sourceType === 'resolver') {
      if (Object.keys(constants.sessionContexts.specials).includes(setClaimEntry.sourceValue)) {
        outputClaims.push({ claimId: setClaimEntry.claimToSet });
        outputXforms.push(getOrCreateSSCTransform(parsingCtx, setClaimEntry.sourceValue, setClaimEntry.claimToSet));
      } else {
        if (submitActionFlow) {
          // Handle bizarre undocumented B2C behavior - claims resolvers work only on input claims to ClaimsTransformation profiles inside of a validation TP
          inputClaims.push({ claimId: setClaimEntry.claimToSet, defaultValue: setClaimEntry.sourceValue, alwaysUseDefaultValue: true });
          outputClaims.push({ claimId: setClaimEntry.claimToSet });
        } else {
          outputClaims.push({ claimId: setClaimEntry.claimToSet, defaultValue: setClaimEntry.sourceValue, alwaysUseDefaultValue: true });
        }
      }
    } else if (setClaimEntry.sourceType === 'transform') {
      setClaimEntry.transformData!.getClaims().forEach(srcClaim => {
        inputClaims.push({ claimId: srcClaim });
      });
      outputXforms.push(createFQClaimXform(
        parsingCtx.claimTransformStore,
        setClaimEntry.transformData!.makeTransform(node.sanitizedDisplayName, setClaimEntry.claimToSet, intermediateTempVarMap)
      ).id);
      outputClaims.push({ claimId: setClaimEntry.claimToSet });
    }
  });

  let setClaimsTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      metadata: metadataFields,
      inputClaims: inputClaims,
      outputClaims: outputClaims,
      outputClaimXformIds: outputXforms,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx)
    },
    'SetClaims'
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    setClaimsTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    submitActionFlow,
    nodeData.claimsToSet.map((claimToSet) => {
      return claimToSet.claimToSet;
    })
  )
}

const generateBooleanAccumulatorClaimsAndTransforms = (
  parsingCtx: JE_ParsingContext,
  claimIdsToAccumulate: string[],
  finalDestClaimId: string,
  xformIdArray: string[],
  tempClaimIDPrefix: string,
  tempClaimDisplayNamePrefix: string,
  tempTransformIDPrefix: string,
  transformOp: string,
) => {
  let lastSourceClaimId: string = claimIdsToAccumulate[0];
  for (let i = 1; i < claimIdsToAccumulate.length - 1; i++) {
    let nextClaimId = createFQClaim(parsingCtx.claimStore, {
      id: `${tempClaimIDPrefix}${parsingCtx.claimStore.claimIds.size}`,
      displayName: `${tempClaimDisplayNamePrefix} ${parsingCtx.claimStore.claimIds.size}`,
      dataType: 'boolean',
    }).id;
    xformIdArray.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${tempTransformIDPrefix}${parsingCtx.claimTransformStore.claimXformIds.size}`,
        method: transformOp,
        inputClaims: [
          { claimId: lastSourceClaimId, xformClaimType: 'inputClaim1' },
          { claimId: claimIdsToAccumulate[i], xformClaimType: 'inputClaim2' },
        ],
        outputClaims: [{ claimId: nextClaimId, xformClaimType: 'outputClaim' }],
      }).id,
    );
    lastSourceClaimId = nextClaimId;
  }
  xformIdArray.push(
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${tempTransformIDPrefix}${parsingCtx.claimTransformStore.claimXformIds.size}`,
      method: transformOp,
      inputClaims: [
        { claimId: lastSourceClaimId, xformClaimType: 'inputClaim1' },
        { claimId: claimIdsToAccumulate[claimIdsToAccumulate.length - 1], xformClaimType: 'inputClaim2' },
      ],
      outputClaims: [{ claimId: finalDestClaimId, xformClaimType: 'outputClaim' }],
    }).id,
  );
};

const generateInPlaceStringCoercionXforms = (
  parsingCtx: JE_ParsingContext,
  baseClaimId: string,
  xformIdBase: string,
) => {
  let xformIds: string[] = [];
  xformIds.push(
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${xformIdBase}_StrCoerceA`,
      method: 'FormatStringClaim',
      inputClaims: [{ claimId: baseClaimId, xformClaimType: 'inputClaim' }],
      inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}' }],
      outputClaims: [
        { claimId: getOrCreateStringHandlingBufferClaim(parsingCtx, baseClaimId), xformClaimType: 'outputClaim' },
      ],
    }).id,
  );
  xformIds.push(
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${xformIdBase}_StrCoerceB`,
      method: 'FormatStringClaim',
      inputClaims: [
        { claimId: getOrCreateStringHandlingBufferClaim(parsingCtx, baseClaimId), xformClaimType: 'inputClaim' },
      ],
      inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}' }],
      outputClaims: [{ claimId: baseClaimId, xformClaimType: 'outputClaim' }],
    }).id,
  );
  return xformIds;
};

const generateConditionalNodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  submitActionFlow?: JE_SubflowInfo,
) => {
  if (node.children.length > 1) {
    // It's possible to make a conditional node with both sides leading to the same node, in which case it will have been simplified to 1 child. In this case the conditional node should be skipped.
    let nodeData = node.data as JE_ConditionalNodeData;
    let xformIds: string[] = [];
    let groupClaimIds: string[] = [];
    let inputClaimIds: Set<string> = new Set();
    let resolverClaimIds: { [index: string]: string } = {};
    let booleanTrueConstant: string | null = null;
    let finalConditionClaimId: string = '';
    let specialSessionContexts: Set<string> = new Set();

    nodeData.conditionGroups.forEach((group: JE_Conditional_ConditionGroup, gidx) => {
      let conditionClaimIds: string[] = [];
      group.conditions.forEach((condition: JE_Conditional_Condition, idx) => {
        // Build the individual condition's supporting claims and transform.
        let baseClaimId = condition.claimSrc;
        let claimType = parsingCtx.claimStore.claims[baseClaimId].dataType;
        // Special case for null-string comparisons, coerce non-existing claims and null claims to empty string.
        inputClaimIds.add(baseClaimId);
        if (condition.compareTo === 'claim') {
          inputClaimIds.add(condition.compareValue as string);
          // Check that the data types of the claims match.
          if (
            parsingCtx.claimStore.claims[baseClaimId].dataType !==
            parsingCtx.claimStore.claims[condition.compareValue as string].dataType
          ) {
            throw `Invalid condition: comparison between claims of different data types in node ${node.nodeId}`;
          }
        }
        let conditionClaimId = createFQClaim(parsingCtx.claimStore, {
          id: `${node.sanitizedDisplayName}_Condition${idx}`,
          displayName: `Conditional Evaluation Temp Condition ${parsingCtx.claimStore.claimIds.size}`,
          dataType: 'boolean',
        }).id;
        conditionClaimIds.push(conditionClaimId);
        if (claimType === 'string') {
          // Coerce input string to empty string, if nonexistent or null
          generateInPlaceStringCoercionXforms(
            parsingCtx,
            baseClaimId,
            `${node.sanitizedDisplayName}_Condition${idx}_Input`,
          ).forEach((tid) => {
            xformIds.push(tid);
          });
          if (condition.operator === 'contains') {
            xformIds.push(createFQClaimXform(
              parsingCtx.claimTransformStore,
              {
                id: `${node.sanitizedDisplayName}_Condition${idx}_StrContains`,
                method: 'StringContains',
                inputClaims: [
                  { claimId: baseClaimId, xformClaimType: 'inputClaim' }
                ],
                inputParameters: [
                  { id: 'contains', dataType: 'string', value: condition.compareValue as string },
                  { id: 'ignoreCase', dataType: 'string', value: condition.ignoreCase!.toString() }
                ],
                outputClaims: [
                  { claimId: conditionClaimId, xformClaimType: 'outputClaim' }
                ]
              }
            ).id);
          } else {
            if (condition.compareTo === 'claim' || condition.compareTo === 'sessionContext') {
              let targetClaimId: string = '';
              if (condition.compareTo === 'sessionContext') {
                if (resolverClaimIds.hasOwnProperty(condition.compareValue as string)) {
                  targetClaimId = resolverClaimIds[condition.compareValue as string];
                } else {
                  if (isRealResolver(condition.compareValue as string)) {
                    targetClaimId = createFQClaim(parsingCtx.claimStore, {
                      id: `${node.sanitizedDisplayName}_Condition${idx}_ResolverBuffer`,
                      displayName: `Conditional Evaluation Claims Resolver ${parsingCtx.claimStore.claimIds.size}`,
                      dataType: 'string',
                    }).id;
                    resolverClaimIds[condition.compareValue as string] = targetClaimId;
                  } else if (isSpecialResolver(condition.compareValue as string)) {
                    targetClaimId = getOrCreateSpecialClaim(
                      parsingCtx,
                      constants.sessionContexts.specials[
                        condition.compareValue as keyof typeof constants.sessionContexts.specials
                      ].claimId,
                    );
                    specialSessionContexts.add(condition.compareValue as string);
                  }
                }
              } else {
                // Also coerce other claim to empty string.
                targetClaimId = condition.compareValue as string;
                generateInPlaceStringCoercionXforms(
                  parsingCtx,
                  targetClaimId,
                  `${node.sanitizedDisplayName}_Condition${idx}_Compare`,
                ).forEach((tid) => {
                  xformIds.push(tid);
                });
              }
              xformIds.push(
                createFQClaimXform(parsingCtx.claimTransformStore, {
                  id: `${node.sanitizedDisplayName}_Condition${idx}_Strcmp`,
                  method: 'CompareClaims',
                  inputClaims: [
                    { claimId: baseClaimId, xformClaimType: 'inputClaim1' },
                    { claimId: targetClaimId, xformClaimType: 'inputClaim2' },
                  ],
                  inputParameters: [
                    { id: 'operator', dataType: 'string', value: condition.operator === '==' ? 'equal' : 'not equal' },
                    { id: 'ignoreCase', dataType: 'string', value: condition.ignoreCase!.toString() },
                  ],
                  outputClaims: [{ claimId: conditionClaimId, xformClaimType: 'outputClaim' }],
                }).id,
              );
            } else if (condition.compareTo === 'literal') {
              xformIds.push(
                createFQClaimXform(parsingCtx.claimTransformStore, {
                  id: `${node.sanitizedDisplayName}_Condition${idx}_Strcmp`,
                  method: 'CompareClaimToValue',
                  inputClaims: [{ claimId: baseClaimId, xformClaimType: 'inputClaim1' }],
                  inputParameters: [
                    { id: 'compareTo', dataType: 'string', value: condition.compareValue as string },
                    { id: 'operator', dataType: 'string', value: condition.operator === '==' ? 'equal' : 'not equal' },
                    { id: 'ignoreCase', dataType: 'string', value: condition.ignoreCase!.toString() },
                  ],
                  outputClaims: [{ claimId: conditionClaimId, xformClaimType: 'outputClaim' }],
                }).id,
              );
            }
          }
        } else if (claimType === 'boolean') {
          if (condition.compareTo === 'claim') {
            let booleanComparisonXformIds: string[] = [];
            if (condition.operator === '==') {
              booleanComparisonXformIds = generateBooleanEqualsComparisonTransforms(
                baseClaimId,
                condition.compareValue as string,
                conditionClaimId,
                parsingCtx,
              );
            } else {
              booleanComparisonXformIds = generateBooleanNotEqualsComparisonTransforms(
                baseClaimId,
                condition.compareValue as string,
                conditionClaimId,
                parsingCtx,
              );
            }
            booleanComparisonXformIds.forEach((bcxfId: string) => {
              xformIds.push(bcxfId);
            });
          } else if (condition.compareTo === 'literal') {
            if (
              (condition.compareValue.toString() === 'true' && condition.operator === '==') ||
              (condition.compareValue.toString() === 'false' && condition.operator === '!=')
            ) {
              booleanTrueConstant = getOrCreateTrueBooleanConstant(parsingCtx);
              xformIds.push(
                createFQClaimXform(parsingCtx.claimTransformStore, {
                  id: `${node.sanitizedDisplayName}_Condition${idx}_Boolcmp`,
                  method: 'AndClaims',
                  inputClaims: [
                    { claimId: baseClaimId, xformClaimType: 'inputClaim1' },
                    { claimId: booleanTrueConstant, xformClaimType: 'inputClaim2' },
                  ],
                  outputClaims: [{ claimId: conditionClaimId, xformClaimType: 'outputClaim' }],
                }).id,
              );
            } else {
              xformIds.push(
                createFQClaimXform(parsingCtx.claimTransformStore, {
                  id: `${node.sanitizedDisplayName}_Condition${idx}_Boolcmp`,
                  method: 'NotClaims',
                  inputClaims: [{ claimId: baseClaimId, xformClaimType: 'inputClaim' }],
                  outputClaims: [{ claimId: conditionClaimId, xformClaimType: 'outputClaim' }],
                }).id,
              );
            }
          }
        } else if (claimType === 'dateTime') {
          let offset = condition.dateTimeOffset ? condition.dateTimeOffset : 0;
          if (condition.operator === 'exists' || condition.operator === 'does not exist') {
            let eqTarget = conditionClaimId;
            if (condition.operator === 'does not exist') {
              eqTarget = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanNotBuffer.id);
            }
            xformIds.push(
              createFQClaimXform(parsingCtx.claimTransformStore, {
                id: `${node.sanitizedDisplayName}_Condition${idx}_DatetimeExists`,
                method: 'DoesClaimExist',
                inputClaims: [{ claimId: condition.claimSrc, xformClaimType: 'inputClaim' }],
                outputClaims: [{ claimId: eqTarget, xformClaimType: 'outputClaim' }],
              }).id,
            );
            if (condition.operator === 'does not exist') {
              xformIds.push(
                createFQClaimXform(parsingCtx.claimTransformStore, {
                  id: `${node.sanitizedDisplayName}_Condition${idx}_DatetimeNotExists`,
                  method: 'NotClaims',
                  inputClaims: [{ claimId: eqTarget, xformClaimType: 'inputClaim' }],
                  outputClaims: [{ claimId: conditionClaimId, xformClaimType: 'outputClaim' }],
                }).id,
              );
            }
          } else {
            if (condition.compareTo === 'claim') {
              xformIds.push(
                createFQClaimXform(parsingCtx.claimTransformStore, {
                  id: `${node.sanitizedDisplayName}_Condition${idx}_Datetimecmp`,
                  method: 'DateTimeComparison',
                  inputClaims: [
                    { claimId: condition.claimSrc, xformClaimType: 'firstDateTime' },
                    { claimId: condition.compareValue as string, xformClaimType: 'secondDateTime' },
                  ],
                  inputParameters: [
                    { id: 'timeSpanInSeconds', dataType: 'int', value: offset.toString() },
                    {
                      id: 'operator',
                      dataType: 'string',
                      value:
                        condition.operator === '=='
                          ? 'same'
                          : condition.operator === '>='
                            ? 'later than'
                            : 'earlier than',
                    },
                  ],
                  outputClaims: [{ claimId: conditionClaimId, xformClaimType: 'result' }],
                }).id,
              );
            } else if (condition.compareTo === 'sessionContext') {
              if (isSpecialResolver(condition.compareValue as string)) {
                specialSessionContexts.add(condition.compareValue as string);
                xformIds.push(
                  createFQClaimXform(parsingCtx.claimTransformStore, {
                    id: `${node.sanitizedDisplayName}_Condition${idx}_Datetimecmp`,
                    method: 'DateTimeComparison',
                    inputClaims: [
                      { claimId: condition.claimSrc, xformClaimType: 'firstDateTime' },
                      {
                        claimId: getOrCreateSpecialClaim(
                          parsingCtx,
                          constants.sessionContexts.specials[
                            condition.compareValue as keyof typeof constants.sessionContexts.specials
                          ].claimId,
                        ),
                        xformClaimType: 'secondDateTime',
                      },
                    ],
                    inputParameters: [
                      { id: 'timeSpanInSeconds', dataType: 'int', value: offset.toString() },
                      {
                        id: 'operator',
                        dataType: 'string',
                        value:
                          condition.operator === '=='
                            ? 'same'
                            : condition.operator === '>='
                              ? 'later than'
                              : 'earlier than',
                      },
                    ],
                    outputClaims: [{ claimId: conditionClaimId, xformClaimType: 'result' }],
                  }).id,
                );
              } else {
                throw 'Unsupported resolver comparison for dateTime claim';
              }
            } else {
              throw 'Unsupported comparison target for data type in conditional';
            }
          }
        }
      });
      // Now && up the conditions. If there is only one, we don't need to generate any ANDs to combine, so just pass the claim ID on in that case.
      if (conditionClaimIds.length > 1) {
        let groupClaimId = createFQClaim(parsingCtx.claimStore, {
          id: `${node.sanitizedDisplayName}_ConditionGroup${gidx}`,
          displayName: `Conditional Evaluation Temp Group ${parsingCtx.claimStore.claimIds.size}`,
          dataType: 'boolean',
        }).id;
        generateBooleanAccumulatorClaimsAndTransforms(
          parsingCtx,
          conditionClaimIds,
          groupClaimId,
          xformIds,
          `${node.sanitizedDisplayName}_ConditionGroup${gidx}_BoolAccumulator`,
          'Conditional Evaluation Temp GroupAcc',
          `${node.sanitizedDisplayName}_ConditionGroup${gidx}_AndAccumulate`,
          'AndClaims',
        );
        groupClaimIds.push(groupClaimId);
      } else {
        groupClaimIds.push(conditionClaimIds[0]);
      }
    });
    // Now || up the groups. If there is only one, don't need to generate any ORs and can just pass on the sole group claim ID.
    if (groupClaimIds.length > 1) {
      finalConditionClaimId = createFQClaim(parsingCtx.claimStore, {
        id: `${node.sanitizedDisplayName}_ConditionalResult`,
        displayName: `Conditional Evaluation Temp Final ${parsingCtx.claimStore.claimIds.size}`,
        dataType: 'boolean',
      }).id;
      generateBooleanAccumulatorClaimsAndTransforms(
        parsingCtx,
        groupClaimIds,
        finalConditionClaimId,
        xformIds,
        `${node.sanitizedDisplayName}_ConditionalResult_BoolAccumulator`,
        'Conditional Evaluation Temp FinalAcc',
        `${node.sanitizedDisplayName}_ConditionalResult_OrAccumulate`,
        'OrClaims',
      );
    } else {
      finalConditionClaimId = groupClaimIds[0];
    }
    let intermediateOutputClaimId = node.childBranchVars[1]
      ? node.childBranchVars[1]!
      : createFQClaim(parsingCtx.claimStore, {
        id: `${node.sanitizedDisplayName}_ConditionalBranchBuffer`,
        displayName: `Conditional Evaluation Temporary ${parsingCtx.claimStore.claimIds.size}`,
        dataType: 'boolean',
      }).id;
    let finalOutputClaimId = node.childBranchVars[0];
    let outputClaimsList: JE_technicalProfileClaimRef[] = [];
    let branchVarOutputClaimIds: string[] = [];
    Object.keys(resolverClaimIds).forEach((resolver: string) => {
      outputClaimsList.push({
        claimId: resolverClaimIds[resolver],
        defaultValue: resolver,
        alwaysUseDefaultValue: true,
      });
    });
    if (booleanTrueConstant) {
      outputClaimsList.push({ claimId: booleanTrueConstant, defaultValue: 'true', alwaysUseDefaultValue: true });
    }
    if (node.childBranchVars[0]) {
      outputClaimsList.push({ claimId: node.childBranchVars[0] });
      branchVarOutputClaimIds.push(node.childBranchVars[0]);
    }
    if (node.childBranchVars[1]) {
      outputClaimsList.push({ claimId: node.childBranchVars[1] });
      branchVarOutputClaimIds.push(node.childBranchVars[1]);
    }
    inputClaimIds.forEach((inputClaimId: string) => {
      let inputDataType = parsingCtx.claimStore.claims[inputClaimId].dataType;
      if (constants.defaultClaimValues.hasOwnProperty(inputDataType)) {
        let defaultValue = constants.defaultClaimValues[inputDataType as keyof typeof constants.defaultClaimValues];
        outputClaimsList.push({ claimId: inputClaimId, defaultValue: defaultValue });
      }
    });
    xformIds.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${node.sanitizedDisplayName}_SetFalseBranchVar`,
        method: 'NotClaims',
        inputClaims: [{ claimId: finalConditionClaimId, xformClaimType: 'inputClaim' }],
        outputClaims: [{ claimId: intermediateOutputClaimId, xformClaimType: 'outputClaim' }],
      }).id,
    );
    if (finalOutputClaimId) {
      xformIds.push(
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_SetTrueBranchVar`,
          method: 'NotClaims',
          inputClaims: [{ claimId: intermediateOutputClaimId, xformClaimType: 'inputClaim' }],
          outputClaims: [{ claimId: finalOutputClaimId!, xformClaimType: 'outputClaim' }],
        }).id,
      );
    }
    if (specialSessionContexts.size > 0) {
      let sscTP = generateSpecialSessionContextPrefiller(parsingCtx, node, nodes, specialSessionContexts);
      addFQOrchestrationStepOrValidationProfileRef(
        parsingCtx,
        node,
        nodes,
        sscTP.id,
        `${node.sanitizedDisplayName}_SpecialSessionContextPrefillExchange`,
        journeyId,
        branchVarMap,
        preconditions?.slice(),
        submitActionFlow,
      );
    }
    let metadata: JE_FQMetadataItemSpec[] = [];
    if (Object.keys(resolverClaimIds).length > 0) {
      metadata.push({
        key: 'IncludeClaimResolvingInClaimsHandling',
        value: 'true',
      });
    }
    let conditionalTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: node.sanitizedDisplayName,
        displayName: node.displayName,
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        metadata: metadata,
        outputClaims: outputClaimsList,
        outputClaimXformIds: xformIds,
        useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
      },
      'Conditional Handling',
    );
    if (settings.outputExtraBranchVarInfo) {
      node.childBranchVars.forEach((childBranchVar) => {
        if (childBranchVar) {
          parsingCtx.branchVarMetadata[childBranchVar].setInProfiles.add(conditionalTP.id);
        }
      });
    }
    addFQOrchestrationStepOrValidationProfileRef(
      parsingCtx,
      node,
      nodes,
      conditionalTP.id,
      `${node.sanitizedDisplayName}_ClaimsExchange`,
      journeyId,
      branchVarMap,
      preconditions?.slice(),
      submitActionFlow,
      branchVarOutputClaimIds,
    );
  }
};

export const generateUsernamePasswordValidationFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  submitActionFlow: JE_SubflowInfo,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_UsernamePasswordValidationNodeData;
  let metadataFields = [
    { key: 'ProviderName', value: 'https://sts.windows.net/' },
    { key: 'METADATA', value: 'https://login.microsoftonline.com/{tenant}/.well-known/openid-configuration' },
    { key: 'authorization_endpoint', value: 'https://login.microsoftonline.com/{tenant}/oauth2/token' },
    { key: 'response_types', value: 'id_token' },
    { key: 'response_mode', value: 'query' },
    { key: 'scope', value: 'email openid' },
    { key: 'UsePolicyInRedirectUri', value: 'false' },
    { key: 'HttpBinding', value: 'POST' },
    { key: 'client_id', value: nodeData.clientId },
    { key: 'IdTokenAudience', value: nodeData.resourceId },
  ];
  if (nodeData.errorMessage) {
    metadataFields.unshift({ key: 'UserMessageIfClaimsPrincipalDoesNotExist', value: nodeData.errorMessage });
    metadataFields.unshift({ key: 'UserMessageIfInvalidPassword', value: nodeData.errorMessage });
  }
  let upvTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.openIdConnect,
      metadata: metadataFields,
      inputClaims: [
        { claimId: nodeData.userIdClaim, partnerClaimType: nodeData.userIdType, required: true },
        { claimId: 'password', required: true },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.grant_type.id),
          partnerClaimType: constants.specialClaims.grant_type.id,
          defaultValue: 'Password',
          alwaysUseDefaultValue: true,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.scope.id),
          partnerClaimType: constants.specialClaims.scope.id,
          defaultValue: 'openid',
          alwaysUseDefaultValue: true,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.nca.id),
          partnerClaimType: constants.specialClaims.nca.id,
          defaultValue: '1',
          alwaysUseDefaultValue: true,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.client_id.id),
          partnerClaimType: constants.specialClaims.client_id.id,
          defaultValue: nodeData.clientId,
          alwaysUseDefaultValue: true,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.resource_id.id),
          partnerClaimType: 'resource',
          defaultValue: nodeData.resourceId,
          alwaysUseDefaultValue: true,
        },
      ],
      outputClaims: [
        { claimId: nodeData.objectIdClaim, partnerClaimType: 'oid' },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.strCmpBuffer.id),
          defaultValue: 'Password',
          alwaysUseDefaultValue: true,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.estsRequestId.id),
          defaultValue: '00000000-0000-0000-0000-000000000000',
          partnerClaimType: 'estsRequestId',
        },
      ],
      outputClaimXformIds: [
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_makeAuthMethodsCollection`,
          method: 'AddItemToStringCollection',
          inputClaims: [
            {
              claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.strCmpBuffer.id),
              xformClaimType: 'item',
            },
            {
              claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.authMethodsUsedForCA.id),
              xformClaimType: 'collection',
            },
          ],
          outputClaims: [
            {
              claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.authMethodsUsedForCA.id),
              xformClaimType: 'collection',
            },
          ],
        }).id,
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    constants.claimsProviderNames.usernamePasswordValidation,
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    upvTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange_SHOULD_NOT_APPEAR`,
    journeyId,
    branchVarMap,
    preconditions,
    submitActionFlow,
    [nodeData.objectIdClaim, getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.authMethodsUsedForCA.id)],
  );
};

export const generateRestAPINodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  submitActionFlow?: JE_SubflowInfo,
) => {
  let nodeData = node.data as JE_RESTNodeData;
  let advanceNeededClaims = collectAdvanceNeededClaimsRestNode(node, nodes, parsingCtx);
  generateAdvanceNeededClaimsInitializationStep(
    parsingCtx,
    node,
    nodes,
    advanceNeededClaims,
    journeyId,
    branchVarMap,
    preconditions,
    submitActionFlow,
  );
  let metadata: JE_FQMetadataItemSpec[] = [
    { key: 'ServiceUrl', value: nodeData.serviceURL },
    { key: 'AuthenticationType', value: constants.restAuthTypes[nodeData.authType as keyof typeof constants.restAuthTypes].policyAuthType },
    { key: 'SendClaimsIn', value: nodeData.sendClaimsIn }
  ];
  if (constants.restAuthTypes[nodeData.authType as keyof typeof constants.restAuthTypes].allowInsecureAuthInProduction) {
    metadata.push({ key: 'AllowInsecureAuthInProduction', value: 'true' });
  }
  let usingResolvers = nodeData.inputParameters.some((inp) => {
    return inp.sourceType === 'resolver' && isRealResolver(inp.sourceValue);
  });
  if (usingResolvers) {
    metadata.push({ key: 'IncludeClaimResolvingInClaimsHandling', value: 'true' });
  }
  if (
    nodeData.outputParameters.some((inp) => {
      return inp.sourceType === 'resolver';
    })
  ) {
    throw 'Illegal claim mapping in REST API component: claims resolvers cannot be used as output destinations';
  }
  let inputDefaultValues = nodeData.inputParameters.filter((inp) => {
    return (
      inp.sourceType === 'claim' &&
      inp.defaultValue &&
      inp.defaultValue.length > 0 &&
      !inp.alwaysUseDefaultValue &&
      inp.sourceValue &&
      parsingCtx.claimStore.claims[inp.sourceValue].dataType === 'string'
    );
  });
  let inputXformIds: string[] = [];
  if (inputDefaultValues.length > 0) {
    // Create advance default prep stage - string claims with optional default values need special handling to apply these defaults to initialized but empty claims.
    inputDefaultValues.forEach((inpd, idx) => {
      inputXformIds.push(
        createStrCopyFormatClaimXform(
          parsingCtx,
          inpd.sourceValue,
          getOrCreateStringHandlingBufferClaim(parsingCtx, inpd.sourceValue),
        ),
      );
      inputXformIds.push(
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_InputDefaultValueHandler${idx}`,
          method: 'SetClaimsIfStringsMatch',
          inputClaims: [
            {
              claimId: getOrCreateStringHandlingBufferClaim(parsingCtx, inpd.sourceValue),
              xformClaimType: 'claimToMatch',
            },
          ],
          inputParameters: [
            { id: 'matchTo', dataType: 'string', value: '' },
            { id: 'stringComparison', dataType: 'string', value: 'ordinalIgnoreCase' },
            { id: 'outputClaimIfMatched', dataType: 'string', value: inpd.defaultValue! },
          ],
          outputClaims: [
            { claimId: inpd.sourceValue, xformClaimType: 'outputClaim' },
            {
              claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.strCmpBoolBuf.id),
              xformClaimType: 'stringCompareResultClaim',
            },
          ],
        }).id,
      );
    });
  }

  let specialResolverMap: { [index: string]: string } = {};
  let specialResolversCreated: Set<string> = new Set();
  nodeData.inputParameters
    .filter((inp) => {
      // Handle special resolvers
      return inp.sourceType === 'resolver' && isSpecialResolver(inp.sourceValue);
    })
    .forEach((inp) => {
      let targetClaimId = getOrCreateSpecialClaim(
        parsingCtx,
        constants.sessionContexts.specials[inp.sourceValue as keyof typeof constants.sessionContexts.specials].claimId,
      );
      if (!specialResolversCreated.has(targetClaimId)) {
        specialResolversCreated.add(targetClaimId);
        inputXformIds.push(getOrCreateSSCTransform(parsingCtx, inp.sourceValue));
      }
      specialResolverMap[inp.partnerClaimType] = targetClaimId;
    });

  let cryptographicKeys: JE_CryptographicKeyRef[] = [];
  let inClaims: JE_technicalProfileClaimRef[] = nodeData.inputParameters.map((inp) => {
    let iRef: JE_technicalProfileClaimRef = {};
    if (inp.sourceType === 'claim') {
      iRef.claimId = inp.sourceValue;
      if ((inp.defaultValue !== undefined) && (!constants.noDefaultClaimTypes.includes(parsingCtx.claimStore.claims[inp.sourceValue].dataType))) {
        iRef.defaultValue = inp.defaultValue;
      }
      if (inp.alwaysUseDefaultValue !== undefined) {
        iRef.alwaysUseDefaultValue = inp.alwaysUseDefaultValue;
      }
      if (inp.partnerClaimType && inp.partnerClaimType !== inp.sourceValue) {
        iRef.partnerClaimType = inp.partnerClaimType;
      }
    } else if (inp.sourceType === 'resolver') {
      if (isSpecialResolver(inp.sourceValue)) {
        iRef.claimId = specialResolverMap[inp.partnerClaimType];
        iRef.partnerClaimType = inp.partnerClaimType;
      } else {
        iRef.claimId = createFQClaim(parsingCtx.claimStore, {
          id: `${node.sanitizedDisplayName}_ResolverBuffer`,
          displayName: `${node.displayName} Resolver Buffer`,
          dataType: 'string',
        }).id;
        iRef.defaultValue = inp.sourceValue;
        iRef.alwaysUseDefaultValue = true;
        iRef.partnerClaimType = inp.partnerClaimType;
      }
    } else {
      throw 'Invalid source type for REST API mapping';
    }
    return iRef;
  });
  if (nodeData.authType === constants.restAuthTypes.aadBearer.id) {
    let aadAccessTokenClaimId = getOrCreateAADAccessTokenClaim(parsingCtx, nodeData.clientIdContainerName!, nodeData.clientSecretContainerName!);
    inClaims.unshift({ claimId: aadAccessTokenClaimId });
    metadata.push({ key: 'UseClaimAsBearerToken', value: aadAccessTokenClaimId });
  } else if (nodeData.authType === constants.restAuthTypes.clientCert.id) {
    cryptographicKeys.push({
      id: 'ClientCertificate',
      storageReferenceId: nodeData.clientCertContainerName!
    });
  }

  let restTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: metadata,
      cryptographicKeys: cryptographicKeys,
      inputClaimXformIds: inputXformIds,
      inputClaims: inClaims,
      outputClaims: nodeData.outputParameters.map((out) => {
        let oRef: JE_technicalProfileClaimRef = {
          claimId: out.sourceValue,
        };
        if (out.defaultValue !== undefined) {
          oRef.defaultValue = out.defaultValue;
        }
        if (out.alwaysUseDefaultValue !== undefined) {
          oRef.alwaysUseDefaultValue = out.alwaysUseDefaultValue;
        }
        if (out.partnerClaimType && out.partnerClaimType !== out.sourceValue) {
          oRef.partnerClaimType = out.partnerClaimType;
        }
        return oRef;
      }),
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'REST',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    restTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    submitActionFlow,
    restTP.outputClaims?.map((oc) => {
      return oc.claimId!;
    }),
  );
};

const generateMFANodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  // The MFA node doesn't play well with our programming model in that it has defined behaviors if the input phone number claims are nonexistant
  // but will throw an exception if they are empty string ("") or NULL, so we need to copy conditionally into a dedicated fresh buffer claim so it
  // won't exist if empty.
  let nodeData = node.data as JE_MFANodeData;
  let advanceNeededClaims = collectAdvanceNeededClaimsMFANode(node);
  generateAdvanceNeededClaimsInitializationStep(
    parsingCtx,
    node,
    nodes,
    advanceNeededClaims,
    journeyId,
    branchVarMap,
    preconditions,
  );
  // Now handle the actual MFA step.
  let phoneNumberBufferDraftClaim: JE_FQClaimSpec = {
    id: `${node.sanitizedDisplayName}_InputPhoneNumberBuffer`,
    displayName: nodeData.phoneNumberInputClaimId
      ? parsingCtx.claimStore.claims[nodeData.phoneNumberInputClaimId].displayName
      : 'Phone Number',
    dataType: 'string',
    predicateValidationReference: getOrCreateNonemptyStringPredicateValidation(parsingCtx),
  };
  if (nodeData.phoneNumberInputClaimId) {
    let originalInputClaim = parsingCtx.claimStore.claims[nodeData.phoneNumberInputClaimId];
    if (originalInputClaim?.mask) {
      phoneNumberBufferDraftClaim.mask = {
        type: originalInputClaim.mask.type,
        value: originalInputClaim.mask.value,
      };
      if (originalInputClaim.mask.type === 'Regex') {
        phoneNumberBufferDraftClaim.mask.regex = originalInputClaim.mask.regex;
      }
    }
  }
  let phoneNumberBufferClaimId = createFQClaim(parsingCtx.claimStore, phoneNumberBufferDraftClaim).id;
  let inputXformIds: string[] = [];
  if (nodeData.numberEntryMode !== 'alwaysNew') {
    inputXformIds.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${node.sanitizedDisplayName}_CopyNumberToInputBuffer`,
        method: 'CopyClaimIfPredicateMatch',
        inputClaims: [{ claimId: nodeData.phoneNumberInputClaimId, xformClaimType: 'inputClaim' }],
        outputClaims: [{ claimId: phoneNumberBufferClaimId, xformClaimType: 'outputClaim' }],
      }).id,
    );
  }

  let metadataFields: JE_FQMetadataItemSpec[] = [
    { key: 'ManualPhoneNumberEntryAllowed', value: (nodeData.numberEntryMode !== 'existingOnly').toString() },
  ];
  if (nodeData.contentDefinitionUrl) {
    let draftCD: JE_FQContentDefinitionSpec = {
      id: `${node.displayName}_ContentDefinition`,
      loadUri: nodeData.contentDefinitionUrl,
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:multifactor:1.2.5',
      metadata: [{ key: 'DisplayName', value: 'Multi-factor Authentication Page' }],
    };
    if (settings.includeDefaultLocalization) {
      draftCD.localizedResourcesReferences = {
        mergeBehavior: 'Prepend',
        references: [{ language: 'en', referenceId: 'api.phonefactor.en' }],
      };
    }
    metadataFields.push({
      key: 'ContentDefinitionReferenceId',
      value: getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.phonefactor').id,
    });
  } else {
    metadataFields.push({
      key: 'ContentDefinitionReferenceId',
      value: fetchDefaultFQContentDefinitionRef(parsingCtx, 'api.phonefactor'),
    });
  }
  let mfaUidClaimId = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.userIdForMFA.id);
  let inputClaims: JE_technicalProfileClaimRef[] = [
    { claimId: mfaUidClaimId, partnerClaimType: 'UserId' },
    { claimId: phoneNumberBufferClaimId },
  ];
  inputXformIds.push(
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_BuildMFAUserID`,
      method: 'FormatStringClaim',
      inputClaims: [{ claimId: nodeData.idClaimId, xformClaimType: 'inputClaim' }],
      inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}@{RelyingPartyTenantId}' }],
      outputClaims: [{ claimId: mfaUidClaimId, xformClaimType: 'outputClaim' }],
    }).id,
  );
  let outputXformIds: string[] = [];
  // newPhoneNumberEntered's actual returned boolean value is basically nonsense. MS AD B2C recommendations (and samples) check the claim's
  // existence rather than its value, so we need to copy whether it exists into the actual intended output flag claim.
  // Because we must check existence, we need to create a new claim every time to guarantee it's not in the claims bag.
  let newNumberEnteredBufferClaimId = createFQClaim(parsingCtx.claimStore, {
    id: `${node.sanitizedDisplayName}_NewNumberEnteredBuffer`,
    displayName: 'New Number Entered Buffer',
    dataType: 'boolean',
  }).id;
  let newNumberOutputBufferClaimDraft: JE_FQClaimSpec = {
    id: `${node.sanitizedDisplayName}_OutputPhoneNumberBuffer`,
    displayName: 'New Number Buffer',
    dataType: 'string',
  };
  let originalOutputPhoneNumberClaim = parsingCtx.claimStore.claims[nodeData.phoneNumberOutputClaimId];
  if (originalOutputPhoneNumberClaim.mask) {
    newNumberOutputBufferClaimDraft.mask = {
      type: originalOutputPhoneNumberClaim.mask.type,
      value: originalOutputPhoneNumberClaim.mask.value,
    };
    if (originalOutputPhoneNumberClaim.mask.type === 'Regex') {
      newNumberOutputBufferClaimDraft.mask.regex = originalOutputPhoneNumberClaim.mask.regex;
    }
  }
  let newNumberOutputBufferClaimId = createFQClaim(parsingCtx.claimStore, newNumberOutputBufferClaimDraft).id;
  outputXformIds.push(
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_SetNewNumberEntered`,
      method: 'DoesClaimExist',
      inputClaims: [{ claimId: newNumberOutputBufferClaimId, xformClaimType: 'inputClaim' }],
      outputClaims: [{ claimId: nodeData.newlyEnteredFlagClaimId, xformClaimType: 'outputClaim' }],
    }).id,
  );
  let postOutputXformIdsA = [
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_CopyOutputNumberFromReturnedNumber`,
      method: 'CopyClaim',
      inputClaims: [{ claimId: newNumberOutputBufferClaimId, xformClaimType: 'inputClaim' }],
      outputClaims: [{ claimId: nodeData.phoneNumberOutputClaimId, xformClaimType: 'outputClaim' }],
    }).id,
  ];
  let postOutputPreconditionsA = preconditions ? preconditions.slice() : [];
  postOutputPreconditionsA.push({
    type: 'ClaimsExist',
    executeActionsIf: false,
    values: [newNumberOutputBufferClaimId],
    action: 'SkipThisOrchestrationStep',
  });
  let postOutputXformIdsB = [
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_CopyOutputNumberFromInputNumber`,
      method: 'CopyClaim',
      inputClaims: [{ claimId: phoneNumberBufferClaimId, xformClaimType: 'inputClaim' }],
      outputClaims: [{ claimId: nodeData.phoneNumberOutputClaimId, xformClaimType: 'outputClaim' }],
    }).id,
  ];
  let postOutputPreconditionsB = preconditions ? preconditions.slice() : [];
  postOutputPreconditionsB.push({
    type: 'ClaimsExist',
    executeActionsIf: true,
    values: [newNumberOutputBufferClaimId],
    action: 'SkipThisOrchestrationStep',
  });
  let mfaNodeTPid = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.phoneFactor,
      metadata: metadataFields,
      cryptographicKeys: [
        {
          id: 'issuer_secret',
          storageReferenceId: extractSettingFieldValue(jsonConstants.defaultAppSettingFields.tokenSigningKeyContainer.id, parsingCtx.buildSettings)
        },
      ],
      inputClaimXformIds: inputXformIds,
      inputClaims: inputClaims,
      outputClaims: [
        { claimId: newNumberOutputBufferClaimId, partnerClaimType: 'Verified.OfficePhone' },
        { claimId: newNumberEnteredBufferClaimId, partnerClaimType: 'newPhoneNumberEntered' },
      ],
      outputClaimXformIds: outputXformIds,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    constants.claimsProviderNames.mfa,
  ).id;
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    mfaNodeTPid,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
  let outNodeTPAid = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_ManuallyEnteredPhoneNumberHandler`,
      displayName: 'MFA output A',
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      outputClaims: [{ claimId: nodeData.phoneNumberOutputClaimId, defaultValue: '' }],
      outputClaimXformIds: postOutputXformIdsA,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'MFA Support',
  ).id;
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    outNodeTPAid,
    `${node.sanitizedDisplayName}_ManuallyEnteredPhoneNumberExchange`,
    journeyId,
    branchVarMap,
    postOutputPreconditionsA,
  );
  let outNodeTPBid = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_SavedPhoneNumberHandler`,
      displayName: 'MFA output B',
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      outputClaims: [{ claimId: nodeData.phoneNumberOutputClaimId, defaultValue: '' }],
      outputClaimXformIds: postOutputXformIdsB,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'MFA Support',
  ).id;
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    outNodeTPBid,
    `${node.sanitizedDisplayName}_SavedPhoneNumberExchange`,
    journeyId,
    branchVarMap,
    postOutputPreconditionsB,
  );
};

const generateWebAuthnRegistrationNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  parsingCtx.userJourneyStore.userJourneys[journeyId].requiresJavascript = true; // Required to implement the appropriate content definitions.
  let nodeData = node.data as JE_WebAuthnRegistrationNodeData;
  let advanceNeededClaims = collectAdvanceNeededClaimsWebAuthnRegistration(node);
  generateAdvanceNeededClaimsInitializationStep(
    parsingCtx,
    node,
    nodes,
    advanceNeededClaims,
    journeyId,
    branchVarMap,
    preconditions,
  );
  let challengeTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_GetChallenge`,
      displayName: 'WebAuthn Registration',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.storageApiUrl}/GetChallenge` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id),
          partnerClaimType: constants.restAPIs.webAuthnGetChallenge.challenge,
        },
        {
          claimId: nodeData.successClaim,
          defaultValue: 'false',
          alwaysUseDefaultValue: true,
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let checkCredentialTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_CheckCredentialPresence`,
      displayName: 'WebAuthn Check Credential Presence',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.storageApiUrl}/GetAuth` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
      ],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRawId.id),
          partnerClaimType: constants.restAPIs.webAuthnGetAuth.authId,
        },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanCopyBufA.id),
          partnerClaimType: constants.restAPIs.webAuthnGetAuth.success,
          defaultValue: 'false',
        },
      ],
      outputClaimXformIds: [
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_InvertCredentialLookupSuccess`,
          method: 'NotClaims',
          inputClaims: [
            {
              claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanCopyBufA.id),
              xformClaimType: 'inputClaim',
            },
          ],
          outputClaims: [{ claimId: nodeData.successClaim, xformClaimType: 'outputClaim' }],
        }).id,
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let makeCredentialTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_MakeCredential`,
      displayName: 'WebAuthn Make Credential',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.credentialApiUrl}` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
        { key: 'IncludeClaimResolvingInClaimsHandling', value: 'true' },
      ],
      inputClaims: [
        { claimId: nodeData.idClaim, partnerClaimType: constants.restAPIs.webAuthnMakeCredential.userHandle },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRPId.id),
          defaultValue: '{Context:HostName}',
          alwaysUseDefaultValue: true,
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.RPId,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRawId.id),
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.rawId,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnClientDataJson.id),
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.clientDataJson,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAttestation.id),
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.attestation,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id),
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.challenge,
        },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnParsedId.id),
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.parsedId,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey1.id),
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.publicKey1,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey2.id),
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.publicKey2,
        },
        {
          claimId: nodeData.successClaim,
          partnerClaimType: constants.restAPIs.webAuthnMakeCredential.success,
          defaultValue: 'false',
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let saveCredentialTPA = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_SaveObjectIdAuthIdMap`,
      displayName: 'WebAuthn Save Credentials',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.storageApiUrl}/SetAuth` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
      ],
      inputClaims: [
        { claimId: nodeData.idClaim, partnerClaimType: constants.restAPIs.webAuthnSetAuth.objectId },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnParsedId.id),
          partnerClaimType: constants.restAPIs.webAuthnSetAuth.authId,
        },
      ],
      outputClaims: [
        {
          claimId: nodeData.successClaim,
          partnerClaimType: constants.restAPIs.webAuthnSetAuth.success,
          defaultValue: 'false',
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let saveCredentialTPB = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_SavePublicKey`,
      displayName: 'WebAuthn Save Credentials',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.storageApiUrl}/SetCert` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
      ],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnParsedId.id),
          partnerClaimType: constants.restAPIs.webAuthnSetCert.authId,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey1.id),
          partnerClaimType: constants.restAPIs.webAuthnSetCert.certPart1,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey2.id),
          partnerClaimType: constants.restAPIs.webAuthnSetCert.certPart2,
        },
      ],
      outputClaims: [
        {
          claimId: nodeData.successClaim,
          partnerClaimType: constants.restAPIs.webAuthnSetCert.success,
          defaultValue: 'false',
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let contentDefinitionKey: string = '';
  if (nodeData.contentDefinitionUrl) {
    let draftCD: JE_FQContentDefinitionSpec = {
      id: `api.webauthn.register`,
      loadUri: nodeData.contentDefinitionUrl,
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: node.displayName }],
    };
    contentDefinitionKey = getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.webauthnreg').id;
  } else {
    contentDefinitionKey = getOrCreateWebAuthnRegistrationContentDefinition(parsingCtx);
  }
  let inputXformIds: string[] = [
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_CopyInputObjectId`,
      method: 'FormatStringClaim',
      inputClaims: [{ claimId: nodeData.idClaim, xformClaimType: 'inputClaim' }],
      inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}' }],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnUserHandle.id),
          xformClaimType: 'outputClaim',
        },
      ],
    }).id,
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_CopyInputNameField`,
      method: 'FormatStringClaim',
      inputClaims: [{ claimId: nodeData.nameClaim, xformClaimType: 'inputClaim' }],
      inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}' }],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnName.id),
          xformClaimType: 'outputClaim',
        },
      ],
    }).id,
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_CopyInputDisplayNameField`,
      method: 'FormatStringClaim',
      inputClaims: [{ claimId: nodeData.displayNameClaim, xformClaimType: 'inputClaim' }],
      inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}' }],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnDisplayName.id),
          xformClaimType: 'outputClaim',
        },
      ],
    }).id,
  ];
  let selfAssertedAuthGetTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.selfAsserted,
      metadata: [
        { key: 'ContentDefinitionReferenceId', value: contentDefinitionKey },
        { key: 'IncludeClaimResolvingInClaimsHandling', value: 'true' },
      ],
      inputClaimXformIds: inputXformIds,
      inputClaims: [
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnUserHandle.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id) },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRPId.id),
          defaultValue: '{Context:HostName}',
          alwaysUseDefaultValue: true,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnDisplayName.id),
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnName.id),
        },
      ],
      displayClaims: [
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRawId.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnClientDataJson.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAttestation.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRPId.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnUserHandle.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnDisplayName.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnName.id) },
      ],
      outputClaims: [
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRawId.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnClientDataJson.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAttestation.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey1.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey2.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnParsedId.id) },
        { claimId: nodeData.successClaim, defaultValue: 'false' },
      ],
      validationTechnicalProfiles: [
        { profileId: checkCredentialTP.id },
        {
          profileId: makeCredentialTP.id,
          preconditions: [
            {
              type: 'ClaimEquals',
              executeActionsIf: false,
              values: [nodeData.successClaim, 'True'],
              action: 'SkipThisValidationTechnicalProfile',
            },
          ],
        },
        {
          profileId: saveCredentialTPA.id,
          preconditions: [
            {
              type: 'ClaimEquals',
              executeActionsIf: false,
              values: [nodeData.successClaim, 'True'],
              action: 'SkipThisValidationTechnicalProfile',
            },
          ],
        },
        {
          profileId: saveCredentialTPB.id,
          preconditions: [
            {
              type: 'ClaimEquals',
              executeActionsIf: false,
              values: [nodeData.successClaim, 'True'],
              action: 'SkipThisValidationTechnicalProfile',
            },
          ],
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    challengeTP.id,
    `${node.sanitizedDisplayName}_GetChallengeExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    selfAssertedAuthGetTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
};

const generateWebAuthnAuthenticationNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  parsingCtx.userJourneyStore.userJourneys[journeyId].requiresJavascript = true; // Required to implement the appropriate content definitions.
  let nodeData = node.data as JE_WebAuthnAuthenticationNodeData;
  let challengeTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_GetChallenge`,
      displayName: 'WebAuthn Authentication',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.storageApiUrl}/GetChallenge` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id),
          partnerClaimType: constants.restAPIs.webAuthnGetChallenge.challenge,
        },
        {
          claimId: nodeData.successClaim,
          defaultValue: 'false',
          alwaysUseDefaultValue: true,
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let getCredentialsTPA = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_LookupObjectIdByAuthId`,
      displayName: 'WebAuthn Get Credentials',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.storageApiUrl}/GetAuth` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
      ],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRawId.id),
          partnerClaimType: constants.restAPIs.webAuthnGetAuth.authId,
        },
      ],
      outputClaims: [
        { claimId: nodeData.idClaim, partnerClaimType: constants.restAPIs.webAuthnGetAuth.objectId },
        {
          claimId: nodeData.successClaim,
          partnerClaimType: constants.restAPIs.webAuthnGetAuth.success,
          defaultValue: 'false',
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let oidCheckBufferClaim = createFQClaim(parsingCtx.claimStore, {
    id: `${node.sanitizedDisplayName}_ObjIdCheckBuffer`,
    displayName: 'ObjectId Buffer',
    dataType: 'string'
  });
  let oidCheckMetadata: JE_FQMetadataItemSpec[] = [
    { key: 'Operation', value: 'Read' },
    { key: 'RaiseErrorIfClaimsPrincipalDoesNotExist', value: 'false' }
  ];
  let extClientId = extractSettingFieldValue(jsonConstants.defaultAppSettingFields.extensionsContainerClientId.id, parsingCtx.buildSettings);
  let extObjectId = extractSettingFieldValue(jsonConstants.defaultAppSettingFields.extensionsContainerObjectId.id, parsingCtx.buildSettings);
  if (extClientId && extObjectId) {
    oidCheckMetadata.push({ key: 'ClientId', value: extClientId });
    oidCheckMetadata.push({ key: 'ApplicationObjectId', value: extObjectId });
  }
  let checkObjectIdXform = createFQClaimXform(parsingCtx.claimTransformStore, {
    id: `${node.sanitizedDisplayName}_ObjIdCheckXform`,
    method: 'DoesClaimExist',
    inputClaims: [
      { claimId: oidCheckBufferClaim.id, xformClaimType: 'inputClaim' }
    ],
    outputClaims: [
      { claimId: nodeData.successClaim, xformClaimType: 'outputClaim' }
    ]
  });
  let checkObjectIdTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_CheckObjectId`,
      displayName: 'WebAuthn Get Credentials',
      protocol: constants.customPolicySchema.protocols.AAD,
      metadata: oidCheckMetadata,
      inputClaims: [
        { claimId: nodeData.idClaim, partnerClaimType: 'objectId' }
      ],
      outputClaims: [
        { claimId: oidCheckBufferClaim.id, partnerClaimType: 'objectId' }
      ],
      outputClaimXformIds: [checkObjectIdXform.id]
    },
    constants.claimsProviderNames.webauthnObjectIdCheck
  );
  let getCredentialsTPB = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_LookupPublicKey`,
      displayName: 'WebAuthn Get Credentials',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.storageApiUrl}/GetCert` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
      ],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRawId.id),
          partnerClaimType: constants.restAPIs.webAuthnGetCert.authId,
        },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey1.id),
          partnerClaimType: constants.restAPIs.webAuthnGetCert.certPart1,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey2.id),
          partnerClaimType: constants.restAPIs.webAuthnGetCert.certPart2,
        },
        {
          claimId: nodeData.successClaim,
          partnerClaimType: constants.restAPIs.webAuthnGetCert.success,
          defaultValue: 'false',
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let checkAssertionTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_CheckAssertion`,
      displayName: 'WebAuthn Check Assertion',
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: `${nodeData.credentialApiUrl}` },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
      ],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRawId.id),
          partnerClaimType: constants.restAPIs.webAuthnAssertion.rawId,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnClientDataJson.id),
          partnerClaimType: constants.restAPIs.webAuthnAssertion.clientDataJson,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnSignature.id),
          partnerClaimType: constants.restAPIs.webAuthnAssertion.signature,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAuthenticatorData.id),
          partnerClaimType: constants.restAPIs.webAuthnAssertion.authenticatorData,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id),
          partnerClaimType: constants.restAPIs.webAuthnAssertion.challenge,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRPId.id),
          defaultValue: '{Context:HostName}',
          alwaysUseDefaultValue: true,
          partnerClaimType: constants.restAPIs.webAuthnAssertion.RPId,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey1.id),
          partnerClaimType: constants.restAPIs.webAuthnAssertion.publicKey1,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnPublicKey2.id),
          partnerClaimType: constants.restAPIs.webAuthnAssertion.publicKey2,
        },
      ],
      outputClaims: [
        {
          claimId: nodeData.successClaim,
          partnerClaimType: constants.restAPIs.webAuthnAssertion.success,
          defaultValue: 'false',
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  let contentDefinitionKey: string = '';
  if (nodeData.contentDefinitionUrl) {
    let draftCD: JE_FQContentDefinitionSpec = {
      id: `api.webauthn.auth`,
      loadUri: nodeData.contentDefinitionUrl,
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: node.displayName }],
    };
    contentDefinitionKey = getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.webauthnauth').id;
  } else {
    contentDefinitionKey = getOrCreateWebAuthnAuthenticationContentDefinition(parsingCtx);
  }
  let selfAssertedAuthGetTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.selfAsserted,
      metadata: [
        { key: 'ContentDefinitionReferenceId', value: contentDefinitionKey },
        { key: 'IncludeClaimResolvingInClaimsHandling', value: 'true' },
      ],
      inputClaims: [{ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id) }],
      displayClaims: [
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnChallenge.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRawId.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnClientDataJson.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnSignature.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnUserHandle.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAuthenticatorData.id) },
      ],
      outputClaims: [{ claimId: nodeData.idClaim }, { claimId: nodeData.successClaim, defaultValue: 'false' }],
      validationTechnicalProfiles: [
        { profileId: getCredentialsTPA.id },
        {
          profileId: checkObjectIdTP.id,
          preconditions: [
            {
              type: 'ClaimEquals',
              executeActionsIf: false,
              values: [nodeData.successClaim, 'True'],
              action: 'SkipThisValidationTechnicalProfile',
            }
          ]
        },
        {
          profileId: getCredentialsTPB.id,
          preconditions: [
            {
              type: 'ClaimEquals',
              executeActionsIf: false,
              values: [nodeData.successClaim, 'True'],
              action: 'SkipThisValidationTechnicalProfile',
            },
          ],
        },
        {
          profileId: checkAssertionTP.id,
          preconditions: [
            {
              type: 'ClaimEquals',
              executeActionsIf: false,
              values: [nodeData.successClaim, 'True'],
              action: 'SkipThisValidationTechnicalProfile',
            },
          ],
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    challengeTP.id,
    `${node.sanitizedDisplayName}_GetChallengeExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    selfAssertedAuthGetTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
};

const generateWebAuthnCredentialExistsNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  parsingCtx.userJourneyStore.userJourneys[journeyId].requiresJavascript = true; // Required to implement the appropriate content definitions.
  let nodeData = node.data as JE_WebAuthnCredentialExistsNodeData;

  let contentDefinitionKey: string = '';
  let draftCD: JE_FQContentDefinitionSpec = {
    id: `api.webauthn.cre`,
    loadUri: nodeData.contentDefinitionUrl!,
    recoveryUri: '~/common/default_page_error.html',
    dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
    metadata: [{ key: 'DisplayName', value: node.displayName }],
  };
  contentDefinitionKey = getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.webauthncre').id;

  let outputXformIds: string[] = [
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_OutputClaimCopyToBuf`,
      method: 'NotClaims',
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnHasCredential.id),
          xformClaimType: 'inputClaim',
        },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanNotBuffer.id),
          xformClaimType: 'outputClaim',
        },
      ],
    }).id,
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_OutputClaimCopyToOutput`,
      method: 'NotClaims',
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanNotBuffer.id),
          xformClaimType: 'inputClaim',
        },
      ],
      outputClaims: [{ claimId: nodeData.existsClaim, xformClaimType: 'outputClaim' }],
    }).id,
  ];

  let checkForStoredFlagTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.selfAsserted,
      metadata: [{ key: 'ContentDefinitionReferenceId', value: contentDefinitionKey }],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnHasCredential.id),
          defaultValue: 'false',
          alwaysUseDefaultValue: true,
        },
      ],
      displayClaims: [
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnHasCredential.id) },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnHasCredential.id),
          defaultValue: 'false',
        },
      ],
      outputClaimXformIds: outputXformIds,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );

  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    checkForStoredFlagTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
};

const generateWebAuthnAvailabilityNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  parsingCtx.userJourneyStore.userJourneys[journeyId].requiresJavascript = true; // Required to implement the appropriate content definitions.
  let nodeData = node.data as JE_WebAuthnAvailabilityNodeData;

  let contentDefinitionKey: string = '';
  let draftCD: JE_FQContentDefinitionSpec = {
    id: `api.webauthn.ava`,
    loadUri: nodeData.contentDefinitionUrl!,
    recoveryUri: '~/common/default_page_error.html',
    dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
    metadata: [{ key: 'DisplayName', value: node.displayName }],
  };
  contentDefinitionKey = getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.webauthnava').id;

  let outputXformIds: string[] = [
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_OutputClaimCopyToBuf`,
      method: 'NotClaims',
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAvailable.id),
          xformClaimType: 'inputClaim',
        },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanNotBuffer.id),
          xformClaimType: 'outputClaim',
        },
      ],
    }).id,
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_OutputClaimCopyToOutput`,
      method: 'NotClaims',
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanNotBuffer.id),
          xformClaimType: 'inputClaim',
        },
      ],
      outputClaims: [{ claimId: nodeData.availabilityClaim, xformClaimType: 'outputClaim' }],
    }).id,
  ];

  let checkForAvailabilityTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.selfAsserted,
      metadata: [{ key: 'ContentDefinitionReferenceId', value: contentDefinitionKey }],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAvailable.id),
          defaultValue: 'false',
          alwaysUseDefaultValue: true,
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRequirePlatformAuth.id),
          defaultValue: nodeData.requirePlatformAuth ? 'true' : 'false',
          alwaysUseDefaultValue: true,
        },
      ],
      displayClaims: [
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAvailable.id) },
        { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnRequirePlatformAuth.id) },
      ],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.webAuthnAvailable.id),
          defaultValue: 'false',
        },
      ],
      outputClaimXformIds: outputXformIds,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'WebAuthn',
  );

  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    checkForAvailabilityTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
};

const generateConditionalAccessEvaluationNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_ConditionalAccessEvaluationNodeData;
  let mfaRegisteredClaimId: string = '';
  let inputXformIds: string[] = [];
  if (parsingCtx.claimStore.claims[nodeData.mfaRegisteredClaim].dataType === 'string') {
    mfaRegisteredClaimId = createFQClaim(parsingCtx.claimStore, {
      id: `${node.sanitizedDisplayName}_MFAIsRegisteredClaim`,
      displayName: `${node.sanitizedDisplayName}_MFAIsRegisteredClaim`,
      dataType: 'boolean',
    }).id;
    inputXformIds.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${node.sanitizedDisplayName}_CheckMFAIsRegistered`,
        method: 'CompareClaimToValue',
        inputClaims: [
          {
            claimId: getOrCreateStringHandlingBufferClaim(parsingCtx, nodeData.mfaRegisteredClaim),
            xformClaimType: 'inputClaim1',
          },
        ],
        inputParameters: [
          { id: 'compareTo', dataType: 'string', value: '' },
          { id: 'operator', dataType: 'string', value: 'not equal' },
          { id: 'ignoreCase', dataType: 'string', value: 'true' },
        ],
        outputClaims: [{ claimId: mfaRegisteredClaimId, xformClaimType: 'outputClaim' }],
      }).id,
    );
    let prepMFARegisteredTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `${node.sanitizedDisplayName}_MFARegisteredStringHandler`,
        displayName: `${node.sanitizedDisplayName}_MFARegisteredStringHandler`,
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        inputClaims: [{ claimId: nodeData.mfaRegisteredClaim, defaultValue: '' }],
        outputClaims: [{ claimId: nodeData.mfaRegisteredClaim, defaultValue: '' }],
        outputClaimXformIds: [
          createFQClaimXform(parsingCtx.claimTransformStore, {
            id: `${node.sanitizedDisplayName}_SanitizeMFADataString`,
            method: 'FormatStringClaim',
            inputClaims: [{ claimId: nodeData.mfaRegisteredClaim, xformClaimType: 'inputClaim' }],
            inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}' }],
            outputClaims: [
              {
                claimId: getOrCreateStringHandlingBufferClaim(parsingCtx, nodeData.mfaRegisteredClaim),
                xformClaimType: 'outputClaim',
              },
            ],
          }).id,
        ],
        useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
      },
      'Conditional Access',
    );
    addFQOrchestrationStepOrValidationProfileRef(
      parsingCtx,
      node,
      nodes,
      prepMFARegisteredTP.id,
      `${node.sanitizedDisplayName}_PrepMFAStringExchange`,
      journeyId,
      branchVarMap,
      preconditions?.slice(),
    );
  } else {
    mfaRegisteredClaimId = nodeData.mfaRegisteredClaim;
  }
  let challengeBufferId = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.caChallengeBuffer.id);
  let statusBufferId = getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.caStatusBuffer.id);
  let outputXforms: string[] = [
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_ExtractChangePasswordFlag`,
      method: 'StringCollectionContains',
      inputClaims: [{ claimId: challengeBufferId, xformClaimType: 'inputClaim' }],
      inputParameters: [
        { id: 'item', dataType: 'string', value: 'chg_pwd' },
        { id: 'ignoreCase', dataType: 'string', value: 'true' },
      ],
      outputClaims: [{ claimId: nodeData.changePasswordFlagClaim, xformClaimType: 'outputClaim' }],
    }).id,
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_ExtractMFAFlag`,
      method: 'StringCollectionContains',
      inputClaims: [{ claimId: challengeBufferId, xformClaimType: 'inputClaim' }],
      inputParameters: [
        { id: 'item', dataType: 'string', value: 'mfa' },
        { id: 'ignoreCase', dataType: 'string', value: 'true' },
      ],
      outputClaims: [{ claimId: nodeData.mfaFlagClaim, xformClaimType: 'outputClaim' }],
    }).id,
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_ExtractBlockFlag`,
      method: 'StringCollectionContains',
      inputClaims: [{ claimId: challengeBufferId, xformClaimType: 'inputClaim' }],
      inputParameters: [
        { id: 'item', dataType: 'string', value: 'block' },
        { id: 'ignoreCase', dataType: 'string', value: 'true' },
      ],
      outputClaims: [{ claimId: nodeData.blockFlagClaim, xformClaimType: 'outputClaim' }],
    }).id,
  ];
  let immediateOutputXforms: string[] = [];
  let conditionalAccessTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.conditionalAccess,
      metadata: [{ key: 'OperationType', value: 'Evaluation' }],
      inputClaimXformIds: inputXformIds,
      inputClaims: [
        { claimId: nodeData.idClaim, partnerClaimType: 'UserId' },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.authMethodsUsedForCA.id),
          partnerClaimType: 'AuthenticationMethodsUsed',
        },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.isFederatedLogin.id),
          partnerClaimType: 'IsFederated',
          defaultValue: 'false',
        },
        { claimId: mfaRegisteredClaimId, partnerClaimType: 'IsMfaRegistered' },
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.estsRequestId.id),
          defaultValue: '00000000-0000-0000-0000-000000000000',
          partnerClaimType: 'estsRequestId',
        },
      ],
      outputClaims: [
        { claimId: challengeBufferId, partnerClaimType: 'Challenges' },
        { claimId: statusBufferId, partnerClaimType: 'MultiConditionalAccessStatus' },
        { claimId: nodeData.changePasswordFlagClaim, defaultValue: 'false' },
        { claimId: nodeData.mfaFlagClaim, defaultValue: 'false' },
        { claimId: nodeData.blockFlagClaim, defaultValue: 'false' },
      ],
      outputClaimXformIds: immediateOutputXforms,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Conditional Access',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    conditionalAccessTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
  let outputClaims: JE_technicalProfileClaimRef[] = [
    { claimId: nodeData.changePasswordFlagClaim },
    { claimId: nodeData.mfaFlagClaim },
    { claimId: nodeData.blockFlagClaim },
  ];
  let flagExtractTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_ExtractCAFlags`,
      displayName: `${node.sanitizedDisplayName}_ExtractCAFlags`,
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      outputClaims: outputClaims,
      outputClaimXformIds: outputXforms,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Conditional Access',
  );
  let outputPreconditions = preconditions ? preconditions.slice() : [];
  outputPreconditions.push({
    type: 'ClaimsExist',
    executeActionsIf: false,
    values: [getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.caChallengeBuffer.id)],
    action: 'SkipThisOrchestrationStep',
  });
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    flagExtractTP.id,
    `${node.sanitizedDisplayName}_ExtractCAFlagsClaimsExchange`,
    journeyId,
    branchVarMap,
    outputPreconditions.slice(),
  );
};

const generateConditionalAccessRemediationNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let remediationTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.conditionalAccess,
      metadata: [{ key: 'OperationType', value: 'Remediation' }],
      inputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.caChallengeBuffer.id),
          partnerClaimType: 'ChallengesSatisfied',
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'Conditional Access',
  );
  let remediationPreconditions = preconditions?.slice();
  if (!remediationPreconditions) {
    remediationPreconditions = [];
  }
  // Skip remediation if evaluation indicated no remediations necessary.
  remediationPreconditions.push({
    type: 'ClaimsExist',
    executeActionsIf: false,
    values: [getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.caChallengeBuffer.id)],
    action: 'SkipThisOrchestrationStep',
  });
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    remediationTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    remediationPreconditions,
  );
};

// Generates session handling precursors for a component that uses a specific session flag to be skipped.
// Adds an orchestration step for the session handling precursor.
// Returns an extra precondition to put on the node's orchestration steps, if the node is configured to use such a session.
// Otherwise, returns null.
const generateFlagSessionHandlingForNode = (
  parsingCtx: JE_ParsingContext,
  node: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  journeyId: string,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  if (node.sessionBehavior?.sessionAction === 'flagSession') {
    let sessionSetupTP = generateSessionSetupProfileFQSchema(
      parsingCtx,
      node,
      node.sessionBehavior.sessionId
    );
    addFQOrchestrationStepOrValidationProfileRef(
      parsingCtx,
      node,
      nodes,
      sessionSetupTP.id,
      `${node.sanitizedDisplayName}_SessionSetup`,
      journeyId,
      branchVarMap,
      preconditions?.slice(),
    );
    return {
      type: 'ClaimEquals',
      executeActionsIf: true,
      values: [parsingCtx.sessions[node.sessionBehavior.sessionId].sessionFlagClaimId, "True"],
      action: "SkipThisOrchestrationStep"
    }
  }
  return null;
}

const generateSessionSetupProfileFQSchema = (
  parsingCtx: JE_ParsingContext,
  node: JsonFlowchartNode,
  sessionId: string,
) => {
  return createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `SessionExistsSetup_${node.sanitizedDisplayName}`,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      outputClaims: [
        {
          claimId: parsingCtx.sessions[sessionId].sessionInitClaimId,
          defaultValue: '',
          alwaysUseDefaultValue: true,
        },
        {
          claimId: parsingCtx.sessions[sessionId].sessionFlagClaimId,
          defaultValue: 'false',
          alwaysUseDefaultValue: true,
        },
      ],
      useTechnicalProfileForSessionManagement: parsingCtx.sessions[sessionId].sessionProfileId,
    },
    'Session Branch Handling',
  );
}

const generateSessionExistsFQSChema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  subflow?: JE_SubflowInfo,
) => {
  let setupTP = generateSessionSetupProfileFQSchema(
    parsingCtx,
    node,
    '_SSO'
  );
  let branchOutputs: JE_technicalProfileClaimRef[] = [];
  if (node.childBranchVars[0]) {
    branchOutputs.push({ claimId: node.childBranchVars[0], defaultValue: 'false' });
  }
  if (node.childBranchVars.length > 1 && node.childBranchVars[1]) {
    branchOutputs.push({ claimId: node.childBranchVars[1], defaultValue: 'false' });
  }
  let intermediateStageClaim =
    node.childBranchVars.length > 1 && node.childBranchVars[1]
      ? node.childBranchVars[1]
      : createFQClaim(parsingCtx.claimStore, {
        id: `${node.sanitizedDisplayName}_IntermediateBranchBuffer`,
        displayName: 'Session Exists Branch Buffer',
        dataType: 'boolean',
      }).id;
  let branchXforms: string[] = [];
  branchXforms.push(
    createFQClaimXform(parsingCtx.claimTransformStore, {
      id: `${node.sanitizedDisplayName}_SetNoSessionBranchVar`,
      method: 'NotClaims',
      inputClaims: [
        { claimId: parsingCtx.sessions['_SSO'].sessionFlagClaimId, xformClaimType: 'inputClaim' },
      ],
      outputClaims: [{ claimId: intermediateStageClaim, xformClaimType: 'outputClaim' }],
    }).id,
  );
  if (node.childBranchVars[0]) {
    branchXforms.push(
      createFQClaimXform(parsingCtx.claimTransformStore, {
        id: `${node.sanitizedDisplayName}_SetSessionExistsBranchVar`,
        method: 'NotClaims',
        inputClaims: [{ claimId: intermediateStageClaim, xformClaimType: 'inputClaim' }],
        outputClaims: [{ claimId: node.childBranchVars[0], xformClaimType: 'outputClaim' }],
      }).id,
    );
  }
  let branchTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      outputClaims: branchOutputs,
      outputClaimXformIds: branchXforms,
      useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id,
    },
    'Session Branch Handling',
  );
  if (settings.outputExtraBranchVarInfo) {
    node.childBranchVars.forEach((childBranchVar) => {
      if (childBranchVar) {
        parsingCtx.branchVarMetadata[childBranchVar].setInProfiles.add(branchTP.id);
      }
    });
  }
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    setupTP.id,
    `${node.sanitizedDisplayName}_SetupClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    subflow,
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    branchTP.id,
    `${node.sanitizedDisplayName}_BranchClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    subflow,
    node.childBranchVars.filter((bv) => {
      return Boolean(bv);
    }) as string[],
  );
};

const generateValidationErrorNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  submitActionFlow?: JE_SubflowInfo,
) => {
  let validationErrorTP = createValidationErrorTP(parsingCtx);
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    validationErrorTP,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    submitActionFlow,
  );
}

const generateErrorPageNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_ErrorPageNodeData;
  let metadataFields: JE_FQMetadataItemSpec[] = [
    { key: 'setting.showContinueButton', value: 'false' },
    { key: 'setting.showCancelButton', value: 'false' },
  ];
  if (nodeData.contentDefinitionUrl) {
    let draftCD: JE_FQContentDefinitionSpec = {
      id: `${node.sanitizedDisplayName}_ContentDefinition`,
      loadUri: nodeData.contentDefinitionUrl,
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Error Page' }],
    };
    metadataFields.push({
      key: 'ContentDefinitionReferenceId',
      value: getOrCreateFQContentDefinition(parsingCtx, draftCD, 'api.selfasserted').id,
    });
  } else {
    metadataFields.push({
      key: 'ContentDefinitionReferenceId',
      value: fetchDefaultFQContentDefinitionRef(parsingCtx, 'api.selfasserted'),
    });
  }
  let inputClaimXforms: string[] = [];
  let earlyInputClaims: string[] = [];
  let inputClaims: JE_technicalProfileClaimRef[] = [];
  let displayClaims: JE_technicalProfileClaimRef[] = [];
  let usingClaimsResolvers = false;
  nodeData.entries.forEach((ent) => {
    if (ent.sourceType === 'claim') {
      if (
        !constants.readonlyUserInputTypes.includes(
          parsingCtx.claimStore.claims[ent.source].userInputType
            ? parsingCtx.claimStore.claims[ent.source].userInputType!
            : '',
        )
      ) {
        earlyInputClaims.push(ent.source);
        let newDisplayClaim = cloneFQClaim(
          parsingCtx.claimStore,
          parsingCtx.claimStore.claims[ent.source],
          `${node.sanitizedDisplayName}_${ent.source}_DisplayCopy`,
          'Paragraph',
        );
        if (newDisplayClaim.dataType === 'boolean') {
          inputClaimXforms.push(
            createFQClaimXform(parsingCtx.claimTransformStore, {
              id: `${node.sanitizedDisplayName}_${ent.source}_CopyForDisplay`,
              method: 'NotClaims',
              inputClaims: [{ claimId: ent.source, xformClaimType: 'inputClaim' }],
              outputClaims: [
                {
                  claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanCopyBufA.id),
                  xformClaimType: 'outputClaim',
                },
              ],
            }).id,
          );
          inputClaimXforms.push(
            createFQClaimXform(parsingCtx.claimTransformStore, {
              id: `${node.sanitizedDisplayName}_${ent.source}_CopyForDisplay`,
              method: 'NotClaims',
              inputClaims: [
                {
                  claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.booleanCopyBufA.id),
                  xformClaimType: 'inputClaim',
                },
              ],
              outputClaims: [{ claimId: newDisplayClaim.id, xformClaimType: 'outputClaim' }],
            }).id,
          );
        } else if (newDisplayClaim.dataType === 'string') {
          inputClaimXforms.push(
            createFQClaimXform(parsingCtx.claimTransformStore, {
              id: `${node.sanitizedDisplayName}_${ent.source}_CopyForDisplay`,
              method: 'FormatStringClaim',
              inputClaims: [{ claimId: ent.source, xformClaimType: 'inputClaim' }],
              inputParameters: [{ id: 'stringFormat', dataType: 'string', value: '{0}' }],
              outputClaims: [{ claimId: newDisplayClaim.id, xformClaimType: 'outputClaim' }],
            }).id,
          );
        }
        inputClaims.push({ claimId: newDisplayClaim.id });
        displayClaims.push({ claimId: newDisplayClaim.id });
      } else {
        inputClaims.push({ claimId: ent.source });
        displayClaims.push({ claimId: ent.source });
      }
    } else if (ent.sourceType === 'literal') {
      let newDisplayClaim = createFQClaim(parsingCtx.claimStore, {
        id: `${node.sanitizedDisplayName}_DisplayLiteral`,
        displayName: 'Error Display Message',
        dataType: 'string',
        userInputType: 'Paragraph',
      });
      inputClaims.push({ claimId: newDisplayClaim.id, defaultValue: ent.source, alwaysUseDefaultValue: true });
      displayClaims.push({ claimId: newDisplayClaim.id });
    } else if (ent.sourceType === 'resolver') {
      if (isSpecialResolver(ent.source)) {
        let newDisplayClaim = createFQClaim(parsingCtx.claimStore, {
          id: `${node.sanitizedDisplayName}_DisplayResolverBuf`,
          displayName: 'Error Display Message',
          dataType:
            constants.sessionContexts.specials[ent.source as keyof typeof constants.sessionContexts.specials].dataType,
          userInputType: 'Paragraph',
        });
        inputClaimXforms.push(getOrCreateSSCTransform(parsingCtx, ent.source, newDisplayClaim.id));
        inputClaims.push({ claimId: newDisplayClaim.id });
        displayClaims.push({ claimId: newDisplayClaim.id });
      } else {
        usingClaimsResolvers = true;
        let newDisplayClaim = createFQClaim(parsingCtx.claimStore, {
          id: `${node.sanitizedDisplayName}_DisplayResolverBuf`,
          displayName: 'Error Display Message',
          dataType: 'string',
          userInputType: 'Paragraph',
        });
        inputClaims.push({ claimId: newDisplayClaim.id, defaultValue: ent.source, alwaysUseDefaultValue: true });
        displayClaims.push({ claimId: newDisplayClaim.id });
      }
    }
  });
  if (usingClaimsResolvers) {
    metadataFields.push({ key: 'IncludeClaimResolvingInClaimsHandling', value: 'true' });
  }
  if (earlyInputClaims.length > 0) {
    let advancePrepTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `${node.sanitizedDisplayName}_EarlyClaimPrep`,
        displayName: 'Advance Claim Preparation',
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        outputClaims: earlyInputClaims.map((eic) => {
          return { claimId: eic, defaultValue: getClaimTypeDefault(eic, parsingCtx) };
        }),
      },
      'Error Pages',
    );
    addFQOrchestrationStepOrValidationProfileRef(
      parsingCtx,
      node,
      nodes,
      advancePrepTP.id,
      `${node.sanitizedDisplayName}_Prep_ClaimsExchange`,
      journeyId,
      branchVarMap,
      preconditions?.slice(),
    );
  }
  let errorNodeTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.selfAsserted,
      metadata: metadataFields,
      inputClaimXformIds: inputClaimXforms,
      inputClaims: inputClaims,
      displayClaims: displayClaims,
      useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id,
    },
    'Error Pages',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    errorNodeTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
  );
};

const getAvailableTPId = (tpStore: JE_TechnicalProfileStore, prospectiveId: string) => {
  let idIterCount = 0;
  let attemptedId = prospectiveId;
  while (tpStore.tpIds.has(attemptedId.toLowerCase())) {
    attemptedId = prospectiveId + `_${idIterCount}`;
    idIterCount += 1;
  }
  return attemptedId;
};

const generateAuthorizeTokenFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_AuthorizeTokenNodeData;
  let authTokenTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.none,
      inputTokenFormat: 'JWT',
      metadata: [
        { key: 'issuer', value: nodeData.issuer },
        {
          key: 'audience',
          value:
            '[ ' +
            nodeData.audience
              .map((audEntry) => {
                return `"${audEntry}"`;
              })
              .join(', ') +
            ' ]',
        },
        { key: 'client_assertion_type', value: constants.customPolicySchema.userInfoEndpoint.clientAssertionType },
      ],
      cryptographicKeys: [{ id: 'issuer_secret', storageReferenceId: nodeData.issuerSecret }],
      outputClaims: nodeData.claims.map((clRef) => {
        return { claimId: clRef.claimId, partnerClaimType: clRef.partnerClaimType };
      }),
    },
    'UserInfo Endpoints',
  );
  updateLiveClaims(parsingCtx, node, nodes, authTokenTP.id);
  setUserJourneyAuthorizationProfile(parsingCtx.userJourneyStore, journeyId, authTokenTP.id);
};

const generateSendEmailOTPFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
  submitActionFlow?: JE_SubflowInfo,
) => {
  let nodeData = node.data as JE_SendEmailOTPNodeData;

  let genOTPTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_GenerateOTP`,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.oneTimePassword,
      metadata: [
        // TODO: Make these configurable from the frontend.
        { key: 'Operation', value: 'GenerateCode' },
        { key: 'CodeExpirationInSeconds', value: '600' },
        { key: 'CodeLength', value: '6' },
        { key: 'CharacterSet', value: '0-9' },
        { key: 'NumRetryAttempts', value: '5' },
        { key: 'NumCodeGenerationAttempts', value: '10' },
        { key: 'ReuseSameCode', value: 'false' },
      ],
      inputClaims: [{ claimId: nodeData.emailClaim, partnerClaimType: 'identifier' }],
      outputClaims: [
        {
          claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emailOTP.id),
          partnerClaimType: 'otpGenerated',
        },
      ],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'OTP Handling',
  );
  let requestBodyClaims: JE_claimXformIOClaimSpec[] = [];
  let requestBodyParameters: JE_claimXformParamSpec[] = [];
  let requestBodyResolverClaims: JE_technicalProfileClaimRef[] = [];
  let requestBodyClaimIds: Set<string> = new Set();
  let requestBodyResolverMap: { [resolver: string]: string } = {};
  let prepOutputXforms: string[] = [];
  let usingClaimResolvers: boolean = false;
  let dispFields = nodeData.fields.slice();
  // TODO: Figure out why this breaks JSON request generation and fix it.
  if (nodeData.language.sourceType) {
    dispFields.push({
      sourceType: nodeData.language.sourceType,
      source: nodeData.language.source,
      templateField: 'languagecode',
    });
  }
  dispFields.forEach((fld) => {
    if (fld.sourceType === 'claim') {
      requestBodyClaims.push({
        claimId: fld.source,
        xformClaimType: `personalizations.0.dynamic_template_data.${fld.templateField}`,
      });
      requestBodyClaimIds.add(fld.source);
    } else if (fld.sourceType === 'resolver') {
      if (!requestBodyResolverMap.hasOwnProperty(fld.source)) {
        if (isSpecialResolver(fld.source)) {
          requestBodyResolverMap[fld.source] = createFQClaim(parsingCtx.claimStore, {
            id: `${node.sanitizedDisplayName}_Resolver_Buf_${requestBodyResolverClaims.length}`,
            displayName: `${node.displayName} Resolver Buf`,
            dataType:
              constants.sessionContexts.specials[fld.source as keyof typeof constants.sessionContexts.specials]
                .dataType,
          }).id;
          prepOutputXforms.push(getOrCreateSSCTransform(parsingCtx, fld.source, requestBodyResolverMap[fld.source]));
        } else {
          usingClaimResolvers = true;
          requestBodyResolverMap[fld.source] = createFQClaim(parsingCtx.claimStore, {
            id: `${node.sanitizedDisplayName}_Resolver_Buf_${requestBodyResolverClaims.length}`,
            displayName: `${node.displayName} Resolver Buf`,
            dataType: 'string',
          }).id;
          requestBodyResolverClaims.push({
            claimId: requestBodyResolverMap[fld.source],
            defaultValue: fld.source,
            alwaysUseDefaultValue: true,
          });
        }
      }
      requestBodyClaims.push({
        claimId: requestBodyResolverMap[fld.source],
        xformClaimType: `personalizations.0.dynamic_template_data.${fld.templateField}`,
      });
    } else if (fld.sourceType === 'literal') {
      requestBodyParameters.push({
        id: `personalizations.0.dynamic_template_data.${fld.templateField}`,
        dataType: 'string',
        value: fld.source,
      });
    } else {
      throw `Invalid source type for field ${fld.templateField} (${fld.sourceType}) in send email OTP component`;
    }
  });
  let reqBodyMetadata: JE_FQMetadataItemSpec[] = [];
  if (usingClaimResolvers) {
    reqBodyMetadata.push({ key: 'IncludeClaimResolvingInClaimsHandling', value: 'true' });
  }
  requestBodyClaims.push({
    claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emailOTP.id),
    xformClaimType: `personalizations.0.dynamic_template_data.${nodeData.otpField}`,
  });
  requestBodyClaimIds.add(getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emailOTP.id));
  requestBodyClaims.push({
    claimId: nodeData.emailClaim,
    xformClaimType: `personalizations.0.to.0.email`,
  });
  requestBodyClaimIds.add(nodeData.emailClaim);
  // TODO: Make this configurable, somehow
  requestBodyParameters.push({
    id: `from.email`,
    dataType: 'string',
    value: 'info@gritsoftwaresystems.com',
  });
  requestBodyParameters.push({
    id: 'template_id',
    dataType: 'string',
    value: nodeData.templateName,
  });
  // TODO: Make this configurable
  requestBodyParameters.push({
    id: 'personalizations.0.dynamic_template_data.subject',
    dataType: 'string',
    value: 'Email verification code',
  });
  let reqBodyOutputClaims: JE_technicalProfileClaimRef[] = [];
  Object.keys(requestBodyClaimIds).forEach((cid) => {
    reqBodyOutputClaims.push({
      claimId: cid,
    });
  });
  let reqBodyInputClaims: JE_technicalProfileClaimRef[] = Object.keys(requestBodyClaimIds).map((cid) => {
    return { claimId: cid };
  });

  requestBodyResolverClaims.forEach((rbrc) => {
    reqBodyInputClaims.push(rbrc);
    reqBodyOutputClaims.push({ claimId: rbrc.claimId });
  });

  let buildRequestBodyXformId: string = createFQClaimXform(parsingCtx.claimTransformStore, {
    id: `${node.sanitizedDisplayName}_BuildRequestBody`,
    method: 'GenerateJson',
    inputClaims: requestBodyClaims,
    inputParameters: requestBodyParameters,
    outputClaims: [
      {
        claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emailRequestBody.id),
        xformClaimType: 'outputClaim',
      },
    ],
  }).id;

  prepOutputXforms.push(buildRequestBodyXformId);

  reqBodyOutputClaims.push({
    claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emailRequestBody.id),
  });

  let requestBodyTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `${node.sanitizedDisplayName}_BuildRequest`,
      displayName: `${node.displayName} Request Builder`,
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      metadata: reqBodyMetadata,
      inputClaims: reqBodyInputClaims,
      outputClaims: reqBodyOutputClaims,
      outputClaimXformIds: prepOutputXforms,
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'OTP Handling',
  );

  let sendRequestTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'ServiceUrl', value: 'https://api.sendgrid.com/v3/mail/send' },
        { key: 'AuthenticationType', value: 'Bearer' },
        { key: 'SendClaimsIn', value: 'Body' },
        {
          key: 'ClaimUsedForRequestPayload',
          value: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emailRequestBody.id),
        },
      ],
      cryptographicKeys: [
        { id: 'BearerAuthenticationToken', storageReferenceId: 'B2C_1A_SendGridSecret' }, // TODO: Somehow make this configurable
      ],
      inputClaims: [{ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.emailRequestBody.id) }],
      useTechnicalProfileForSessionManagement: getNodeSessionProfileId(node, parsingCtx),
    },
    'OTP Handling',
  );

  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    genOTPTP.id,
    'OTPCEX_SHOULD_NOT_APPEAR',
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    submitActionFlow,
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    requestBodyTP.id,
    'OTPCEX_SHOULD_NOT_APPEAR',
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    submitActionFlow,
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    sendRequestTP.id,
    'OTPCEX_SHOULD_NOT_APPEAR',
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    submitActionFlow,
  );
};

const generateOIDCIdPAuthenticationFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_OIDCIdPNodeData;
  let identityXforms = getOrCreateUserForeignIdentityCreationXforms(parsingCtx);
  let metadataFields: JE_FQMetadataItemSpec[] = [
    { key: 'client_id', value: nodeData.clientId },
    { key: 'METADATA', value: nodeData.metadataUrl },
    { key: 'UsePolicyInRedirectUri', value: 'false' },
    { key: 'response_types', value: nodeData.responseType },
    { key: 'response_mode', value: nodeData.responseMode },
    { key: 'HttpBinding', value: 'POST' },
  ];
  let scopes: string[] = ['openid'];
  nodeData.forceScopes.forEach((sc) => {
    scopes.push(sc)
  });
  metadataFields.push({ key: 'scope', value: scopes.join(' ') });
  let cryptographicKeys: JE_CryptographicKeyRef[] = [];
  if (nodeData.responseType === 'code') {
    cryptographicKeys.push({
      id: 'client_secret',
      storageReferenceId: nodeData.clientSecretContainerName
    });
  }

  let outputClaims: JE_technicalProfileClaimRef[] = nodeData.outputClaims.map((oClm) => {
    if (oClm.partnerClaimType && (!oClm.defaultValue)) {
      return { claimId: oClm.claimId, partnerClaimType: oClm.partnerClaimType }
    } else {
      return { claimId: oClm.claimId, partnerClaimType: oClm.partnerClaimType, defaultValue: oClm.defaultValue, alwaysUseDefaultValue: oClm.alwaysUseDefaultValue }
    }
  });
  outputClaims.unshift({ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.identityProvider.id), defaultValue: nodeData.idpDomain, alwaysUseDefaultValue: true });
  outputClaims.unshift({ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.issuerUserId.id), partnerClaimType: nodeData.issuerIdPartnerClaimType });
  outputClaims.push({ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.isFederatedLogin.id), defaultValue: 'true', alwaysUseDefaultValue: true });
  let oidcTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.openIdConnect,
      metadata: metadataFields,
      cryptographicKeys: cryptographicKeys,
      inputClaims: nodeData.inputClaims.map((iClm) => {
        return { claimId: iClm.claimId, partnerClaimType: iClm.partnerClaimType }
      }),
      outputClaims: outputClaims,
      outputClaimXformIds: identityXforms
    },
    nodeData.idpDomain
  );
  if (node.sessionBehavior && node.sessionBehavior.sessionAction !== 'always') {
    oidcTP.useTechnicalProfileForSessionManagement = getOrCreateSocialSessionManagementTP(parsingCtx).id;
  } else {
    oidcTP.useTechnicalProfileForSessionManagement = getOrCreateNoopSessionManagementTP(parsingCtx).id;
  }
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    oidcTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice()
  );
  createIdPSessionHandlerStep(parsingCtx, node, nodes, journeyId, branchVarMap, preconditions);
}

const generateSAMLIdPAuthenticationFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_SAMLIdPNodeData;
  let identityXforms = getOrCreateUserForeignIdentityCreationXforms(parsingCtx);
  let metadataFields: JE_FQMetadataItemSpec[] = [
    { key: 'PartnerEntity', value: nodeData.metadataUrl },
    { key: 'WantsSignedRequests', value: nodeData.signRequests ? 'true' : 'false' },
    { key: 'WantsSignedAssertions', value: nodeData.expectResponseSignatures ? 'true' : 'false' },
    { key: 'ResponsesSigned', value: nodeData.expectResponseSignatures ? 'true' : 'false' },
    { key: 'WantsEncryptedAssertions', value: nodeData.encryptAssertions ? 'true' : 'false' },
  ];
  if (nodeData.signRequests) {
    metadataFields.push({ key: 'XmlSignatureAlgorithm', value: nodeData.signatureAlgorithm });
  }
  let cryptographicKeys: JE_CryptographicKeyRef[] = [];
  if (nodeData.messageSigningKey) {
    cryptographicKeys.push({ id: 'SamlMessageSigning', storageReferenceId: nodeData.messageSigningKey });
  }
  if (nodeData.encryptAssertions) {
    cryptographicKeys.push({ id: 'SamlAssertionDecryption', storageReferenceId: nodeData.assertionDecryptionKey });
  }
  if (nodeData.metadataSigningKey) {
    cryptographicKeys.push({ id: 'MetadataSigning', storageReferenceId: nodeData.metadataSigningKey });
  }

  let outputClaims: JE_technicalProfileClaimRef[] = nodeData.outputClaims.map((oClm) => {
    if (oClm.partnerClaimType && (!oClm.defaultValue)) {
      return { claimId: oClm.claimId, partnerClaimType: oClm.partnerClaimType }
    } else {
      return { claimId: oClm.claimId, partnerClaimType: oClm.partnerClaimType, defaultValue: oClm.defaultValue, alwaysUseDefaultValue: oClm.alwaysUseDefaultValue }
    }
  });
  outputClaims.unshift({ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.identityProvider.id), defaultValue: nodeData.idpDomain, alwaysUseDefaultValue: true });
  outputClaims.unshift({ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.issuerUserId.id), partnerClaimType: nodeData.issuerIdPartnerClaimType });
  outputClaims.push({ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.isFederatedLogin.id), defaultValue: 'true', alwaysUseDefaultValue: true });

  let sessionManagementProfileId: string = '';

  if (node.sessionBehavior && node.sessionBehavior.sessionAction !== 'always') {
    sessionManagementProfileId = getOrCreateSamlIdPSessionManagementTP(parsingCtx).id;
  } else {
    sessionManagementProfileId = getOrCreateNoopSessionManagementTP(parsingCtx).id;
  }

  let samlTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.saml2,
      metadata: metadataFields,
      cryptographicKeys: cryptographicKeys,
      inputClaims: nodeData.requestUserClaim ? [{ claimId: nodeData.requestUserClaim, partnerClaimType: 'subject' }] : undefined,
      outputClaims: outputClaims,
      outputClaimXformIds: identityXforms,
      useTechnicalProfileForSessionManagement: sessionManagementProfileId
    },
    nodeData.idpDomain
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    samlTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice()
  );
  createIdPSessionHandlerStep(parsingCtx, node, nodes, journeyId, branchVarMap, preconditions);
  addSamlMetadataUrlToJourney(parsingCtx.userJourneyStore, journeyId, samlTP.id,
    `https://${extractSettingFieldValue(jsonConstants.defaultAppSettingFields.tenantName.id, parsingCtx.buildSettings)}.b2clogin.com/${extractSettingFieldValue(jsonConstants.defaultAppSettingFields.tenantName.id, parsingCtx.buildSettings)}.onmicrosoft.com/`,
    `/samlp/metadata?idptp=${samlTP.id}`);
}

const escapeClaimIdForTableStorage = (name: string) => {
  return name.replace('-', '_'); // Azure table storage doesn't allow dashes in property names.
}

const generatePolicyInstrumentationFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions: JE_FQPreconditionSpec[],
  subflow?: JE_SubflowInfo,
) => {
  let restSendClaims: JE_technicalProfileClaimRef[] = [
    {
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.instrumentationCorrelationId.id),
      defaultValue: '{Context:CorrelationId}',
      alwaysUseDefaultValue: true,
      partnerClaimType: 'correlationId',
    },
  ];
  node.parents.forEach((parentId) => {
    restSendClaims.push(
      {
        claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.instrumentationComponentName.id),
        defaultValue: nodes[parentId].displayName,
        alwaysUseDefaultValue: true,
        partnerClaimType: 'componentName',
      },
      {
        claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.instrumentationComponentId.id),
        defaultValue: parentId,
        alwaysUseDefaultValue: true,
        partnerClaimType: 'componentId',
      },
    );
    parsingCtx.liveClaims[parentId].forEach((claimId) => {
      if (settings.includeGeneratedClaimsInInstrumentation || parsingCtx.claimStore.declaredClaimIds.has(claimId)) {
        if (constants.validRESTClaimDataTypes.includes(parsingCtx.claimStore.claims[claimId].dataType)) {
          // Not all claims can be sent via REST profile
          restSendClaims.push({ claimId: claimId, partnerClaimType: `claim_${escapeClaimIdForTableStorage(claimId)}` });
        }
      }
    });
  });
  let instrumentationTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.REST,
      metadata: [
        { key: 'IncludeClaimResolvingInClaimsHandling', value: 'true' },
        { key: 'ServiceUrl', value: 'https://debugdata-221115080130.azurewebsites.net/api/SetDebugData' },
        { key: 'AuthenticationType', value: 'None' },
        { key: 'AllowInsecureAuthInProduction', value: 'true' },
        { key: 'SendClaimsIn', value: 'Body' },
      ],
      inputClaims: restSendClaims,
      useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id,
    },
    'Policy Instrumentation',
  );
  addFQOrchestrationStepOrValidationProfileRef(
    parsingCtx,
    node,
    nodes,
    instrumentationTP.id,
    `${node.sanitizedDisplayName}_ClaimsExchange`,
    journeyId,
    branchVarMap,
    preconditions?.slice(),
    subflow,
  );
};

const generateUserInfoIssuerFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_UserInfoIssuerNodeData;
  let uiiTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: node.sanitizedDisplayName,
      displayName: node.displayName,
      protocol: constants.customPolicySchema.protocols.none,
      outputTokenFormat: 'JSON',
      cryptographicKeys: [{ id: 'issuer_secret', storageReferenceId: nodeData.issuerSecret }],
      inputClaims: nodeData.claims.map((cRef) => {
        return {
          claimId: cRef.claimId,
          defaultValue: cRef.defaultValue,
        };
      }),
    },
    'UserInfo Endpoints',
  );
  addFQOrchestrationStepToJourney(
    parsingCtx.userJourneyStore,
    {
      order: 1,
      type: 'SendClaims',
      cpimIssuerTechnicalProfileReferenceId: uiiTP.id,
    },
    journeyId,
  );
};

const generateTokenIssuerNodeFQSchema = (
  node: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  branchVarMap: BranchVarMap,
  preconditions?: JE_FQPreconditionSpec[],
) => {
  let nodeData = node.data as JE_TokenIssuerNodeData;
  // If the token issuer has optional default string values, need a handler to translate empty claims into default values.
  let defaultStringClaims = nodeData.claims.filter((cl) => {
    return (
      cl.claimId &&
      cl.defaultValueSource === 'literal' &&
      cl.defaultValue &&
      cl.defaultValue.length > 0 &&
      parsingCtx.claimStore.claims[cl.claimId].dataType === 'string'
    );
  });
  let resolvers = nodeData.claims.filter((cl) => {
    return cl.claimId && cl.defaultValueSource === 'resolver' && cl.defaultValue;
  });
  if (defaultStringClaims.length > 0 || resolvers.length > 0) {
    // Create advance default prep stage - string claims with optional default values need special handling to apply these defaults to initialized but empty claims.
    // For the TokenIssuer we can't use input transforms but rather need to create a preceding orch step.
    let xformIds: string[] = [];
    let inputClaims: JE_technicalProfileClaimRef[] = [];
    let outputClaims: JE_technicalProfileClaimRef[] = [];
    let prepWithClaimsResolving = false;
    defaultStringClaims.forEach((inpd) => {
      xformIds.push(
        createStrCopyFormatClaimXform(
          parsingCtx,
          inpd.claimId!,
          getOrCreateStringHandlingBufferClaim(parsingCtx, inpd.claimId!),
        ),
      );
      xformIds.push(
        createFQClaimXform(parsingCtx.claimTransformStore, {
          id: `${node.sanitizedDisplayName}_InputDefaultValueHandler`,
          method: 'SetClaimsIfStringsMatch',
          inputClaims: [
            {
              claimId: getOrCreateStringHandlingBufferClaim(parsingCtx, inpd.claimId!),
              xformClaimType: 'claimToMatch',
            },
          ],
          inputParameters: [
            { id: 'matchTo', dataType: 'string', value: '' },
            { id: 'stringComparison', dataType: 'string', value: 'ordinalIgnoreCase' },
            { id: 'outputClaimIfMatched', dataType: 'string', value: inpd.defaultValue! },
          ],
          outputClaims: [
            { claimId: inpd.claimId!, xformClaimType: 'outputClaim' },
            {
              claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.strCmpBoolBuf.id),
              xformClaimType: 'stringCompareResultClaim',
            },
          ],
        }).id,
      );
      inputClaims.push({
        claimId: inpd.claimId,
      });
      outputClaims.push({
        claimId: inpd.claimId,
      });
    });
    resolvers.forEach((spr) => {
      if (spr.defaultValue && Object.keys(constants.sessionContexts.specials).includes(spr.defaultValue)) {
        xformIds.push(getOrCreateSSCTransform(parsingCtx, spr.defaultValue!, spr.claimId));
        outputClaims.push({
          claimId: spr.claimId,
        });
      } else {
        prepWithClaimsResolving = true;
        outputClaims.push({
          claimId: spr.claimId,
          defaultValue: spr.defaultValue,
          alwaysUseDefaultValue: true,
        });
      }
    });
    let prepMetadata: JE_FQMetadataItemSpec[] = [];
    if (prepWithClaimsResolving) {
      prepMetadata.push({
        key: 'IncludeClaimResolvingInClaimsHandling',
        value: 'true',
      });
    }
    let dfPrepTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `${node.sanitizedDisplayName}_InputDefaultHandlerProfile`,
        displayName: 'Token Issuer Default Value Handler',
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        metadata: prepMetadata,
        outputClaims: outputClaims,
        outputClaimXformIds: xformIds,
        useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id, // Use the NOOP session handler because we can't share the OAuth one and we don't want to unexpectedly skip this one
      },
      'Token Issuer Default Handling',
    );
    addNewFQClaimsExchangeOrchestrationStep(
      parsingCtx,
      node,
      nodes,
      journeyId,
      dfPrepTP.id,
      `${node.sanitizedDisplayName}_InputDefaultHandlerExchange`,
      branchVarMap,
      preconditions?.slice(),
    );
  } else if (node.isLink) {
    // If we're a signin link node but didn't have a default claims exchange to put in as the landing-point for the claims provider selection, we need to make a placeholder for it.
    let linkPrepTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `${node.sanitizedDisplayName}_InputCEXHandlerProfile`,
        displayName: node.displayName,
        protocol: constants.customPolicySchema.protocols.claimsTransformation,
        outputClaims: [{ claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.dummyOutputClaim.id) }],
        useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id,
      },
      'Token Issuer Preparation',
    );
    addNewFQClaimsExchangeOrchestrationStep(
      parsingCtx,
      node,
      nodes,
      journeyId,
      linkPrepTP.id,
      `${node.sanitizedDisplayName}_InputCEXHandlerExchange`,
      branchVarMap,
      preconditions?.slice(),
    );
  }
  addFQOrchestrationStepToJourney(
    parsingCtx.userJourneyStore,
    {
      order: 1,
      type: 'SendClaims',
      cpimIssuerTechnicalProfileReferenceId: getOrCreateTokenIssuerTechnicalProfile(
        parsingCtx,
        nodeData.tokenIssuerType,
        nodeData.issuerUri,
      ),
      preconditions: preconditions,
    },
    journeyId,
  );
  let userJourney = parsingCtx.userJourneyStore.userJourneys[journeyId];
  if (!userJourney.relyingParties) {
    userJourney.relyingParties = [];
  }
  let userJourneyBehaviors: JE_FQUserJourneyBehaviorsSpec = {
    singleSignOn: { scope: nodeData.ssoScope },
    sessionExpiryType: nodeData.ssoExpiryType,
    sessionExpiryInSeconds: nodeData.ssoExpiryTime,
  };
  if (parsingCtx.buildSettings.xmlGenerationSettings.enableJourneyInsights) {
    // Enable appinsights in the generated code.
    userJourneyBehaviors.journeyInsights = {
      telemetryEngine: 'ApplicationInsights',
      instrumentationKey: extractSettingFieldValue('applicationInsightsInstrumentationKey', parsingCtx.buildSettings),
      developerMode: true,
      clientEnabled: extractSettingFieldValue('applicationInsightsClientEnabled', parsingCtx.buildSettings),
      serverEnabled: true,
      telemetryVersion: '1.0.0',
    };
  }
  if (userJourney.requiresJavascript) {
    userJourneyBehaviors.scriptExecution = 'Allow';
  }
  let outputClaims: JE_technicalProfileClaimRef[] = [];
  nodeData.claims.forEach((clm) => {
    if (clm.defaultValueSource === 'resolver') {
      outputClaims.push({
        claimId: clm.claimId,
        partnerClaimType: clm.partnerClaimType,
      });
    } else {
      outputClaims.push({
        claimId: clm.claimId,
        defaultValue: clm.defaultValue,
        partnerClaimType: clm.partnerClaimType,
      });
    }
  });
  if (settings.enablePolicyWideInstrumentation) {
    outputClaims.push({
      claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.CorrelationId.id),
      defaultValue: '{Context:CorrelationId}',
      alwaysUseDefaultValue: true,
    });
  }
  userJourney.relyingParties.push({
    policyName: userJourney.policyName!,
    defaultUserJourney: journeyId,
    userJourneyBehaviors: userJourneyBehaviors,
    endpoints:
      nodeData.endpoints && nodeData.tokenIssuerType === constants.customPolicySchema.tokenIssuerTypes.oidc.type
        ? nodeData.endpoints.map((endp) => {
          return { id: endp.id, userJourneyReferenceId: endp.journeyId };
        })
        : undefined,
    technicalProfile: {
      id: getAvailableTPId(parsingCtx.technicalProfileStore, 'PolicyProfile'),
      displayName: 'Policy Profile',
      protocol:
        constants.customPolicySchema.protocols[
        constants.customPolicySchema.tokenIssuerTypes[
          nodeData.tokenIssuerType as keyof typeof constants.customPolicySchema.tokenIssuerTypes
        ].protocol as keyof typeof constants.customPolicySchema.protocols
        ],
      outputClaims: outputClaims,
      subjectNamingInfo:
        nodeData.tokenIssuerType === constants.customPolicySchema.tokenIssuerTypes.saml.type
          ? { claimType: 'sub', excludeAsClaim: true }
          : { claimType: 'sub' },
    },
  });
};

const collectAdvanceNeededClaimsUserInputNode = (node: JsonFlowchartNode, parsingCtx: JE_ParsingContext) => {
  let nodeData = node.data as JE_UserInputNodeData;
  let advanceClaims: Set<string> = new Set();
  nodeData.inputFields.forEach((inputField: JE_UserInput_InputField) => {
    if (inputField.kind === 'data') {
      if (
        inputField.prefilled === 'claim' &&
        (inputField.prefill_source !== inputField.claimId ||
          (parsingCtx.claimStore.claims[inputField.claimId].userInputType !== 'Readonly' && inputField.readonly)) &&
        !claimUsesUserIdentitiesAPI(parsingCtx, inputField.prefill_source)
      ) {
        // Claims that will be the input to an input transformation need to be defined before the user input node.
        advanceClaims.add(inputField.prefill_source);
      }
    }
  });
  if (
    nodeData.emailValidation &&
    nodeData.emailValidation.readonly &&
    parsingCtx.claimStore.claims[nodeData.emailValidation.emailClaimId].userInputType !== 'Readonly'
  ) {
    advanceClaims.add(nodeData.emailValidation.emailClaimId);
  }
  return advanceClaims;
};

const getClaimTypeDefault = (claimId: string, parsingCtx: JE_ParsingContext) => {
  let dataType = parsingCtx.claimStore.claims[claimId].dataType;
  if (!constants.defaultClaimValues.hasOwnProperty(dataType) && !constants.noDefaultClaimTypes.includes(dataType)) {
    throw `Unsupported claim data type when fetching default value: ${dataType}`;
  }
  return constants.defaultClaimValues[dataType as keyof typeof constants.defaultClaimValues];
};

const collectAdvanceNeededClaimsRestNode: (
  node: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  parsingCtx: JE_ParsingContext,
) => Set<string> = (
  node: JsonFlowchartNode,
  nodes: { [index: string]: JsonFlowchartNode },
  parsingCtx: JE_ParsingContext,
  ) => {
    // REST nodes will place string values with optional default values into input claim Xforms, so they must be initialized in advance.
    let advanceNeededClaims: Set<string> = new Set();
    let nodeData = node.data as JE_RESTNodeData;
    nodeData.inputParameters.forEach((inp) => {
      if (
        inp.sourceType === 'claim' &&
        inp.defaultValue &&
        !inp.alwaysUseDefaultValue &&
        inp.sourceValue &&
        parsingCtx.claimStore.claims[inp.sourceValue].dataType === 'string'
      ) {
        advanceNeededClaims.add(inp.sourceValue);
      }
    });
    return advanceNeededClaims;
  };

const collectAdvanceNeededClaimsAADWriteNode: (node: JsonFlowchartNode) => Set<string> = (node: JsonFlowchartNode) => {
  let nodeData = node.data as JE_AADWriteNodeData;
  let advanceNeededClaims: Set<string> = new Set();
  nodeData.claimAttributeMap.forEach((cam) => {
    if (cam.defaultValue && !cam.alwaysUseDefaultValue && !cam.claimResolver) {
      advanceNeededClaims.add(cam.claimId);
    }
  });
  return advanceNeededClaims;
};

const collectAdvanceNeededClaimsMFANode: (node: JsonFlowchartNode) => Set<string> = (node: JsonFlowchartNode) => {
  let nodeData = node.data as JE_MFANodeData;
  let advanceNeededClaims: Set<string> = new Set();
  if (nodeData.numberEntryMode !== 'alwaysNew') {
    advanceNeededClaims.add(nodeData.phoneNumberInputClaimId);
  }
  advanceNeededClaims.add(nodeData.idClaimId);
  return advanceNeededClaims;
};

const collectAdvanceNeededClaimsWebAuthnRegistration: (node: JsonFlowchartNode) => Set<string> = (
  node: JsonFlowchartNode,
) => {
  let nodeData = node.data as JE_WebAuthnRegistrationNodeData;
  let advanceNeededClaims: Set<string> = new Set();
  advanceNeededClaims.add(nodeData.idClaim);
  advanceNeededClaims.add(nodeData.displayNameClaim);
  advanceNeededClaims.add(nodeData.nameClaim);
  return advanceNeededClaims;
};

export interface FQSchemaData {
  node: JsonFlowchartNode;
  journeyId: string;
  parsingCtx: JE_ParsingContext;
  nodes: { [nodeId: string]: JsonFlowchartNode };
  branchVarMap: BranchVarMap;
  subflowTopologicalOrders: { [index: string]: string[] };
  subflowBranchVarMaps: { [index: string]: BranchVarMap };
  preconditions?: JE_FQPreconditionSpec[];
};

const nodeFQSchemaGenerators: { [nodeType: string]: (data: FQSchemaData) => void } = {}

export const registerNodeFQSchema = (nodeType: string, generateFQSchema: (data: FQSchemaData) => void) => {
  nodeFQSchemaGenerators[nodeType] = generateFQSchema;
}

export const generateNodeFQSchema = (
  node: JsonFlowchartNode,
  journeyId: string,
  parsingCtx: JE_ParsingContext,
  nodes: { [nodeId: string]: JsonFlowchartNode },
  branchVarMap: BranchVarMap,
  subflowTopologicalOrders: { [index: string]: string[] },
  subflowBranchVarMaps: { [index: string]: BranchVarMap },
  subflow?: JE_SubflowInfo,
) => {
  if (!(node.isLink && node.linkType === 'localAccount')) {
    generateBranchJoinOrchestration(node, parsingCtx, journeyId, branchVarMap, subflow);
    let preconditions = generatePreconditions(node, branchVarMap, Boolean(subflow));
    let sessionHandlingPrecondition = generateFlagSessionHandlingForNode(
      parsingCtx,
      node,
      nodes,
      journeyId,
      branchVarMap,
      preconditions
    );
    if (sessionHandlingPrecondition) {
      preconditions.push(sessionHandlingPrecondition);
    }
    switch (node.kind) {
      case constants.componentTypes.signIn:
        if (subflow) {
          throw 'Sign-in node cannot be used inside a submit action flow';
        }
        generateSignInNodeFQSchema(
          node,
          journeyId,
          parsingCtx,
          nodes,
          branchVarMap,
          subflowTopologicalOrders,
          subflowBranchVarMaps,
          preconditions,
        );
        break;
      case constants.componentTypes.aadRead:
        generateAADReadFQSchema(node, journeyId, parsingCtx, nodes, branchVarMap, preconditions, subflow);
        break;
      case constants.componentTypes.aadWrite:
        generateAADWriteFQSchema(node, journeyId, parsingCtx, nodes, branchVarMap, preconditions, subflow);
        break;
      case constants.componentTypes.setClaims:
        generateSetClaimsNodeFQSchema(node, journeyId, parsingCtx, nodes, branchVarMap, preconditions, subflow);
        break;
      case constants.componentTypes.rest:
        generateRestAPINodeFQSchema(node, journeyId, parsingCtx, nodes, branchVarMap, preconditions, subflow);
        break;
      case constants.componentTypes.userInput:
        if (subflow) {
          throw 'User input node cannot be used inside a submit action flow';
        }
        generateUserInputNodeFQSchema(
          node,
          journeyId,
          parsingCtx,
          nodes,
          branchVarMap,
          subflowTopologicalOrders,
          subflowBranchVarMaps,
          preconditions,
        );
        break;
      case constants.componentTypes.appInsights:
        generateAppInsightsNodeFQSchema(node, journeyId, parsingCtx, nodes, branchVarMap, preconditions);
        break;
      case constants.componentTypes.conditional:
        generateConditionalNodeFQSchema(node, journeyId, parsingCtx, nodes, branchVarMap, preconditions, subflow);
        break;
      case constants.componentTypes.google:
        generateGoogleNodeFQSchema(node, journeyId, parsingCtx, nodes, branchVarMap, preconditions);
        break;
      case constants.componentTypes.usernamePasswordValidation:
        if (!subflow) {
          throw 'Username Password Validation node can only be used inside a submit action flow';
        }
        generateUsernamePasswordValidationFQSchema(
          node,
          nodes,
          journeyId,
          parsingCtx,
          subflow,
          branchVarMap,
          preconditions,
        );
        break;
      case constants.componentTypes.mfa:
        if (subflow) {
          throw 'MFA node cannot be used inside a submit action flow';
        }
        generateMFANodeFQSchema(node, journeyId, parsingCtx, nodes, branchVarMap, preconditions);
        break;
      case constants.componentTypes.webAuthnRegistration:
        if (subflow) {
          throw 'WebAuthn Registration node cannot be used inside a submit action flow';
        }
        generateWebAuthnRegistrationNodeFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions);
        break;
      case constants.componentTypes.webAuthnAuthentication:
        if (subflow) {
          throw 'WebAuthn Authentication node cannot be used inside a submit action flow';
        }
        generateWebAuthnAuthenticationNodeFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions);
        break;
      case constants.componentTypes.tokenIssuer:
        if (subflow) {
          throw 'Token Issuer node cannot be used inside a submit action flow';
        }
        generateTokenIssuerNodeFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions);
        break;
      case constants.componentTypes.webAuthnCredentialExists:
        if (subflow) {
          throw 'WebAuthn Credential Exists node cannot be used inside a submit action flow';
        }
        generateWebAuthnCredentialExistsNodeFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions);
        break;
      case constants.componentTypes.webAuthnAvailability:
        if (subflow) {
          throw 'WebAuthn Availability node cannot be used inside a submit action flow';
        }
        generateWebAuthnAvailabilityNodeFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions);
        break;
      case constants.componentTypes.validationError:
        if (!subflow) {
          throw 'Validation Error node can only be used inside a submit action flow';
        }
        generateValidationErrorNodeFQSchema(
          node,
          nodes,
          journeyId,
          parsingCtx,
          branchVarMap,
          preconditions,
          subflow
        );
        break;
      case constants.componentTypes.conditionalAccessEvaluation:
        if (subflow) {
          throw 'Conditional access node cannot be used inside a submit action flow';
        }
        generateConditionalAccessEvaluationNodeFQSchema(
          node,
          nodes,
          journeyId,
          parsingCtx,
          branchVarMap,
          preconditions,
        );
        break;
      case constants.componentTypes.conditionalAccessRemediation:
        if (subflow) {
          throw 'Conditional access node cannot be used inside a submit action flow';
        }
        generateConditionalAccessRemediationNodeFQSchema(
          node,
          nodes,
          journeyId,
          parsingCtx,
          branchVarMap,
          preconditions,
        );
        break;
      case constants.componentTypes.errorPage:
        if (subflow) {
          throw 'Error page node cannot be used inside a submit action flow';
        }
        generateErrorPageNodeFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions);
        break;
      case constants.componentTypes.authorizeToken:
        if (subflow || parsingCtx.userJourneyStore.userJourneys[journeyId].type !== 'endpoint') {
          throw 'AuthorizeToken node can only be used inside a UserInfo endpoint';
        }
        generateAuthorizeTokenFQSchema(node, nodes, journeyId, parsingCtx, preconditions);
        break;
      case constants.componentTypes.userInfoIssuer:
        if (subflow || parsingCtx.userJourneyStore.userJourneys[journeyId].type !== 'endpoint') {
          throw 'UserInfo Issuer node can only be used inside a UserInfo endpoint';
        }
        generateUserInfoIssuerFQSchema(node, nodes, journeyId, parsingCtx, preconditions);
        break;
      case constants.componentTypes.sendEmailOTP:
        if (!subflow || subflow.flowType !== 'emailVerificationSendAction') {
          throw 'SendEmailOTP node can only be used inside a custom email verification send action';
        }
        generateSendEmailOTPFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions, subflow);
        break;
      case constants.componentTypes.sessionExists:
        generateSessionExistsFQSChema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions, subflow);
        break;
      case constants.componentTypes.policyInstrumentation:
        generatePolicyInstrumentationFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions, subflow);
        break;
      case constants.componentTypes.oidcIdP:
        if (subflow) {
          throw 'OIDC IdP node cannot be used inside a subflow'
        }
        generateOIDCIdPAuthenticationFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions);
        break;
      case constants.componentTypes.samlIdP:
        if (subflow) {
          throw 'SAML IdP node cannot be used inside a subflow'
        }
        generateSAMLIdPAuthenticationFQSchema(node, nodes, journeyId, parsingCtx, branchVarMap, preconditions);
        break;
      default:
        if (Object.keys(nodeFQSchemaGenerators).includes(node.kind)) {
          nodeFQSchemaGenerators[node.kind]({ node, nodes, journeyId, parsingCtx, branchVarMap, preconditions } as FQSchemaData);
        } else {
          console.log(`Cannot find node of type ${node.kind}`);
        }
        break;
    }
  }
};

const generateBranchVariableInitializationFQSchema = (journeyId: string, parsingCtx: JE_ParsingContext) => {
  let bvInitTP = createFQTechnicalProfile(
    parsingCtx.technicalProfileStore,
    {
      id: `BranchVariableInitializer`,
      displayName: 'Branch Variable Initialization',
      protocol: constants.customPolicySchema.protocols.claimsTransformation,
      outputClaims: parsingCtx.userJourneyStore.userJourneys[journeyId].branchVars.map((bvId: string) => {
        return { claimId: bvId, defaultValue: 'false', alwaysUseDefaultValue: true };
      }),
      useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id,
    },
    'Conditional Handling',
  );
  if (
    Object.keys(parsingCtx.claimStore.claims).some(
      (claimId: string) => parsingCtx.claimStore.claims[claimId].dataType === 'boolean',
    )
  ) {
    // If we use boolean claims, create a fixed boolean true constant to make it possible to perform boolean copying.
    let booleanTrueConstant = getOrCreateTrueBooleanConstant(parsingCtx);
    bvInitTP.outputClaims!.push({
      claimId: booleanTrueConstant,
      defaultValue: 'true',
      alwaysUseDefaultValue: true,
    });
  }
  addFQOrchestrationStepToJourney(
    parsingCtx.userJourneyStore,
    {
      order: 1,
      type: 'ClaimsExchange',
      claimsExchanges: [{ id: 'InitialClaimsExchange', technicalProfileReferenceId: bvInitTP.id }],
    },
    journeyId,
  );
};

interface RESTBearerTokenKey {
  clientIdContainer: string,
  clientSecretContainer: string,
  issuerTenant: string,
  applicationIdUri: string
}

const extractSubflowRESTAADBearerTokenKeys = (
  nodes: { [index: string]: JsonFlowchartNode },
  subflowTopologicalOrders: { [index: string]: string[] },
  keys: RESTBearerTokenKey[],
  formSubmitActionId?: string
) => {
  if (formSubmitActionId) {
    let subflowKeys = collectRESTAADBearerTokenKeys(nodes, subflowTopologicalOrders[formSubmitActionId], {});
    subflowKeys.forEach((sk) => {
      if (!keys.some((k) => { return (k.clientIdContainer === sk.clientIdContainer) && (k.clientSecretContainer === sk.clientSecretContainer); })) {
        keys.push(sk);
      }
    });
  }
}

const collectRESTAADBearerTokenKeys = (
  nodes: { [index: string]: JsonFlowchartNode },
  topologicalOrder: string[],
  subflowTopologicalOrders: { [index: string]: string[] }
) => {
  let keys: RESTBearerTokenKey[] = [];
  topologicalOrder.forEach((nodeId: string) => {
    if (nodes[nodeId].kind === constants.componentTypes.rest) {
      let data = nodes[nodeId].data as JE_RESTNodeData
      if ((data.authType === constants.restAuthTypes.aadBearer.id) &&
        (!keys.some((k) => { return (k.clientIdContainer === data.clientIdContainerName) && (k.clientSecretContainer === data.clientSecretContainerName) }))) {
        keys.push({
          clientIdContainer: data.clientIdContainerName!,
          clientSecretContainer: data.clientSecretContainerName!,
          issuerTenant: data.issuerTenant!,
          applicationIdUri: data.applicationIdUri!,
        });
      }
    } else if (nodes[nodeId].kind === constants.componentTypes.userInput) {
      let data = nodes[nodeId].data as JE_UserInputNodeData
      extractSubflowRESTAADBearerTokenKeys(nodes, subflowTopologicalOrders, keys, data.formSubmitAction);
    } else if (nodes[nodeId].kind === constants.componentTypes.signIn) {
      let data = nodes[nodeId].data as JE_SignInNodeData
      extractSubflowRESTAADBearerTokenKeys(nodes, subflowTopologicalOrders, keys, data.formSubmitAction);
    }
  });
  return keys;
}

const checkForAndGenerateRESTAADBearerTokenFetchFQSchemae = (
  parsingCtx: JE_ParsingContext,
  journeyId: string,
  nodes: { [index: string]: JsonFlowchartNode },
  topologicalOrder: string[],
  subflowTopologicalOrders: { [index: string]: string[] }
) => {
  let idSecretPairs = collectRESTAADBearerTokenKeys(nodes, topologicalOrder, subflowTopologicalOrders);
  idSecretPairs.forEach((bearerTokenKeys, idx) => {
    let accessTokenTP = createFQTechnicalProfile(
      parsingCtx.technicalProfileStore,
      {
        id: `GetAADAccessToken_${idx}`,
        displayName: `GetAADAccessToken_${idx}`,
        protocol: constants.customPolicySchema.protocols.REST,
        metadata: [
          { key: 'ServiceUrl', value: `https://login.microsoftonline.com/${bearerTokenKeys.issuerTenant}/oauth2/v2.0/token` },
          { key: 'AuthenticationType', value: 'Basic' },
          { key: 'SendClaimsIn', value: 'Form' }
        ],
        cryptographicKeys: [
          { id: 'BasicAuthenticationUsername', storageReferenceId: bearerTokenKeys.clientIdContainer },
          { id: 'BasicAuthenticationPassword', storageReferenceId: bearerTokenKeys.clientSecretContainer }
        ],
        inputClaims: [
          { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.grant_type.id), defaultValue: 'client_credentials', alwaysUseDefaultValue: true, partnerClaimType: 'grant_type' },
          { claimId: getOrCreateSpecialClaim(parsingCtx, constants.specialClaims.scope.id), defaultValue: `${bearerTokenKeys.applicationIdUri}/.default`, alwaysUseDefaultValue: true, partnerClaimType: 'scope' }
        ],
        outputClaims: [
          { claimId: getOrCreateAADAccessTokenClaim(parsingCtx, bearerTokenKeys.clientIdContainer, bearerTokenKeys.clientSecretContainer, idx), partnerClaimType: 'access_token' }
        ],
        useTechnicalProfileForSessionManagement: getOrCreateNoopSessionManagementTP(parsingCtx).id
      },
      constants.claimsProviderNames.restAADTokens
    );
    addFQOrchestrationStepToJourney(
      parsingCtx.userJourneyStore,
      {
        order: 2,
        type: 'ClaimsExchange',
        claimsExchanges: [{ id: `AADAccessTokenFetch_${idx}`, technicalProfileReferenceId: accessTokenTP.id }]
      },
      journeyId
    );
  });
}

export const parseConditionalDAG = (
  parsingCtx: JE_ParsingContext,
  journeyId: string,
  nodes: { [index: string]: JsonFlowchartNode },
  topologicalOrder: string[],
  branchVarMap: BranchVarMap,
  subflowTopologicalOrders: { [index: string]: string[] },
  subflowBranchVarMaps: { [index: string]: BranchVarMap },
  submitActionFlow?: JE_SubflowInfo,
) => {
  if (!submitActionFlow) {
    if (parsingCtx.userJourneyStore.userJourneys[journeyId].branchVars.length > 0 ||
      Object.keys(parsingCtx.claimStore.claims).some(
        (claimId: string) => parsingCtx.claimStore.claims[claimId].dataType === 'boolean',
      )) {
      generateBranchVariableInitializationFQSchema(journeyId, parsingCtx);
    }
    checkForAndGenerateRESTAADBearerTokenFetchFQSchemae(parsingCtx, journeyId, nodes, topologicalOrder, subflowTopologicalOrders);
  }

  topologicalOrder.forEach((nodeId: string) => {
    let node = nodes[nodeId];
    generateNodeFQSchema(
      node,
      journeyId,
      parsingCtx,
      nodes,
      branchVarMap,
      subflowTopologicalOrders,
      subflowBranchVarMaps,
      submitActionFlow,
    );
  });
  // A SendClaims step is a hard requirement for a UJ
  if (!submitActionFlow && parsingCtx.userJourneyStore.userJourneys[journeyId].type === 'userJourney') {
    if (nodes[topologicalOrder[topologicalOrder.length - 1]].kind !== constants.componentTypes.tokenIssuer) {
      throw 'Invalid user journey: Journey does not end with a token issuer node';
    }
  }
};

// Assign defaults to all input and output claims that do not already have one, to prevent server errors due to undefined claims.
export const setClaimAutoDefaults = (parsingCtx: JE_ParsingContext) => {
  Object.keys(parsingCtx.technicalProfileStore.claimsProviders).forEach((claimsProviderId: string) => {
    Object.keys(parsingCtx.technicalProfileStore.claimsProviders[claimsProviderId].technicalProfiles).forEach(
      (tpId: string) => {
        let tp = parsingCtx.technicalProfileStore.claimsProviders[claimsProviderId].technicalProfiles[tpId];
        if (claimsProviderId !== constants.claimsProviderNames.policyInstrumentation) {
          if (claimsProviderId !== constants.claimsProviderNames.mfa) {
            // Don't provide default values on input claims to the PhoneFactor protocol handler
            if (tp.inputClaims !== undefined) {
              tp.inputClaims.forEach((claimRef: JE_technicalProfileClaimRef) => {
                if (claimRef.defaultValue === undefined
                  && claimRef.claimId !== undefined
                  && (claimRef.claimId !== getSpecialClaimEffectiveId(parsingCtx, constants.specialClaims.aadBearerTokenForRestAuth.id))
                  && (claimRef.claimId !== getSpecialClaimEffectiveId(parsingCtx, constants.specialClaims.totpSecretKey.id))
                  && (!jsonXMLConstants.noDefaultClaimTypes.includes(parsingCtx.claimStore.claims[claimRef.claimId].dataType))) {
                  claimRef.defaultValue = getClaimTypeDefault(claimRef.claimId, parsingCtx);
                }
              });
            }
          }
          if (tp.outputClaims !== undefined) {
            tp.outputClaims.forEach((claimRef: JE_technicalProfileClaimRef) => {
              if (claimRef.defaultValue === undefined && claimRef.claimId !== undefined && (claimRef.claimId !== getSpecialClaimEffectiveId(parsingCtx, constants.specialClaims.aadBearerTokenForRestAuth.id)) && (!jsonXMLConstants.noDefaultClaimTypes.includes(parsingCtx.claimStore.claims[claimRef.claimId].dataType))) {
                if (!([constants.claimsProviderNames.mfa, constants.claimsProviderNames.webauthnObjectIdCheck].includes(claimsProviderId))) {
                  // Don't provide default values on the boolean buffer for newPhoneNumberEntered in MFA/Phone Factor output claims.
                  // Also don't provide default claims on the object ID check in webAuthn auth.
                  claimRef.defaultValue = getClaimTypeDefault(claimRef.claimId, parsingCtx);
                }
              }
            });
          }
        }
      },
    );
  });
};

export const generateRelyingPartiesXML = (
  parsingCtx: JE_ParsingContext,
  tenantId: string,
  basePolicyId: string,
) => {
  let relyingPartyFiles: RelyingPartyReference[] = [];
  parsingCtx.userJourneyStore.journeyIds.forEach((journeyId: string) => {
    let userJourney = parsingCtx.userJourneyStore.userJourneys[journeyId];
    if (userJourney.relyingParties) {
      userJourney.relyingParties.forEach((relyingParty: JE_FQRelyingPartySpec) => {
        let rpName = relyingParty.policyName;
        if (parsingCtx.buildSettings.xmlGenerationSettings.addRandomPolicyIdTail) {
          rpName += Math.floor(Math.random() * 100000).toString();
        }
        let samlMetadataUrls: { [index: string]: string } = {};
        if (userJourney.samlRelyingPartyMetadataUrls) {
          let srpMetadataUrls = userJourney.samlRelyingPartyMetadataUrls;
          Object.keys(srpMetadataUrls).forEach((tpId: string) => {
            samlMetadataUrls[parsingCtx.technicalProfileStore.claimsProviders[parsingCtx.technicalProfileStore.providerNameIndex[tpId]].technicalProfiles[tpId].id] =
              `${srpMetadataUrls[tpId].urlPrefix}${rpName}${srpMetadataUrls[tpId].urlPostfix}`;
          });
        }
        relyingPartyFiles.push({
          xml: generateRelyingPartyXML(relyingParty, rpName, tenantId, basePolicyId, parsingCtx.buildSettings.xmlGenerationSettings.enableJourneyInsights),
          policyName: rpName,
          isSamlPolicy:
            relyingParty.technicalProfile.protocol?.name === constants.customPolicySchema.protocols.saml2.name,
          samlIdPMetadataUrls: Object.keys(samlMetadataUrls).length === 0 ? undefined : samlMetadataUrls
        });
      });
    }
  });
  return relyingPartyFiles;
};
